import {useEffect, useState} from 'react'
import {useLocation, useNavigate, useParams} from "react-router-dom";



import grapesjs from 'grapesjs'

import 'grapesjs/dist/grapes.min.js'

import 'grapesjs-preset-webpage/dist/grapesjs-preset-webpage.min.js'
import server from "../../../apis/server.js"
// import toast from 'react-toastify'

import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/common/loader/loader.js";

import customCodePlugin from "../../../utils/custom-code-grapejs/index.ts"
import sendpadForm from "../../../utils/sendpadForm/index.ts"
import gjsTabs from "../../../utils/grapeJsTabs/index"
import gjsTooltip from "grapesjs-tooltip"
import customForm from "../../../utils/grapeJsCustomForm/index.ts"
import isEqual from 'lodash/isEqual';
import gjsImageEditor from '../../../utils/grapeJsImageEditor/index.ts'
import {BsCheck2} from "react-icons/bs";
import Checked from '../../../images/checked.png'; // Replace with the actual path to your image file

import {Dropdown, DropdownItem, DropdownMenu, FormGroup, Input, Label} from 'reactstrap';
import scripts from 'grapesjs-script-editor'
import gjsp from 'grapesjs-preset-webpage'

import gjsTyped from 'grapesjs-typed';
import gjsModal from '../../../utils/grapejsModal/index.ts';

// import gjsAccordian from '../../../utils/grapeJsAccordian/index';
import gjsAccordian from 'grapesjs-accordion';

import isLoading from '../../../store/LoadingState.js';


function Editor({direction, ...args}) {

    useEffect(() => {
        // Conditionally import SCSS file based on your condition
        const importScss = async () => {
          if (true) { // Replace with your actual condition
            const scssModule = await import("../editor_v0/grapejs_v0.scss");
            return scssModule.default;
          } else {
            // const scssModule = await import("../path/to/grapejs2.scss");
            // return scssModule.default;
          }
        };
      
        let linkTag;
      
        importScss().then((scssHref) => {
          // Create a new <link> tag
          linkTag = document.createElement("link");
          linkTag.rel = "stylesheet";
          linkTag.href = scssHref;
          document.head.appendChild(linkTag);
        });
      
        // Cleanup function to unload CSS when the component unmounts
        return () => {
          if (linkTag) {
            document.head.removeChild(linkTag);
          }
        };
      }, []);
      
    
    const navigate = useNavigate();
    const accountsString = localStorage.getItem('accounts')
    console.log(accountsString)
    const accounts = accountsString ? JSON.parse(accountsString) : ''
    console.log('accounts', accounts)
    // alert(accounts.public_url)
    const {public_url} = accounts
    const {state} = useLocation();


    let {editorpage} = useParams();
    if(editorpage){
        localStorage.setItem("pageId",editorpage);
    }
    const updatePage = `${process.env.REACT_APP_API_URL}/page/update`;
    const getPage = `${process.env.REACT_APP_API_URL}/page/edit/${editorpage}`
    const uploadImage = `${process.env.REACT_APP_API_URL}/upload/assets/${editorpage}`

    const [draft, setDraft] = useState();
    const [edit, setEdit] = useState(false)
    const [status, setStatus] = useState('')
    // const [dropdownOpen, setDropdownOpen] = useState(true);
    const toggle = () => setPublishOpen((prevState) => !prevState);
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)

    const [publishOpen, setPublishOpen] = useState(false)
    const [html, setHtml] = useState(null)

    const [seoPgeTitle, setseoPgeTitle] = useState('');
    const [seoPgeKeyword, setseoPgeKeyword] = useState('');
    const [seoPgeDescription, setseoPgeDescription] = useState('');
    const [pageDetail, setPageDetail] = useState('');
    const [domainId, setDomainId] = useState();
    const [updateUi, setUpdateUi] = useState(false);
    const [updateGrapeJs, setUpdateGrapeJs] = useState(false);
    const [editor, setEditor] = useState(null);
    const [draftData, setDraftData] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const [googleCoversionId, setGoogleCoversionId] = useState('');

    const [isPublished, setIsPublished] = useState(
        localStorage.getItem('isPublished') === 'true'
    );

    const [publishedUrl, setPublishedUrl] = useState(
        localStorage.getItem('publishedUrl')
    );


    let data;

    // const myfunction=()=>{
    //     // console.log("ye chal raha hai bosss");
    //     setLoading(true);
    // }
    const nameAsif = "asif";

    //     function stoperror() {
    //         return true;
    //   };
    //   window.onerror = stoperror;


    useEffect(() => {
        const isEqualWithoutIds = (obj1, obj2) => {
            // Remove the "id" attribute from the body element in both objects
            const removeIdFromBody = (obj) => {
                const newObj = { ...obj };

                const bodyElement = newObj.html.match(/<body.*?>/);
                if (bodyElement) {
                    newObj.html = newObj.html.replace(bodyElement[0], bodyElement[0].replace(/ id="[^"]*"/, ''));
                }
                return newObj;
            };

            const sanitizedObj1 = obj1;
            const sanitizedObj2 = obj2

            console.warn('publish html', sanitizedObj1)
            console.warn('draft html', sanitizedObj2)

            return isEqual(sanitizedObj1, sanitizedObj2);
        };

        //   console.warn('html',html)
        if (html && editor && draftData) {
            //  alert('cc')
            let obj1 = draftData ? JSON.parse(draftData) : ''
            let obj2 = html

            const areEqual = isEqualWithoutIds(obj1, obj2);

            setIsDisabled(areEqual)



            // alert(areEqual)


        }


    }, [html, updateUi, draftLoading, editor, draftData])



    useEffect(() => {
        if (editor) {
            //    const htmlObj = {
            //                                         html: editor.getHtml(),
            //                                         css: editor.getCss()

            //                                     }

            //                                     console.warn('current html',htmlObj)
            //                                      setHtml(htmlObj)

            const publishButton = editor.Panels.getButton('myNewPanel', 'Publish');
            const draftButton = editor.Panels.getButton('myNewPanel', 'Draft');

            // console.warn('draft',publishButton)

            if (publishButton) {
                // Update the button's label dynamically


                if (isDisabled) {
                    setPublishOpen(false)
                }
                publishButton.set('label', `
            <button
            ${isDisabled ? 'disabled="disabled"' : ''}

            type="button" title="Publish Page" class="ccc btn btn-secondary Mydropdowntoogle ${!isDisabled ? 'primary-btn-modal' : ''}">

              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="11" width="11" xmlns="http://www.w3.org/2000/svg">
                <path d="M477.64 38.26a4.75 4.75 0 00-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 00-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0010.55 11.2l87.31-9.63a194.1 194.1 0 001.19 19.7 19.53 19.53 0 005.7 12L170.7 375a19.59 19.59 0 0012 5.7 193.53 193.53 0 0019.59 1.19l-9.58 87.2a9.65 9.65 0 0011.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0042.21-35.64C441 232.05 491.74 99.74 477.64 38.26zM294.07 217.93a48 48 0 1167.86 0 47.95 47.95 0 01-67.86 0z"></path>
                <path d="M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 00-3.65-7.45 60 60 0 00-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.69 59.69 0 00176 403.09c.37-4.18-4.72-6.67-7.6-3.66z"></path>
              </svg>
             
              <span class="px-2 fw-semibold">${draftLoading ? '<i class="fa fa-spinner fa-spin  fa-fw"></i>' : 'Publish'}</span>

              
              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M7 10l5 5 5-5z"></path>
               </svg>
            </button>
          `);
            }


            if (draftButton) {
                // Update the button's label dynamically

                // alert(isDisabled)
                if (isDisabled) {

                    draftButton.set('label', ` 
           
          `);

                }


                if (!isDisabled) {
                    draftButton.set('label', ` 
                  <span
      
                   class="badge badge-primary" style="cursor: default;">
                   
                    <span  class="px-2"> Unpublished Version</span>
                   
                  </span>
                `);

                }

            }

        }


    }, [draftLoading, editor, isDisabled]);


    useEffect(() => {
        if (getPage) {
            getPageDetail()
        }
    }, [])
    const getPageDetail = async () => {
        try {


            const { data } = await server.get(`${getPage}`);
            setLoading(false)

            if (data?.status) {
                // console.warn('kk',data?.data?.draft_body)
                setDraftData(data?.data?.html_body)

                setGoogleCoversionId(data?.data?.script_setting?.google_conversion_id)
                // alert(data?.data?.script_setting?.google_conversion_id)


                setIsLoading(false);

            }
            setIsLoading(false);

        } catch (e) {
            setLoading(false)
            if (e.response?.data?.status === false) {
                if (e.response?.data.errors_array?.[0]) {
                    toast(e.response?.data.errors_array?.[0], 'error')
                }
                else {
                    toast(e.response?.data?.message, 'error')

                }
                //  setError(e.response?.data.errors?.title[0])
            }

        }
    }


    useEffect(() => {
        if (editorpage && draftLoading) {
            alert('cc')
            //   setEditor(null)
            return
        }

        //    alert(state?.is_from_template)
        // setLoading(true)

        if (editorpage && public_url) {
            setLoading(true)


            const customType = (editor) => {
                let activeAlignment = 'left'; // Default active alignment

                const setActiveAlignmentButtons = (alignment) => {
                    const alignButtons = document.querySelectorAll('.align-button');

                    alignButtons.forEach((button) => {
                        const buttonAlignment = button.getAttribute('data-align');

                        if (buttonAlignment === alignment) {
                            button.classList.add('active');
                        } else {
                            button.classList.remove('active');
                        }
                    });
                };

                editor.StyleManager.addType('my-custom-prop', {
                    create({change}) {
                        const el = document.createElement('div');
                        el.innerHTML = `
                            <button class="align-button" data-align="left">Left</button>
                            <button class="align-button" data-align="center">Center</button>
                            <button class="align-button" data-align="right">Right</button>
                        `;

                        const alignButtons = el.querySelectorAll('.align-button');

                        alignButtons.forEach((button) => {
                            const alignment = button.getAttribute('data-align');

                            button.addEventListener('click', () => {
                                alignButtons.forEach((btn) => {
                                    btn.classList.remove('active');
                                });

                                button.classList.add('active');

                                activeAlignment = alignment; // Update active alignment

                                const selectedComponent = editor.getSelected();

                                if (selectedComponent) {
                                    const styles = selectedComponent.getStyle();

                                    styles['margin-left'] = alignment === 'left' ? '0' : 'auto';
                                    styles['margin-right'] = alignment === 'right' ? '0' : 'auto';
                                    styles['text-align'] = 'center';
                                    styles['display'] = 'block';
                                    styles['float'] = alignment === 'center' ? 'none' : alignment;

                                    if (alignment === 'center') {
                                        styles['float'] = 'none';
                                        styles['margin-left'] = 'auto';
                                        styles['margin-right'] = 'auto';
                                    } else {
                                        styles['float'] = alignment;
                                    }

                                    selectedComponent.setStyle(styles);
                                }
                            });

                            // Set the initial active button based on the active alignment
                            const selectedComponent = editor.getSelected();
                            if (!selectedComponent) {
                                if (alignment === 'left') {
                                    button.classList.add('active');
                                }
                            }
                        });

                        return el;
                    },
                    emit({updateStyle}, {event}) {
                        // No need to emit changes for this simplified example
                    },
                    update({el}) {
                        // No need to update the UI for this simplified example
                    },
                    destroy() {
                        // Clean up if needed
                    },
                });

                editor.on('component:selected', ({model}) => {
                    const selectedComponent = editor.getSelected();
                    if (selectedComponent) {
                        const styles = selectedComponent.getStyle();
                        const alignment = styles['float'] || 'left';
                        setActiveAlignmentButtons(alignment);
                    } else {
                        setActiveAlignmentButtons(activeAlignment);
                    }
                });
            };


            function init() {
                const editor = grapesjs.init({

                    allowScripts: 1,

                    container: '#gjs',
                    height: '100vh',
                    fromElement: true,
                    styleManager: {
                        sectors: [
                            {
                                name: 'Dimension',
                                open: false,
                                properties: ['width', 'height', 'max-width', 'min-height', 'margin', 'padding'],
                            }, {
                                name: 'Flex',
                                open: false,
                                properties: [
                                    'flex-direction',
                                    'flex-wrap',
                                    'justify-content',
                                    'align-items',
                                    'align-content',
                                    'order',
                                    'flex-basis',
                                    'flex-grow',
                                    'flex-shrink',
                                    'align-self',
                                ],
                            },
                            {
                                name: 'Alignment',
                                properties: [
                                    {
                                        type: 'my-custom-prop',
                                        property: 'text-align',
                                        default: 'center',
                                        // min: 10,
                                        // max: 70,
                                    },
                                ],
                            },
                        ],
                    },

                    protectedCss: `body{margin:0; } .modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;} a.accordion::before{content: '+';margin-right: 8px;}.accordion-active a.accordion::before {content: '–';}img{max-width:100%;height:auto}.cell {height: auto;vertical-align: top;}.cke_editable p{display: block; margin-block-start: 0em !important; margin-block-end: 0em !important;margin-inline-start: 0em !important;margin-inline-end: 0em !important;}table.grid-item-card tbody tr td {background: none !important;}.list-item tr td {background: none !important;}.form-group{ float:none; flex-direction:column; border:0 solid black; display:flex; } .label{ margin:0 0 15px 0; font-family:Arial, Helvetica, sans-serif; font-size:14px; font-weight:600; } .form{ display:flex; flex-direction:column; padding:50px 50px 50px 50px; border:1px solid #6c7978; margin:10px 10px 10px 10px; background-color:#f5f5f5; } .input{ height:40px; width:auto; margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px; } textarea { margin:0 0 15px 0; border-radius:7px; border:1px solid #9e9e9e; padding:0 10px 0 10px;} .button{ height:42px; border-radius:7px; margin:10px 0 0 0; border:1px solid #7e7e7e; font-family:Arial Black, Gadget, sans-serif; font-size:14px; font-weight:600; color:#ffffff; background-color:#000000; } .form-group:nth-child(3) {display: none;} .form-group:nth-child(4) {display: none;}.form-group:has(> .checkbox) { flex-direction:row;align-items: start; }input.checkbox {margin-left: 25px;}label.checkbox-label {margin-left: 5px;} @media (max-width: 992px){ .form{ padding:20px 20px 20px 20px; } }@media (max-width:768px){.cell{width:100%;}}
                    ${state?.is_from_template == false ? '.modal{z-index:11111; position:relative;} .accordion-content{font-family:inherit; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}.closeModalBtn {cursor: pointer;}.accordion{font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;text-decoration:none;}a.accordion::before{content: \'+\';margin-right: 8px;}.accordion-active a.accordion::before {content: \'–\';}.row{padding:0 !important;}p{padding:0 !important; margin:0 !important;}h1{padding:0 !important; margin:0 !important;}h4{padding:0; margin:0;}@media(max-width:768px){.cell{width:100%;display:contents!important;}}' : ''}`,



                    width: '100%',
                    plugins: [gjsAccordian, gjsImageEditor, gjsp, gjsTabs, gjsTooltip, gjsTyped,gjsModal, customType, sendpadForm, customCodePlugin],
                    pluginsOpts: {


                        gjsp:    {
                            blocks: []

                            // options
                        },

                        gjsTyped:
                            {
                                label: 'Typed2'
                            },


                        customCodePlugin: {
                            placeholderScript: true,
                            blockCustomCode: {label: 'Custom'}
                            // options
                        },
                        // sendpadForm: {
                        //     placeholderScript	:true,
                        //     blockCustomCode:{ label: 'Sendpad Form'}
                        //   // options
                        // }
                    },
                    clearOnRender: true,
                    storageManager: {
                        type: 'remote',
                        autosave: true,
                        stepsBeforeSave: 1,
                        contentTypeJson: true,
                        storeComponents: true,
                        storeStyles: true,
                        storeHtml: true,
                        storeCss: true,
                        options: {

                            remote: {

                                contentTypeJson: true,

                                urlStore: updatePage,
                                // The `remote` storage uses the POST method when stores data

                                fetchOptions: opts => (opts.method === 'POST' ? {method: 'POST'} : {}),

                                onLoad: data => JSON.parse(data?.data?.data?.draft_body)

                            }
                        }
                    },


                    assetManager: {
                        autoAdd: 1,
                        // assets: images,
                        upload: 0,
                        storeOnChange: true,
                        storeAfterUpload: true,

                        // uploadName: 'files',
                        uploadText: 'Drop or click to upload',
                        // upload: '<?php echo $uploadUrl;?>',
                        // addBtnText: '<?php echo $this->translate("Aggiungi immagine");?>',
                        uploadFile: async function (e) {

                            // console.log(e.target)
                            // setUpdate('ccc')

                            setLoading(true)
                            // const {data} = await server.get(`${getPage}`);

                            // console.log(data)
                            var files = e?.dataTransfer ? e?.dataTransfer?.files?.[0] : e?.target?.files?.[0];

                            console.log('eeeeee', e)

                            let fileSizeInBytes = files?.size;
                            let fileSizeInMB = fileSizeInBytes / (1024 * 1024); // Convert bytes to megabytes

                            if (fileSizeInMB > 2) {
                                // File size is greater than 2 MB
                                toast("Please upload a file smaller than 2 MB.")
                                setLoading(false)

                                return
                            }


                            var formData = new FormData();
                            formData.append('file', files)
                            formData.append('page_id', editorpage)

                            try {
                                const {data} = await server.post(`media/upload`,
                                    formData,
                                );
                                setLoading(false)

                                if (data?.status) {
                                    console.log(data)

                                    editor.AssetManager.add(data?.data?.upload_url)


                                    // isLoading(true)
                                    // router.push(`/pages/editor/${data?.data?.page_id}`)
                                }
                                console.log(data)
                                // setProduct(data);
                                // setLoading(false);
                            } catch (e) {
                                setLoading(false)
                                if (e.response?.data?.status === false) {
                                    if (e.response?.data.errors_array?.[0]) {
                                        toast(e.response?.data.errors_array?.[0], 'error')
                                    } else {
                                        toast(e.response?.data?.message, 'error')

                                    }
                                    //  setError(e.response?.data.errors?.title[0])
                                }

                            }


                        }
                    },

                    deviceManager: {
                        devices:
                            [
                                {
                                    id: 'desktop',
                                    name: 'Desktop',
                                    width: '',
                                },
                                {
                                    id: 'tablet',
                                    name: 'Tablet',
                                    width: '768px',
                                    widthMedia: '992px',
                                },
                                {
                                    id: 'mobilePortrait',
                                    name: 'Mobile portrait',
                                    title: 'Mobile portrait',
                                    width: '320px',
                                    widthMedia: '575px',
                                },
                            ]
                    },
                    //  pluginsOpts: {
                    //     'grapesjs-preset-webpage': {
                    //         blocksBasicOpts: {
                    //             blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
                    //             flexGrid: 1,
                    //         },
                    //         blocks: ['link-block', 'quote', 'text-basic'],
                    //     },
                    // },

                })
                customType(editor);


                const script = function () {
                    // alert('Hi');
                    // `this` is bound to the component element
                    // console.log('the element', this);
                };

                //   editor.DomComponents.addType('Text', {
                //     isComponent: el => el.tagName === "IFRAME",
                //     model: {
                //       defaults: {
                //         type: "iframe",
                //         traits: [
                //           {
                //             type: "text",
                //             label: "src",
                //             name: "src"
                //           }
                //         ]
                //       }
                //     }
                //   });

                // editor.on('asset:upload:start', (e) => {
                //        alert('ok')
                // });

                //   editor.Components.addType('foo-button', {
                //     model: {
                //         defaults: {
                //             tagName: "button",
                //             name: "Button",
                //             content: "Button",
                //             script: function() {
                //               this.addEventListener("click", () => {
                //                 alert("Meow");
                //               });
                //             }
                //         }
                //     }
                // })

                editor.on('load', () => {



                    const countdownBlock = editor.BlockManager.get('countdown'); // Use the correct block name
                    const accordionsBlock = editor.BlockManager.get('accordions'); // Use the correct block name

                    if (accordionsBlock) {


                        accordionsBlock.set({
                            label: 'Accordion',
                            attributes: {
                                class: '', // Remove the FontAwesome class
                                // Add any other attributes if needed
                            },
                            category: 'Extra',


                            media: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 100;" xml:space="preserve"><g><polygon points="79.7,43.5 74,37.9 50.2,62.2 25.9,38.4 20.3,44.2 50.4,73.5  "/></g><text x="0" y="115" fill="#000000" font-size="5px" font-weight="bold" font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"></text><text x="0" y="120" fill="#000000" font-size="5px" font-weight="bold" font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"></text></svg>`,
                        });
                    }




                    // Update the label
                    if (countdownBlock) {


                        countdownBlock.set({
                            label: 'Countdown Timer',

                        });
                    }


                });


                ;

                editor.DomComponents.addType('Text', {
                    isComponent: el => el.tagName === "IFRAME",
                    model: {
                        defaults: {
                            type: "iframe",
                            traits: [
                                {
                                    type: "text",
                                    label: "src",
                                    name: "src"
                                }
                            ]
                        }
                    }
                });


                editor.BlockManager.add("Button", {
                    label: 'Button',
                    category: 'Basic',

                    media: `<svg xmlns="http://www.w3.org/2000/svg" width="27.633" height="24.151" viewBox="0 0 27.633 24.151">
    <g id="icon-button" transform="translate(789.271 -46.353)">
      <g id="Group_22571" data-name="Group 22571" transform="translate(-789.271 46.353)">
        <path id="Path_45394" data-name="Path 45394" d="M-764.2,46.353h-22.514a2.562,2.562,0,0,0-2.559,2.562V59.678a2.561,2.561,0,0,0,2.559,2.56h5.845a1.175,1.175,0,0,0,1.174-1.176,1.175,1.175,0,0,0-1.174-1.176h-5.845a.208.208,0,0,1-.207-.209V48.915a.208.208,0,0,1,.207-.209H-764.2a.211.211,0,0,1,.21.209V59.678a.211.211,0,0,1-.21.209h-1.236a1.176,1.176,0,0,0-1.176,1.176,1.176,1.176,0,0,0,1.176,1.176h1.236a2.562,2.562,0,0,0,2.56-2.56V48.915A2.564,2.564,0,0,0-764.2,46.353Z" transform="translate(789.271 -46.353)" fill="#b2b9c3"/>
        <path id="Path_45395" data-name="Path 45395" d="M-778.878,53.79a.493.493,0,0,0-.841.349V64.775l2.232-2.537,2.479,5.472,2.521-1.141-2.42-5.342h3.466Z" transform="translate(792.931 -43.559)" fill="#b2b9c3"/>
        <path id="Path_45396" data-name="Path 45396" d="M-778.217,53.039a.946.946,0,0,0,.664-.271l1.138-1.109a.949.949,0,0,0,.018-1.344.949.949,0,0,0-1.344-.017l-1.138,1.109a.949.949,0,0,0-.018,1.344A.951.951,0,0,0-778.217,53.039Z" transform="translate(793.142 -44.945)" fill="#b2b9c3"/>
        <path id="Path_45397" data-name="Path 45397" d="M-781.624,53.12l-1.331.869a.95.95,0,0,0-.277,1.317.95.95,0,0,0,.8.43.945.945,0,0,0,.519-.155l1.331-.87a.949.949,0,0,0,.275-1.315A.947.947,0,0,0-781.624,53.12Z" transform="translate(791.526 -43.82)" fill="#b2b9c3"/>
        <path id="Path_45398" data-name="Path 45398" d="M-780.837,50.036a.952.952,0,0,0-1.338-.141.951.951,0,0,0-.14,1.337l1.173,1.451a.949.949,0,0,0,.74.354.949.949,0,0,0,.6-.212.951.951,0,0,0,.141-1.337Z" transform="translate(791.855 -45.077)" fill="#b2b9c3"/>
      </g>
    </g>
  </svg>`,
                    content: `<div> <a style="background-color: #dcdce0;border: 1px solid #47525d;padding: 10px 20px;font-size: 16px; text-decoration:none;border-radius: 8px; display: block;width:100px;text-align:center" >
      Button
      </a></div>`

                });



//                 editor.BlockManager.add("Accordion", {
//                     label: "Accordion",
//                     category: "Extra",
//                     media: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 125" style="enable-background:new 0 0 100 100;" xml:space="preserve"><g><polygon points="79.7,43.5 74,37.9 50.2,62.2 25.9,38.4 20.3,44.2 50.4,73.5  "/></g><text x="0" y="115" fill="#000000" font-size="5px" font-weight="bold" font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"></text><text x="0" y="120" fill="#000000" font-size="5px" font-weight="bold" font-family="'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"></text></svg>`,

//                     content: `

//     <style>

// .accordion-content{font-family:inherit;  display: none; padding-top: 10px; overflow: hidden; font-size: 16px;line-height: 1.5;color: #0e0e0e;border: none !important;min-height: 40px !important;}
// .accordion{text-decoration:none; font-family:inherit !important; font-size: 22px;font-weight: 700;line-height: 1.18;color: #111;margin-bottom: 8px;cursor: pointer;background: none !important;border: none;}
// .accordion::before{content: '+';margin-right: 8px;}
// .accordion-active a.accordion::before {content: '–';}
// .accordion-container {padding: 10px 15px;}
//     </style>




// <div class="accordion-container">

// <a href="#" class="accordion">Section 1</a>

// <div class="accordion-content">
//   <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
// </div>
// </div>

// <div class="accordion-container">
// <a href="#" class="accordion">Section 2</a>

// <div class="accordion-content">
//   <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
// </div>
// </div>

// <div class="accordion-container">

// <a href="#" class="accordion">Section 3</a>

// <div class="accordion-content">
//   <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
// </div>
// </div>

// <div class="accordion-container">

// <a href="#" class="accordion">Section 4</a>

// <div class="accordion-content">
//   <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
// </div>
// </div>


// <script>
//     var acc = document.getElementsByClassName("accordion");
//     var i;

//     for (i = 0; i < acc.length; i++) {
//       acc[i].addEventListener("click", function() {
//         event.preventDefault(); // Prevents the default action of anchor tags

//         this.classList.toggle("active");
//         var panel = this.nextElementSibling;
//         if (panel.style.display === "block") {
//           panel.style.display = "none";
//         } else {
//           panel.style.display = "block";
//         }
//       });
//     }
// </script>




//                     `,
//                 });



                const blocks = editor.BlockManager.getAll();

                const filtered = blocks?.filter(block => block?.category == 'Basic')
                console.warn('filter', blocks)

                editor.BlockManager.render(filtered);


                // console.warn('blockssss', JSON.stringify(blocks));

                const removed = editor.BlockManager.remove('quote');
                // const removedButton = editor.BlockManager.remove('button');


                editor.BlockManager.add("TEXT",
                    {
                        id: 'heading',
                        label: 'Headline',
                        category: 'Basic',
                        media: `<svg xmlns="http://www.w3.org/2000/svg" width="19.25" height="19.25"><path d="M.781.03A1.186 1.186 0 0 0 .22.4c-.321.421-.287.981.083 1.351.278.278.384.302 1.318.302h.785v15.144h-.785c-.934 0-1.04.024-1.318.302-.502.502-.355 1.336.291 1.656l.16.079h5.358l.183-.09a1.06 1.06 0 0 0 .509-.563c.089-.238.075-.593-.033-.807a1.145 1.145 0 0 0-.467-.476c-.16-.085-.16-.085-1.002-.095l-.842-.01v-6.541h10.33v6.541l-.842.01c-.812.009-.847.012-.986.085a1.007 1.007 0 0 0-.57.871.864.864 0 0 0 .054.422c.091.24.282.452.509.563l.183.09h5.358l.16-.079c.646-.32.793-1.154.291-1.656-.278-.278-.384-.302-1.318-.302h-.785V2.053h.785c.71 0 .801-.006.959-.065.818-.306.889-1.432.117-1.857l-.209-.115h-5.358l-.183.09c-.631.31-.768 1.182-.261 1.663.068.065.188.151.268.193.139.073.174.076.986.085l.842.01v6.541H4.46V2.057l.842-.01c.842-.01.842-.01 1.002-.095a.996.996 0 0 0 .554-.861A.865.865 0 0 0 6.8.66a1.105 1.105 0 0 0-.528-.565l-.16-.079L3.497.011C2.059.008.837.017.781.03" fill="#b2b9c3" fill-rule="evenodd"/></svg>`,
                        // attributes: { class: 'gjs-fonts gjs-f-h1p' },

                        content: {
                            type: 'text',
                            content: 'Insert Headline here',
                            style: {'font-weight': '700', 'font-size': '48px !important'},
                            activeOnRender: true,
                        }



                    },
                );

                const gridItem = `<table class="grid-item-card">
                <tr>
                  <td class="grid-item-card-cell">
                    <img class="grid-item-image" src="http://placehold.it/250x150/78c5d6/fff/" alt="Image"/>
                    <table class="grid-item-card-body">
                      <tr>
                        <td class="grid-item-card-content">
                          <h1 class="card-title">Title here</h1>
                          <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>`;

                const listItem = `<table class="list-item">
          <tr>
            <td class="list-item-cell">
              <table class="list-item-content">
                <tr class="list-item-row">
                  <td class="list-cell-left">
                    <img class="list-item-image" src="http://via.placehold.it/150x150/78c5d6/fff/" alt="Image"/>
                  </td>
                  <td class="list-cell-right">
                    <h1 class="card-title">Title here</h1>
                    <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>`;



                editor.BlockManager.add("Text",
                    {
                        id: 'sub-heading',
                        label: 'Sub Headline',
                        category: 'Basic',
                        media: `<svg xmlns="http://www.w3.org/2000/svg" width="19.75" height="23.55" viewBox="0 0 19.75 23.55">
                       <g id="icon-subheadline" transform="translate(-1709.625 -133.625)">
                         <path id="Path_45400" data-name="Path 45400" d="M7,.25A.747.747,0,0,1,6.25,1H2.75A.747.747,0,0,1,2,.25.747.747,0,0,1,2.75-.5h1V-5.25h-7.5V-.5h1A.747.747,0,0,1-2,.25.747.747,0,0,1-2.75,1h-3.5A.747.747,0,0,1-7,.25.747.747,0,0,1-6.25-.5h1v-11h-1A.747.747,0,0,1-7-12.25.747.747,0,0,1-6.25-13h3.5a.747.747,0,0,1,.75.75.747.747,0,0,1-.75.75h-1v4.75h7.5V-11.5h-1A.747.747,0,0,1,2-12.25.747.747,0,0,1,2.75-13h3.5a.747.747,0,0,1,.75.75.747.747,0,0,1-.75.75h-1v11h1A.747.747,0,0,1,7,.25Z" transform="translate(1719 156)" fill="#b2b9c3" stroke="#b2b9c3" stroke-width="0.35"/>
                         <line id="Line_491" data-name="Line 491" x2="18" transform="translate(1710.5 134.5)" fill="none" stroke="#b2b9c3" stroke-linecap="round" stroke-width="1.75"/>
                       </g>
                     </svg>`,
                        content: {
                            type: 'text',
                            content: 'Insert Sub Headline here',
                            style: {'font-weight': '700', 'font-size': '28px !important'},
                            activeOnRender: true,
                        }

                    },
                );


                editor.BlockManager.add("Grid-Item",
                    {
                        id: 'grid-items',
                        label: 'Grid Items',
                        category: 'Basic',
                        attributes: {class: 'fa fa-th'},
                        content: `<div>
<table class="grid-item-row" style="box-sizing: border-box; margin: 0 auto 10px auto; padding: 5px 0; width: 100%;" width="100%">
    <tbody style="box-sizing: border-box;">
        <tr style="box-sizing: border-box;">
            <td class="grid-item-cell2-l" style="box-sizing: border-box; vertical-align: top; padding-right: 10px; width: 50%;" width="50%" valign="top">
                <table class="grid-item-card" style="box-sizing: border-box; width: 100%; padding: 5px 0 5px 0; margin-bottom: 10px;" width="100%">
                    <tbody style="box-sizing: border-box;">
                        <tr style="box-sizing: border-box;">
                            <td class="grid-item-card-cell" style="box-sizing: border-box; background-color: rgb(255, 255, 255); overflow: hidden; border-radius: 3px; text-align: center; padding: 0;" bgcolor="rgb(255, 255, 255)" align="center">
                                <img src="https://via.placeholder.com/100" alt="Image" class="grid-item-image" style="box-sizing: border-box; line-height: 150px; font-size: 50px; color: rgb(120, 197, 214); margin-bottom: 15px; width: 100%;">
                                <table class="grid-item-card-body" style="box-sizing: border-box;">
                                    <tbody style="box-sizing: border-box;">
                                        <tr style="box-sizing: border-box;">
                                            <td class="grid-item-card-content" style="box-sizing: border-box; font-size: 13px; color: rgb(111, 119, 125); padding: 0 10px 20px 10px; width: 100%; line-height: 20px;" width="100%">
                                                <h4 class="card-title" style="box-sizing: border-box;">Title here</h4>
                                                <p class="card-text" style="box-sizing: border-box;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                                <div style="display: block; margin: auto;">
                                                    <a style="margin: auto; background-color: #dcdce0; border: 1px solid #47525d; padding: 5px 10px; font-size: 14px; text-decoration: none; border-radius: 8px; display: block; width: 80px; text-align: center;">Button</a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
            <td class="grid-item-cell2-r" style="box-sizing: border-box; vertical-align: top; padding-left: 10px; width: 50%;" width="50%" valign="top">
                <table class="grid-item-card" style="box-sizing: border-box; width: 100%; padding: 5px 0 5px 0; margin-bottom: 10px;" width="100%">
                    <tbody style="box-sizing: border-box;">
                        <tr style="box-sizing: border-box;">
                            <td class="grid-item-card-cell" style="box-sizing: border-box; background-color: rgb(255, 255, 255); overflow: hidden; border-radius: 3px; text-align: center; padding: 0;" bgcolor="rgb(255, 255, 255)" align="center">
                                <img src="https://via.placeholder.com/100" alt="Image" class="grid-item-image" style="box-sizing: border-box; line-height: 150px; font-size: 50px; color: rgb(120, 197, 214); margin-bottom: 15px; width: 100%;">
                                <table class="grid-item-card-body" style="box-sizing: border-box;">
                                    <tbody style="box-sizing: border-box;">
                                        <tr style="box-sizing: border-box;">
                                            <td class="grid-item-card-content" style="box-sizing: border-box; font-size: 13px; color: rgb(111, 119, 125); padding: 0 10px 20px 10px; width: 100%; line-height: 20px;" width="100%">
                                                <h4 class="card-title" style="box-sizing: border-box;">Title here</h4>
                                                <p class="card-text" style="box-sizing: border-box;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                                <div style="display: block; margin: auto;">
                                                    <a style="margin: auto; background-color: #dcdce0; border: 1px solid #47525d; padding: 5px 10px; font-size: 14px; text-decoration: none; border-radius: 8px; display: block; width: 80px; text-align: center;">Button</a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </tr>
    </tbody>
</table>
                         </div>`,
                        //   activeOnRender:true
                    },
                )

                editor.BlockManager.add("List-Item",
                    {
                        id: 'list-items',
                        label: 'List Items',
                        category: 'Basic',
                        attributes: {class: 'fa fa-th-list'},
                        content: `<div><table class="grid-item-row" style="box-sizing: border-box; margin-top: 0px; margin-right: auto; margin-bottom: 10px; margin-left: auto; padding-top: 5px; padding-right: 0px; padding-bottom: 5px; padding-left: 0px; width: 100%;" 
                        width="100%">
                        <tbody style="box-sizing: border-box;">
                          <tr style="box-sizing: border-box;">
                          </tr>
                        </tbody>
                      </table>
                      <table class="list-item" style="box-sizing: border-box; height: auto; width: 100%; margin-top: 0px; margin-right: auto; margin-bottom: 10px; margin-left: auto; padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px;" width="100%">
                        <tbody style="box-sizing: border-box;">
                          <tr style="box-sizing: border-box;">
                            <td class="list-item-cell" style="box-sizing: border-box; background-color: #ffffff !important; border-top-left-radius: 3px; border-top-right-radius: 3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px; overflow-x: hidden; overflow-y: hidden; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px;" bgcolor="rgb(255, 255, 255)">
                              <table class="list-item-content" style="box-sizing: border-box; border-collapse: collapse; margin-top: 0px; margin-right: auto; margin-bottom: 0px; margin-left: auto; padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px; height: 150px; width: 100%;" width="100%" height="150">
                                <tbody style="box-sizing: border-box;">
                                  <tr class="list-item-row" style="box-sizing: border-box;">
                                    <td class="list-cell-left" style="box-sizing: border-box; width: 30%; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px;" width="30%">
                                      <img src="https://via.placeholder.com/100" alt="Image" class="list-item-image" style="box-sizing: border-box; color: rgb(217, 131, 166); font-size: 45px; width: 100%;">
                                    </td>
                                    <td class="list-cell-right" style="box-sizing: border-box; width: 70%; padding-top: 10px; padding-right: 20px; padding-bottom: 0px; padding-left: 20px;" width="70%">
                                      <h4 class="card-title" style="box-sizing: border-box;">Title here
                                      </h4>
                                      <p class="card-text" style="box-sizing: border-box;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                      </p>
                                                      <div style="display:block; margin:auto;"><a style="background-color: #dcdce0;border: 1px solid #47525d;padding: 5px 10px;font-size: 14px; text-decoration:none;border-radius: 8px; display: block;width:80px;text-align:center" >
      Button
      </a></div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="list-item" style="box-sizing: border-box; height: auto; width: 100%; margin-top: 0px; margin-right: auto; margin-bottom: 10px; margin-left: auto; padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px;" width="100%">
                        <tbody style="box-sizing: border-box;">
                          <tr style="box-sizing: border-box;">
                            <td class="list-item-cell" style="box-sizing: border-box; background-color: #ffffff !important; border-top-left-radius: 3px; border-top-right-radius: 3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px; overflow-x: hidden; overflow-y: hidden; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px;" bgcolor="rgb(255, 255, 255)">
                              <table class="list-item-content" style="box-sizing: border-box; border-collapse: collapse; margin-top: 0px; margin-right: auto; margin-bottom: 0px; margin-left: auto; padding-top: 5px; padding-right: 5px; padding-bottom: 5px; padding-left: 5px; height: 150px; width: 100%;" width="100%" height="150">
                                <tbody style="box-sizing: border-box;">
                                  <tr class="list-item-row" style="box-sizing: border-box;">
                                    <td class="list-cell-left" style="box-sizing: border-box; width: 30%; padding-top: 0px; padding-right: 0px; padding-bottom: 0px; padding-left: 0px;" width="30%">
                                      <img src="https://via.placeholder.com/100" alt="Image" class="list-item-image" style="box-sizing: border-box; color: rgb(217, 131, 166); font-size: 45px; width: 100%;">
                                    </td>
                                    <td class="list-cell-right" style="box-sizing: border-box; width: 70%; padding-top: 10px; padding-right: 20px; padding-bottom: 0px; padding-left: 20px;" width="70%">
                                      <h4 class="card-title" style="box-sizing: border-box;">Title here
                                      </h4>
                                      <p class="card-text" style="box-sizing: border-box;">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                      </p>
                                                     <div style="display:block; margin:auto;"><a style="background-color: #dcdce0;border: 1px solid #47525d;padding: 5px 10px;font-size: 14px; text-decoration:none;border-radius: 8px; display: block;width:80px;text-align:center" >
      Button
      </a></div>
                                    </td>
                                  </tr> 
                                </tbody> 
                              </table>
                            </td>
                          </tr>
                        </tbody> </table></div>`,
                        activeOnRender: true

                    },
                )






//CouponCounter code

                editor.BlockManager.add("CouponCounter", {
                    label: 'Coupon Counter with description',
                    category: 'Basic',

                    media: `<svg data-name="Layer 1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M316 286.856a7.5 7.5 0 0 0-7.5 7.5v12.667a7.5 7.5 0 0 0 15 0v-12.667a7.5 7.5 0 0 0-7.5-7.5Zm0 44.334a7.5 7.5 0 0 0-7.5 7.5v12.666a7.5 7.5 0 0 0 15 0V338.69a7.5 7.5 0 0 0-7.5-7.5Zm-55-48.086H87.522a17.52 17.52 0 0 0-17.5 17.5v44.506a17.52 17.52 0 0 0 17.5 17.5H261a17.52 17.52 0 0 0 17.5-17.5v-44.506a17.52 17.52 0 0 0-17.5-17.5Zm2.5 62.006a2.502 2.502 0 0 1-2.5 2.5H87.522a2.503 2.503 0 0 1-2.5-2.5v-44.506a2.503 2.503 0 0 1 2.5-2.5H261a2.502 2.502 0 0 1 2.5 2.5Zm52.5 30.413a7.5 7.5 0 0 0-7.5 7.5v12.667a7.5 7.5 0 0 0 15 0v-12.667a7.5 7.5 0 0 0-7.5-7.5Zm97.59-37.278a22.5 22.5 0 1 0 31.82 31.82 22.5 22.5 0 0 0-31.82-31.82Zm21.214 21.213-.001.001a7.409 7.409 0 1 1 0-.001Zm73.067 11.58a18.412 18.412 0 0 0-.035-23.059l-18.618-23.293a3.51 3.51 0 0 1 .052-4.434l18.41-21.972a18.541 18.541 0 0 0 .22-23.496l-16.413-20.35a3.492 3.492 0 0 1-.207-4.11l18.706-28.684a11.499 11.499 0 0 0-9.63-17.783h-33.647l1.12-4.098a16.712 16.712 0 0 0-8.276-19.229l-22.217-11.897a1.802 1.802 0 0 1-.873-2.1l6.99-23.196a16.829 16.829 0 0 0-8.219-19.686l-19.524-10.345a1.79 1.79 0 0 1-.929-1.896l4.985-28.509a10.88 10.88 0 0 0-15.003-11.873L94.71 203.858H11.645a11.5 11.5 0 0 0-9.633 17.78l18.707 28.686a3.492 3.492 0 0 1-.207 4.11L4.1 274.784a18.541 18.541 0 0 0 .22 23.495l18.411 21.974a3.51 3.51 0 0 1 .052 4.433L4.164 347.979a18.413 18.413 0 0 0-.035 23.058l16.247 20.453a3.495 3.495 0 0 1 .192 4.087L2.004 424.08a11.5 11.5 0 0 0 9.636 17.777H286a7.507 7.507 0 0 0 3.354-.792L316 427.742l26.646 13.323a7.507 7.507 0 0 0 3.354.792h154.36a11.5 11.5 0 0 0 9.636-17.776l-18.564-28.504a3.496 3.496 0 0 1 .193-4.087ZM403.681 87.81l-3.675 21.015a16.752 16.752 0 0 0 8.68 17.735l19.526 10.346a1.798 1.798 0 0 1 .879 2.103l-6.99 23.196a16.847 16.847 0 0 0 8.154 19.65l22.218 11.899a1.784 1.784 0 0 1 .884 2.054l-2.198 8.05H346a7.507 7.507 0 0 0-3.354.791L316 217.973l-26.646-13.324a7.507 7.507 0 0 0-3.354-.792H132.8Zm75.182 315.953 15.041 23.094H347.771l-28.416-14.208a7.496 7.496 0 0 0-6.71 0l-28.415 14.208H18.096l15.041-23.094a18.477 18.477 0 0 0-1.016-21.603l-16.246-20.452a3.485 3.485 0 0 1 .006-4.363L34.5 334.05a18.554 18.554 0 0 0-.272-23.43l-18.411-21.974a3.51 3.51 0 0 1-.042-4.446l16.413-20.35a18.454 18.454 0 0 0 1.096-21.72l-15.178-23.273h78.12l.026.002.039-.002h187.938l28.416 14.208a7.496 7.496 0 0 0 6.71 0l28.415-14.208h146.123l-15.177 23.274a18.455 18.455 0 0 0 1.095 21.719l16.414 20.35a3.508 3.508 0 0 1-.042 4.446l-18.412 21.972a18.557 18.557 0 0 0-.27 23.433l18.618 23.294a3.484 3.484 0 0 1 .006 4.362L479.88 382.16a18.474 18.474 0 0 0-1.017 21.603Zm-40.181-122.429a7.503 7.503 0 0 0-10.608 0L356.68 352.73a7.5 7.5 0 0 0 10.607 10.607l71.396-71.396a7.501 7.501 0 0 0 0-10.607Zm-55.87 26.135.001-.001Zm-21.211-21.213a7.5 7.5 0 0 1 10.606 10.605l-.001.001a7.5 7.5 0 0 1-10.605-10.606ZM316 242.523a7.5 7.5 0 0 0-7.5 7.5v12.667a7.5 7.5 0 0 0 15 0v-12.667a7.5 7.5 0 0 0-7.5-7.5Z" fill="#fff"/>
</svg>`,


                    content: `
<div class="wrapper-count">
    <div style=" font-size: 42px; line-height: 1;padding-right: 8px;float: left;">41</div>
    <div style="font-size: 18px;color: #111;line-height: 1.14;text-transform: capitalize;float: left;">Coupons <br>  used</div>
</div>`

                });

//old vs new price

                editor.BlockManager.add("oldVsNew", {
                    label: 'Old vs New Price',
                    category: 'Basic',

                    media: `
<svg fill="#fff" height="60" width="60"  xmlns="http://www.w3.org/2000/svg"
     \t viewBox="0 0 473.655 473.655" xml:space="preserve">
<g>
\t<path d="M226.518,151.253c0,12.144,9.88,22.024,22.024,22.024s22.024-9.88,22.024-22.024s-9.88-22.024-22.024-22.024
\t\tS226.518,139.109,226.518,151.253z M248.542,144.228c3.873,0,7.024,3.151,7.024,7.024c0,3.873-3.151,7.024-7.024,7.024
\t\ts-7.024-3.151-7.024-7.024C241.518,147.38,244.669,144.228,248.542,144.228z"/>
    \t<path d="M130.652,172.578c2.471,0.905,5.032,1.355,7.587,1.355c3.157,0,6.305-0.688,9.255-2.056
\t\tc5.337-2.475,9.391-6.881,11.414-12.405c4.176-11.403-1.703-24.078-13.107-28.255c-11.401-4.175-24.078,1.702-28.256,13.106
\t\tC113.369,155.726,119.248,168.402,130.652,172.578z M131.631,149.482c1.041-2.843,3.737-4.609,6.603-4.609
\t\tc0.801,0,1.614,0.138,2.408,0.429c3.638,1.332,5.513,5.375,4.181,9.012c-1.332,3.637-5.372,5.512-9.012,4.18
\t\tC132.174,157.161,130.298,153.119,131.631,149.482z"/>
    \t<path d="M468.951,239.323L398.127,107.65c-10.31-19.177-34.308-26.389-53.502-16.077l-52.571,28.286l-39.417-25.725
\t\tc-2.49-1.626-5.706-1.626-8.198,0l-51.102,33.354c-10.877-9.829-23.649-17.576-37.83-22.769
\t\tC95.6,82.775,29.008,113.663,7.064,173.571c-21.941,59.908,8.946,126.499,68.854,148.441c12.979,4.754,26.437,7.12,39.86,7.12
\t\tc16.588,0,33.123-3.615,48.62-10.803c2.611-1.211,5.163-2.511,7.654-3.894v64.849c0,4.142,3.357,7.5,7.5,7.5h137.978
\t\tc4.143,0,7.5-3.358,7.5-7.5v-99.918l15.584,28.977c5,9.295,13.319,16.086,23.424,19.122c3.76,1.13,7.598,1.689,11.416,1.689
\t\tc6.444,0,12.828-1.595,18.66-4.734l58.761-31.598C472.051,282.501,479.263,258.502,468.951,239.323z M158.088,304.722
\t\tc-24.403,11.319-51.751,12.457-77.011,3.206C28.936,288.83,2.052,230.872,21.149,178.73c14.928-40.755,53.59-66.076,94.665-66.076
\t\tc11.477,0,23.146,1.979,34.534,6.149c25.258,9.251,45.402,27.785,56.721,52.187c11.318,24.402,12.457,51.752,3.206,77.01
\t\tc-0.001,0-0.001,0-0.001,0C201.023,273.259,182.49,293.403,158.088,304.722z M310.031,371.785H187.054v-67.279
\t\tc16.864-13.149,29.769-30.767,37.307-51.346l-0.001,0c10.63-29.021,9.322-60.444-3.683-88.481
\t\tc-4.443-9.578-10.071-18.369-16.711-26.217l44.572-29.092l61.493,40.133V371.785z M445.77,279.613l-58.761,31.598
\t\tc-5.763,3.101-12.387,3.772-18.653,1.889c-6.268-1.883-11.428-6.096-14.529-11.862l-28.795-53.541v-85.866
\t\tc2.741,1.227,5.775,1.916,8.968,1.916c12.145,0,22.024-9.88,22.024-22.024s-9.88-22.024-22.024-22.024
\t\tc-9.36,0-17.369,5.871-20.552,14.121l-7.087-4.625l45.369-24.411c11.907-6.397,26.794-1.923,33.188,9.97l70.824,131.673
\t\tC462.136,258.324,457.662,273.212,445.77,279.613z M326.975,141.723c0-3.873,3.151-7.024,7.024-7.024s7.024,3.151,7.024,7.024
\t\tc0,3.873-3.151,7.024-7.024,7.024S326.975,145.596,326.975,141.723z"/>
    \t<path d="M373.031,164.895c-1.962-3.648-6.511-5.015-10.158-3.052c-3.647,1.962-5.015,6.51-3.053,10.158l41.619,77.378
\t\tc1.354,2.518,3.94,3.949,6.612,3.949c1.199,0,2.416-0.288,3.546-0.896c3.647-1.962,5.015-6.51,3.053-10.158L373.031,164.895z"/>
    \t<path d="M343.949,180.208c-1.963-3.648-6.511-5.014-10.158-3.052c-3.647,1.962-5.015,6.51-3.053,10.158l41.62,77.378
\t\tc1.354,2.518,3.94,3.949,6.612,3.949c1.199,0,2.416-0.288,3.546-0.896c3.647-1.962,5.015-6.51,3.053-10.158L343.949,180.208z"/>
    \t<path d="M77.104,194.485l80.278,29.404c0.851,0.312,1.722,0.459,2.578,0.459c3.058,0,5.931-1.884,7.043-4.923
\t\tc1.425-3.889-0.573-8.197-4.463-9.622L82.263,180.4c-3.889-1.425-8.197,0.574-9.621,4.463
\t\tC71.217,188.753,73.215,193.06,77.104,194.485z"/>
    \t<path d="M165.793,244.54L57.345,204.818c-3.89-1.425-8.198,0.574-9.621,4.463c-1.425,3.89,0.573,8.198,4.463,9.622l108.448,39.722
\t\tc0.851,0.312,1.722,0.459,2.578,0.459c3.058,0,5.931-1.884,7.043-4.922C171.681,250.272,169.683,245.964,165.793,244.54z"/>
</g>
</svg>`,

                    content: `<div style="position: relative;">
    <div style="line-height: 1;color: #111;font-size: 16px;">Was: <span style="text-decoration: line-through;">$25.00</span></div>
    <div style="  font-size: 48px;font-weight: 700;line-height: 1;color: #a22605;">$0.99</div>
</div>`

                });



                editor.BlockManager.add("Star", {
                    label: '5 Star Rating',
                    category: 'Basic',

                    media: `<svg height="60" width="60" version="1.1"  xmlns="http://www.w3.org/2000/svg" 
\t viewBox="0 0 47.94 47.94" xml:space="preserve">
<path style="fill:#fff;" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757
\tc2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042
\tc0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685
\tc-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528
\tc-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956
\tC22.602,0.567,25.338,0.567,26.285,2.486z"/>
</svg>
`,
                    content: ' <div>   <svg height="30" width="30" version="1.1"  xmlns="http://www.w3.org/2000/svg" \n' +
                        '\t viewBox="0 0 47.94 47.94" xml:space="preserve">\n' +
                        '<path style="fill:#ED8A19;" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757\n' +
                        '\tc2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042\n' +
                        '\tc0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685\n' +
                        '\tc-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528\n' +
                        '\tc-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956\n' +
                        '\tC22.602,0.567,25.338,0.567,26.285,2.486z"/>\n' +
                        '</svg>' +
                        ' <svg height="30" width="30" version="1.1"  xmlns="http://www.w3.org/2000/svg" \n' +
                        '\t viewBox="0 0 47.94 47.94" xml:space="preserve">\n' +
                        '<path style="fill:#ED8A19;" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757\n' +
                        '\tc2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042\n' +
                        '\tc0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685\n' +
                        '\tc-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528\n' +
                        '\tc-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956\n' +
                        '\tC22.602,0.567,25.338,0.567,26.285,2.486z"/>\n' +
                        '</svg> <svg height="30" width="30" version="1.1"  xmlns="http://www.w3.org/2000/svg" \n' +
                        '\t viewBox="0 0 47.94 47.94" xml:space="preserve">\n' +
                        '<path style="fill:#ED8A19;" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757\n' +
                        '\tc2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042\n' +
                        '\tc0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685\n' +
                        '\tc-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528\n' +
                        '\tc-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956\n' +
                        '\tC22.602,0.567,25.338,0.567,26.285,2.486z"/>\n' +
                        '</svg> <svg height="30" width="30" version="1.1"  xmlns="http://www.w3.org/2000/svg" \n' +
                        '\t viewBox="0 0 47.94 47.94" xml:space="preserve">\n' +
                        '<path style="fill:#ED8A19;" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757\n' +
                        '\tc2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042\n' +
                        '\tc0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685\n' +
                        '\tc-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528\n' +
                        '\tc-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956\n' +
                        '\tC22.602,0.567,25.338,0.567,26.285,2.486z"/>\n' +
                        '</svg> <svg height="30" width="30" version="1.1"  xmlns="http://www.w3.org/2000/svg" \n' +
                        '\t viewBox="0 0 47.94 47.94" xml:space="preserve">\n' +
                        '<path style="fill:#ED8A19;" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757\n' +
                        '\tc2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042\n' +
                        '\tc0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685\n' +
                        '\tc-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528\n' +
                        '\tc-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956\n' +
                        '\tC22.602,0.567,25.338,0.567,26.285,2.486z"/>\n' +
                        '</svg> </div>',

                });

//badge flag code

                editor.BlockManager.add("BadgeFlag", {
                    label: 'Rectangle Badge',
                    category: 'Basic',

                    media: `<svg width="20" height="40">
  <rect width="100" height="300" style="fill:rgb(251,253,253);stroke-width:1;stroke:rgb(0,0,0)" />
</svg>`,



                    content: `
<div style="background: red;display: inline-block;padding: 17px 2px;position: relative; width: 68px;font-size: 18px;line-height: 1.5;text-transform: uppercase;color: #fff; font-family: inherit;">
    <span style="display: block;text-align: center;font-weight: 700;">  96%</span>
    <span style="display: block; text-align: center;font-weight: 400;"> OFF </span>
</div>`

                });



//badge code

                editor.BlockManager.add("Badge", {
                    label: 'Round Badge',
                    category: 'Basic',

                    media: `<svg version="1.1" viewBox="0 0 1600 1600" xmlns="http://www.w3.org/2000/svg">
    <path transform="translate(725)" d="m0 0h144l1 2c0.71 0.0198 1.42 0.0396 2.15 0.0601 3.26 0.0961 6.52 0.205 9.79 0.315 1.12 0.0309 2.23 0.0619 3.38 0.0938 5.76 0.203 11.1 0.671 16.7 2.08 2.98 0.683 5.94 0.814 8.98 0.955 4.63 0.281 8.84 0.821 13.3 1.97 4.62 0.918 9.34 1.27 14 1.66 4.65 0.442 8.47 1.45 12.8 3.21 2.65 0.948 5.17 1.07 7.98 1.16 4.78 0.292 7.62 1.28 11.9 3.5 3.12 0.64 6.24 1.12 9.39 1.57 2.61 0.43 2.61 0.43 4.61 1.43 1.37 0.154 2.75 0.274 4.12 0.375 3.95 0.396 7.12 1.36 10.8 2.87 3.2 1.15 6.47 1.67 9.82 2.23 2.36 0.541 4.15 1.44 6.3 2.53l3.44 0.438c3.56 0.562 3.56 0.562 5.94 2.06 3.15 1.8 5.53 1.9 9.09 2.2 7.19 0.866 14 3.32 20.5 6.3 2.45 0.958 4.91 1.9 7.38 2.84 2.62 1.16 2.62 1.16 5.91 3.16 3.9 2.27 7.76 3.13 12.2 4 6.06 1.29 11.2 2.8 16.6 6v2c0.843 0.133 1.69 0.266 2.55 0.402 1.1 0.177 2.19 0.353 3.32 0.535 1.64 0.261 1.64 0.261 3.3 0.527 2.82 0.535 2.82 0.535 4.82 1.54v2l2.19 0.375c2.77 0.615 5.21 1.51 7.81 2.62v2c0.574 0.126 1.15 0.253 1.74 0.383 3.03 0.826 5.72 2.15 8.55 3.48 2.28 0.954 4.51 1.72 6.86 2.47 5.28 1.73 10.2 4.01 15.2 6.41 0.922 0.44 1.84 0.881 2.79 1.33 5.85 2.84 11.3 5.87 16.7 9.51 2.61 1.74 5.26 3.1 8.11 4.41v2l2.38 0.125c6.43 1.55 11.8 5.47 17.1 9.38 3.67 2.7 7.64 4.75 11.7 6.89 2.95 1.63 5.76 3.4 8.59 5.23 3.09 2 6.12 3.85 9.44 5.44 4.6 2.2 8.7 5.04 12.9 7.94 0.701 0.471 1.4 0.941 2.12 1.43 1.66 1.14 3.28 2.35 4.88 3.57v2c0.582 0.282 1.16 0.564 1.76 0.855 3.62 1.85 7 4.07 10.4 6.27 0.761 0.488 1.52 0.977 2.31 1.48 4.95 3.24 9.44 6.65 13.6 10.8 2.15 1.8 4.22 2.64 6.86 3.56v2c0.559 0.238 1.12 0.477 1.7 0.723 3.75 2.08 6.58 5.15 9.67 8.09 2.75 2.29 5.43 3.63 8.63 5.19 2.34 1.75 2.34 1.75 4.38 3.56 0.688 0.599 1.38 1.2 2.09 1.82 1.54 1.62 1.54 1.62 1.54 3.62 0.99 0.33 1.98 0.66 3 1 1.39 1.52 1.39 1.52 2.81 3.38 2.69 3.28 5.21 5.01 9.19 6.62v2c1.14 0.402 1.14 0.402 2.31 0.812 2.58 1.14 3.96 2 5.69 4.19v2c0.586 0.262 1.17 0.523 1.78 0.793 2.35 1.28 3.91 2.64 5.8 4.52 0.68 0.674 1.36 1.35 2.06 2.04 0.723 0.727 1.45 1.45 2.19 2.2 0.749 0.747 1.5 1.49 2.27 2.26 1.58 1.58 3.16 3.16 4.73 4.74 2.42 2.43 4.85 4.85 7.28 7.27 1.53 1.53 3.06 3.07 4.59 4.6 0.731 0.727 1.46 1.45 2.22 2.2 0.668 0.674 1.34 1.35 2.02 2.04 0.592 0.594 1.18 1.19 1.79 1.8 1.26 1.52 1.26 1.52 1.26 3.52l1.64 0.656c3.18 1.81 5.57 4.26 8.11 6.84 0.507 0.499 1.01 0.998 1.54 1.51 3.71 3.73 3.71 3.73 3.71 5.99 0.597 0.262 1.19 0.523 1.81 0.793 4.27 2.35 7.23 6.53 9.63 10.7 1.9 3.04 4.23 5.25 6.79 7.73 2.45 2.45 4.58 5.09 6.77 7.77l1.69 1.44c1.31 1.56 1.31 1.56 2.25 5.12 0.639 3.49 0.639 3.49 2.94 4.45 0.7 0.327 1.4 0.655 2.12 0.992 1.56 1.55 1.56 1.55 3 3.31 0.513 0.624 1.03 1.25 1.55 1.89 0.477 0.593 0.954 1.19 1.45 1.8 0.701 0.846 1.4 1.69 2.12 2.56 1.88 2.44 1.88 2.44 3.69 5.19 1.81 2.69 3.69 5.21 5.69 7.75 2.68 3.4 5.1 6.9 7.5 10.5 1.1 1.4 2.2 2.8 3.31 4.19 3.29 4.18 6.13 8.55 8.94 13.1 1.68 2.64 3.44 5.2 5.25 7.75 14.5 20.5 14.5 20.5 14.5 26h2c1.41 1.95 2.73 3.96 4 6l1.62 2.56c1.38 2.44 1.38 2.44 2.25 4.78 1.22 2.87 2.72 5.09 4.57 7.59 2.61 3.56 4.64 7.09 6.56 11.1 0.897 1.68 1.8 3.37 2.7 5.05 6.86 12.7 13.2 25.7 19.3 38.7 0.538 1.15 0.538 1.15 1.09 2.32 0.316 0.678 0.631 1.36 0.957 2.06 1.01 2.08 1.01 2.08 2.93 4.83 1 2.33 2 4.67 3 7l2 3c0.642 1.84 1.24 3.7 1.81 5.56 1.29 4 2.71 7.67 4.69 11.4 2.56 4.85 4.06 9.81 5.51 15.1 1 3.01 2.35 5.28 3.99 7.98 2.97 7.18 5.53 14.2 6 22h2c0.489 1.81 0.489 1.81 0.988 3.66 0.441 1.61 0.883 3.23 1.32 4.84 0.32 1.19 0.32 1.19 0.646 2.4 1.42 5.16 3.1 10.1 5.04 15.1 0.679 2 1.35 4 2 6l1.06 2.81c1.01 3.45 1.35 6.66 1.59 10.2 0.192 2.18 0.192 2.18 2.34 3.95 0.409 2.13 0.731 4.28 1 6.44 0.616 5.09 0.616 5.09 3 9.56 0.371 2.84 0.505 5.65 0.656 8.5 0.111 2.67 0.111 2.67 2.34 4.5 0.634 3.59 1.02 7.19 1.44 10.8 0.263 3.27 0.263 3.27 2.56 5.19 0.351 3.22 0.443 6.41 0.559 9.64 0.248 3.39 0.248 3.39 1.95 6.21 2.28 4.79 1.96 9.46 2.02 14.7 0.0219 0.772 0.0438 1.54 0.0664 2.34 0.00709 0.695 0.0142 1.39 0.0215 2.11 0.251 2.14 0.251 2.14 1.88 3.94 1.89 2.62 1.88 4.18 1.91 7.39 0.0219 1.01 0.0438 2.02 0.0664 3.06 0.0183 2.12 0.0365 4.25 0.0547 6.38 0.0329 1.51 0.0329 1.51 0.0664 3.06 0.00709 0.922 0.0142 1.84 0.0215 2.8 0.138 2.45 0.138 2.45 1.88 3.73 2.44 2.69 1.99 5.93 2.02 9.39 0.018 0.75 0.0359 1.5 0.0544 2.27 0.0541 2.39 0.088 4.79 0.121 7.18 0.0332 1.62 0.0677 3.25 0.104 4.87 0.085 3.98 0.152 7.96 0.209 11.9l4 2c0.0934 15.6 0.164 31.2 0.207 46.8 0.0206 7.24 0.0488 14.5 0.0945 21.7 0.0398 6.31 0.0657 12.6 0.0746 18.9 0.00522 3.34 0.0175 6.68 0.0466 10 0.0289 3.73 0.033 7.46 0.0312 11.2 0.0144 1.11 0.0288 2.22 0.0436 3.37-0.0055 1.01-0.011 2.03-0.0167 3.07 0.00553 1.32 0.00553 1.32 0.0112 2.67-0.655 2.99-2.05 3.54-4.49 5.24-0.391 2.58-0.534 4.76-0.504 7.34-0.00942 0.716-0.0188 1.43-0.0285 2.17-0.0287 2.29-0.0317 4.58-0.03 6.87-0.00361 2.28-0.0132 4.56-0.0408 6.85-0.0167 1.42-0.0197 2.84-0.00699 4.26-0.047 4.44-1.02 6.84-3.39 10.5-0.447 2.48-0.447 2.48-0.406 5.05-0.0219 0.945-0.0438 1.89-0.0664 2.86-0.00902 0.976-0.018 1.95-0.0273 2.96-0.0645 6.92-0.608 11.7-3.5 18.1-0.425 2.75-0.508 5.47-0.562 8.25-0.181 7.37-0.181 7.37-2.44 10.8-0.341 3.55-0.442 7.09-0.559 10.7-0.441 3.35-0.441 3.35-1.95 5.29-2.25 3.1-1.95 6.37-2 10.1-0.0629 4.96-0.291 8.07-3.5 12-0.5 2.68-0.5 2.68-0.562 5.5-0.173 3.81-0.724 6.13-2.44 9.5-0.342 2.42-0.342 2.42-0.438 4.94-0.338 4.21-1.3 6.48-3.56 10.1-0.217 1.37-0.38 2.75-0.5 4.12-0.5 3.88-0.5 3.88-1.96 5.33-1.96 1.97-2.14 3.4-2.6 6.11-0.729 4.23-0.729 4.23-2.94 6.44l0.625 3.06c0.441 4.63-0.572 6.69-2.58 10.7-1.41 2.96-2.17 6.04-3.05 9.2-0.935 2.37-1.96 4.68-3 7h-3c-0.049 0.748-0.098 1.5-0.148 2.27-0.112 1.48-0.112 1.48-0.227 2.98-0.0696 0.975-0.139 1.95-0.211 2.95-0.404 2.73-1.1 4.41-2.41 6.8l-0.875 3.19c-1.32 4.48-3.18 8.57-5.12 12.8-1.27 2.95-2.15 5.62-2.94 8.75l-1.06 3.25c-0.99 0.33-1.98 0.66-3 1l-0.312 3c-1.11 7.63-4.81 14.6-8.12 21.5-0.382 0.803-0.764 1.61-1.16 2.43-2.14 4.48-4.33 8.94-6.59 13.4-0.939 1.89-0.939 1.89-1.81 4.71h-2l-3 10h-2l-0.516 1.69c-1.51 4.77-3.27 9.17-5.62 13.6-1 1.89-1 1.89-1.87 4.73h-2c-0.227 0.969-0.454 1.94-0.688 2.94-1.33 4.75-3.8 8.84-6.31 13.1h-3l-0.375 2.75c-0.546 2.84-1.2 4.78-2.62 7.25h-2c-0.227 0.825-0.454 1.65-0.688 2.5-1.56 4.17-3.54 8-6.31 11.5h-2c-0.159 0.652-0.317 1.3-0.48 1.98-1.56 5.84-3.1 9.83-7.52 14h-3l-0.438 3.38c-0.562 3.62-0.562 3.62-1.56 5.62h-3l-0.375 2.25c-0.911 4.01-1.96 6.11-4.94 9-2.2 2.25-3.55 3.99-5.12 6.62-2.98 4.97-6.54 9.27-10.8 13.2-1.97 1.89-1.97 1.89-2.56 4.81-1.46 3.84-3.37 5.13-6.52 7.62-2.37 2.13-3.38 4.62-4.67 7.5-1.27 1.71-2.61 3.38-4 5-0.443 0.547-0.887 1.09-1.34 1.66-2.58 3.13-5.18 5.85-8.34 8.41-3.14 2.58-4.77 5.13-6.31 8.94h-2c-0.402 0.959-0.402 0.959-0.812 1.94-1.19 2.06-1.19 2.06-4.19 3.06l-2 4c-0.99 0.33-1.98 0.66-3 1l-2 4c-0.99 0.33-1.98 0.66-3 1-0.289 0.742-0.578 1.48-0.875 2.25-1.42 3.46-3.39 5.21-6.12 7.75l-5 5-2.31 2.38c-2.13 2.09-4.29 4.01-6.56 5.94-3.47 2.99-6.39 6.23-9.34 9.72-2.4 2.65-5.09 4.88-7.81 7.19-2 1.81-3.72 3.72-5.47 5.78-2.96 3.5-6.16 6.45-9.66 9.41-2.03 1.71-2.03 1.71-4.4 4.28-3.06 2.9-7.04 6.31-11.4 6.31-0.145 0.897-0.145 0.897-0.293 1.81-0.855 2.65-1.86 3.48-4.02 5.19-2.1 1.69-3.89 3.22-5.69 5.25-2 1.75-2 1.75-5.62 2.75-3.46 0.604-3.46 0.604-4.56 3.06-0.402 0.959-0.402 0.959-0.812 1.94-2.12 0.75-2.12 0.75-4 1l-1 4c-0.639 0.103-1.28 0.206-1.94 0.312l-2.06 0.688-1 3c-1.97 1.05-3.98 2.05-6 3l-3.25 2.19c-2.75 1.81-2.75 1.81-4.75 1.81v2c-4.38 3-4.38 3-7 3-0.248 0.639-0.495 1.28-0.75 1.94-1.25 2.06-1.25 2.06-3.38 2.81-0.619 0.0825-1.24 0.165-1.88 0.25v2c-5.75 3-5.75 3-8 3l-1 3c-3.06 1.19-3.06 1.19-6 2v2c-1.79 1.44-1.79 1.44-4.19 3-0.777 0.516-1.55 1.03-2.36 1.56-2.46 1.44-2.46 1.44-5.07 2.44-2.5 1.05-3.53 2.09-5.39 4-1.62 0.942-3.27 1.83-4.94 2.69-5.4 2.85-10.4 6.15-15.3 9.68-2.68 1.61-4.65 2.25-7.73 2.64v2c-0.638 0.182-1.28 0.364-1.93 0.551-0.826 0.251-1.65 0.503-2.5 0.762-1.24 0.365-1.24 0.365-2.5 0.738-1.02 0.47-1.02 0.47-2.07 0.949l-1 3c-2.65 1.44-5.27 2.74-8 4-1.63 0.807-3.25 1.62-4.88 2.44-40.1 20.1-40.1 20.1-42.6 21.3-1.65 0.83-3.29 1.68-4.92 2.54-5.47 2.86-10.9 4.94-16.8 6.81-3.37 1.1-6.51 2.47-9.75 3.9l-3.62 1.31c-3.69 1.35-7.2 3-10.8 4.69-4.77 2.24-9.42 3.96-14.5 5.36-2.89 0.874-5.45 2.27-8.13 3.64-1.34 0.481-2.68 0.937-4.04 1.38-0.798 0.261-1.6 0.522-2.42 0.791-0.841 0.275-1.68 0.55-2.55 0.834-1.7 0.571-3.39 1.14-5.09 1.72-10.3 3.46-20.5 6.71-31 9.27-1.08 0.266-1.08 0.266-2.18 0.536-1.42 0.348-2.84 0.69-4.27 1.03-2.63 0.638-5.1 1.25-7.52 2.47-2.84 1.41-5.73 1.86-8.83 2.47-3.43 0.682-6.72 1.36-10 2.5-4.63 1.49-9.37 2.12-14.2 2.86-4.41 0.608-4.41 0.608-7.93 3.14-2.66 0.417-5.26 0.746-7.94 1-5.83 0.489-5.83 0.489-11.1 3-1.88 0.363-1.88 0.363-3.99 0.527-1.17 0.103-1.17 0.103-2.37 0.207-0.83 0.067-1.66 0.134-2.52 0.203-5.75 0.524-11.3 1.18-16.9 2.62-6.1 1.56-12 1.96-18.2 2.23-2.94 0.0113-2.94 0.0113-5.02 1.21-1.55 0.141-3.1 0.226-4.66 0.281-0.941 0.0374-1.88 0.0748-2.85 0.113-0.987 0.0348-1.97 0.0696-2.99 0.105-3.84 0.14-7.67 0.305-11.5 0.5-0.95 0.0374-1.9 0.0748-2.88 0.113-0.896 0.0554-1.79 0.111-2.71 0.168-0.801 0.0419-1.6 0.0838-2.43 0.127-0.979 0.293-0.979 0.293-1.98 0.592l-2 4h-136l-1-4c-0.923-0.0553-1.85-0.111-2.8-0.168-3.43-0.207-6.85-0.418-10.3-0.632-1.48-0.0916-2.97-0.182-4.45-0.271-2.13-0.128-4.26-0.261-6.4-0.395-1.92-0.118-1.92-0.118-3.89-0.238-3.19-0.297-3.19-0.297-6.19-1.3-2.02-0.178-4.04-0.319-6.06-0.438-4.78-0.342-9.32-0.927-14-1.96-2.46-0.503-4.91-0.932-7.39-1.33-0.8-0.128-1.6-0.256-2.42-0.387-1.6-0.253-3.2-0.501-4.8-0.745-3.1-0.495-5.9-0.966-8.82-2.14-3.69-1.47-7.47-1.92-11.4-2.5-5.53-0.835-10.7-1.95-16.1-3.5-3.57-0.715-7.17-1.28-10.8-1.86-4.25-0.711-8.16-1.7-12.2-3.14-1.77-0.493-3.54-0.972-5.31-1.44-3.48-0.934-6.9-1.94-10.3-3.12-2.96-1.02-5.87-1.8-8.94-2.44-3.64-0.763-6.97-1.86-10.4-3.22-5.75-2.23-11.7-3.99-17.6-5.78-3.63-1.11-7.21-2.25-10.8-3.62-3.88-1.45-7.66-2.44-11.7-3.38v-1c-0.883-0.231-1.77-0.461-2.68-0.699-6.94-1.89-13.3-4.03-19.8-7.16-2.22-1.02-4.34-1.77-6.68-2.45-5.98-1.87-11.4-4.92-17-7.76-5.5-2.8-11-5.4-16.9-7.18-6.02-1.91-11.5-4.96-17.1-7.83-2.88-1.47-5.78-2.84-8.75-4.11-6.82-2.97-13.1-6.81-19.4-10.8-6.87-4.26-14-8.49-21.7-11.1v-2c-1.14-0.402-1.14-0.402-2.31-0.812-2.64-1.17-3.7-2.2-5.69-4.19-1.65-0.697-3.32-1.36-5-2-2.71-1.53-5.25-3.17-7.81-4.94-3.6-2.33-7.32-4.22-11.2-6.06v-2h-2v-2c-2.47-1.28-4.9-2.35-7.5-3.38-3.46-1.61-4.86-2.99-7.5-5.62-1.38-0.802-2.78-1.57-4.19-2.31-5.06-2.71-9.37-6.08-13.8-9.69-1.58-1.28-3.16-2.55-4.75-3.81-0.696-0.563-1.39-1.13-2.11-1.71-2.11-1.59-2.11-1.59-4.72-2.47-2.65-1.1-3.63-2.07-5.36-4.32-3.66-4.5-7.04-7.89-12.6-10.1-3.85-1.79-5.33-3.48-7.9-6.72-3.42-4.08-7.54-7.67-12.1-10.4-6.3-3.78-11.2-9.13-15.9-14.7-1.99-2.22-4.27-3.95-6.61-5.79v-2l-1.62-0.625c-3.29-1.91-5.97-4.42-8.38-7.38v-2c-0.567-0.243-1.13-0.485-1.72-0.736-2.72-1.51-4.59-3.3-6.8-5.5-0.888-0.875-1.78-1.75-2.69-2.65-0.961-0.958-1.92-1.92-2.88-2.88-0.993-0.987-1.99-1.97-2.98-2.96-2.08-2.07-4.16-4.14-6.23-6.22-2.65-2.65-5.31-5.28-7.97-7.91-2.06-2.04-4.11-4.08-6.15-6.13-0.976-0.974-1.95-1.94-2.94-2.91-5.46-5.39-9.6-10.1-12.6-17.1-1.8-2.04-1.8-2.04-3.81-3.5-6.78-5.57-11.4-11.7-15.8-19.3-1.77-2.84-4.01-4.92-6.4-7.25-0.821-1.25-1.61-2.53-2.38-3.81-1.8-3.02-3.76-5.58-6.12-8.19-2.87-3.17-5.08-6.4-7.26-10.1-1.26-1.96-2.63-3.63-4.18-5.37-4.09-4.61-7.4-9.75-10.5-15-1.51-2.48-3.14-4.8-4.84-7.14-3.1-4.39-5.71-8.91-8.22-13.7-2.33-4.34-4.91-8.52-7.46-12.7-1.51-2.5-3.01-5.01-4.51-7.52-0.966-1.61-1.94-3.21-2.92-4.8-3.05-4.99-5.86-10.1-8.57-15.2-2.64-5.03-5.45-9.77-8.68-14.4-2.65-4.01-5.32-8.1-5.32-13h-2c-2.27-4.77-4.2-9.51-5.75-14.6-2.34-7.25-5.83-13.8-9.3-20.6-2.69-5.29-5.32-10.6-6.89-16.3-1.02-3.4-2.32-6.16-3.94-9.31-2.45-4.78-4.44-9.52-6.19-14.6-0.924-2.63-1.94-5.2-3-7.78-1.54-3.8-2.89-7.63-4.16-11.5-0.877-2.64-1.82-5.24-2.78-7.85-1.47-4.02-2.89-8.05-4.21-12.1-0.584-1.76-1.2-3.51-1.83-5.25-2.04-5.76-3.43-10.9-3.69-17.1-0.161-2.37-0.161-2.37-2.27-5.06-0.838-2.78-1.52-5.59-2.22-8.41-0.704-2.79-0.704-2.79-2.78-5.59-0.309-2.02-0.309-2.02-0.438-4.25-0.328-3.66-1.19-6.27-2.8-9.59-1.47-4.16-1.79-8.59-2.33-12.9-0.343-3.05-0.343-3.05-0.98-5.34-0.542-2.26-0.546-4.3-0.512-6.62 0.00902-0.799 0.018-1.6 0.0273-2.42 0.0116-0.603 0.0232-1.21 0.0352-1.83h-2c-2.02-5.38-2.35-10.2-2.56-15.9-0.223-3.14-0.223-3.14-1.94-5.46-2.15-3.82-1.99-7.34-2.06-11.7-0.111-7.22-0.111-7.22-2.44-14h-1c-0.0198-0.742-0.0396-1.48-0.0601-2.25-0.0952-3.36-0.205-6.71-0.315-10.1-0.0309-1.17-0.0619-2.33-0.0938-3.54-0.0387-1.12-0.0773-2.24-0.117-3.39-0.0314-1.03-0.0628-2.06-0.0952-3.13-0.146-2.86-0.146-2.86-2.32-5.64-0.241-2.82-0.373-5.56-0.414-8.39-0.0194-0.817-0.0387-1.63-0.0587-2.48-0.0598-2.61-0.106-5.22-0.152-7.82-0.0382-1.77-0.0772-3.54-0.117-5.31-0.096-4.34-0.18-8.67-0.258-13l-2-1v-103h3c-0.0105-0.993-0.0209-1.99-0.0317-3.01-0.0364-3.71-0.0592-7.42-0.0781-11.1-0.01-1.6-0.0236-3.2-0.041-4.8-0.0245-2.31-0.0357-4.62-0.0444-6.93-0.0103-0.708-0.0206-1.42-0.0313-2.14-0.00104-4.67 0.889-8.53 2.23-13 0.309-2.9 0.309-2.9 0.309-5.76 0.0251-1.04 0.0503-2.08 0.0762-3.14 0.0353-2.16 0.0665-4.31 0.0938-6.47 0.0264-1.04 0.0529-2.07 0.0801-3.14 0.0135-0.935 0.0269-1.87 0.0408-2.83 0.473-3.14 1.77-4.96 3.4-7.66 0.551-2.68 0.551-2.68 0.66-5.48 0.107-1.53 0.107-1.53 0.217-3.08 0.0612-1.05 0.122-2.1 0.186-3.18 0.128-2.1 0.264-4.2 0.41-6.3 0.0542-0.927 0.108-1.85 0.164-2.81 0.12-0.708 0.24-1.42 0.363-2.15l2-1c0.426-2.62 0.751-5.17 1-7.81 0.738-7.68 0.738-7.68 1.97-10.1 1.28-2.66 1.6-5.06 1.99-7.99 0.16-1.13 0.321-2.27 0.486-3.43 0.323-2.37 0.643-4.75 0.961-7.12 0.819-5.75 1.56-10.5 4.59-15.6 2.59-6.59 4.09-13.4 5.46-20.3 0.747-3.61 1.56-6.72 3.04-10.1 1.62-3.85 2.32-7.42 2.97-11.5 0.174-0.673 0.348-1.35 0.527-2.04l2-1c0.809-2.57 0.809-2.57 1.44-5.62 1.12-4.75 2.6-8.9 4.56-13.4 1.05-3.27 2.04-6.56 3.03-9.85 1.17-3.79 2.53-7.45 3.97-11.1 2.28-5.91 2.28-5.91 4-12h2c0.124-0.692 0.248-1.38 0.375-2.1 1.82-8.66 5.36-15.6 9.66-23.2 1.35-2.42 2.6-4.88 3.84-7.36 0.369-0.735 0.737-1.47 1.12-2.23 0.718-1.53 1.38-3.09 2-4.66 0.959-2.36 2.06-4.47 3.32-6.68 2.2-3.91 4.25-7.86 6.23-11.9 1.12-2.27 2.26-4.52 3.41-6.77 3.69-7.27 7.24-14.5 10-22.2h2l0.938-3.62c1.94-5.86 5.32-10.7 8.71-15.8 2.82-4.24 5.33-8.63 7.84-13.1 1.38-2.31 2.89-4.38 4.51-6.52 1-1.66 2-3.33 3-5 1.07-1.55 2.15-3.09 3.25-4.62 3.3-4.65 6.32-9.44 9.27-14.3 0.489-0.678 0.977-1.36 1.48-2.05h2c0.248-0.722 0.495-1.44 0.75-2.19 1.37-3.07 3.13-5.22 5.25-7.81l1.06-2.12c1.04-2.07 2.31-3.25 3.94-4.88 1.18-2.1 1.18-2.1 2-4h2l0.625-2.56c2.13-5.31 5.77-8.91 9.88-12.8 2.22-2.33 3.78-4.49 5.5-7.19 2.32-3.6 4.61-5.81 8-8.44 2.8-3.27 5.48-6.46 6.88-10.6 1.61-3.48 4.28-5.33 7.25-7.69 1.98-1.64 1.98-1.64 2.94-3.9 0.938-1.85 0.938-1.85 3.94-2.85l1-2c1-2 1-2 4-3 1.78-1.72 1.78-1.72 3.5-3.81 0.588-0.687 1.18-1.37 1.78-2.08 3.34-3.99 3.34-3.99 5.59-8.61 1.44-3.21 3.35-4.35 6.12-6.5 1.56-1.72 3.04-3.49 4.53-5.27 2.03-2.38 4.23-4.55 6.47-6.73l5-5c1.18-1.21 1.18-1.21 2.38-2.44 4.43-4.33 8.93-8.18 14.1-11.6 6.13-4 10.8-7.65 14.5-14h3l0.625-1.69c1.95-3.28 4.32-5.02 7.38-7.31h2l1-3 2.19-0.75c3.44-1.53 4.82-3.44 7.15-6.32 5.04-5.86 12.3-12.5 19.7-14.9 1.36-1.31 2.69-2.65 4-4 2.87-2.44 5.55-4.47 9-6v-2l3.12-1.75c6.11-3.38 6.11-3.38 11.4-7.88 2.2-2.02 4.67-2.56 7.5-3.38v-2c0.969-0.454 1.94-0.908 2.94-1.38 3.13-1.28 3.13-1.28 4.06-3.62 1.64-0.93 1.64-0.93 3.69-1.88 4.22-2.03 8.42-4.16 11.7-7.57 5.48-5.28 13.4-8.53 20-12.1 4.63-2.56 9.06-5.38 13.4-8.38 3.73-2.41 7.59-4.5 11.5-6.6 2.61-1.42 5.14-2.93 7.68-4.46 4.93-2.81 9.9-5.5 15-8 1.58-0.791 3.17-1.58 4.75-2.38 30.2-15.1 30.2-15.1 32.7-16.4 1.69-0.847 3.37-1.71 5.04-2.58 4.7-2.43 9.3-4.46 14.4-6 4.14-1.33 7.99-3.07 11.9-5.05 14.4-7.25 14.4-7.25 19.2-6.62v-2c0.664-0.11 1.33-0.219 2.01-0.332 4.96-0.89 8.79-1.76 13-4.67l6-3 1-1c1.32-0.352 2.66-0.656 4-0.938 0.808-0.175 1.62-0.351 2.45-0.531 1.67-0.347 3.34-0.681 5.01-1 0.777-0.155 1.55-0.309 2.36-0.469 0.708-0.133 1.42-0.266 2.14-0.402 2.15-0.562 2.15-0.562 3.96-2.2 3.27-2.3 6.54-1.93 10.4-2.06 3.06-0.468 4.27-1.52 6.66-3.41 2.01-0.287 4.03-0.571 6.05-0.754 2.52-0.318 4.61-1.26 6.95-2.25l2.75-0.438c2.74-0.474 4.97-1.13 7.56-2.06 3.88-1.36 7.44-1.91 11.5-2.09 2.28-0.284 2.28-0.284 4.34-1.91 4.56-2.44 9.31-1.97 14.4-2.03 0.78-0.0219 1.56-0.0438 2.36-0.0664 0.707-0.00709 1.41-0.0142 2.14-0.0215 2.44-0.491 3.2-1.63 4.91-3.38 2.54-0.3 4.9-0.466 7.44-0.5 5.1 0.124 5.1 0.124 9.45-2.01 2.69-1.9 4.27-1.84 7.54-1.79 1.02 0.00967 2.05 0.0193 3.11 0.0293 1.6 0.0377 1.6 0.0377 3.22 0.0762 1.62 0.0203 1.62 0.0203 3.27 0.041 2.66 0.0353 5.32 0.0846 7.98 0.146v-2c3.07-1.53 6.27-1.12 9.63-1.1 1.13 0.00212 1.13 0.00212 2.28 0.00429 2.4 0.0056 4.81 0.0182 7.21 0.0309 1.63 0.00501 3.26 0.00958 4.89 0.0137 4 0.011 7.99 0.0283 12 0.0488v-3zm-59 7v1h22v-1h-22zm242 0v1h10v-1h-10zm-45.8 59.9c-0.69 0.878-0.69 0.878-1.39 1.77-1.91 2.41-3.17 3.61-5.81 5.38 0.986 5.26 4.49 8.24 8.72 11.2 5 2.84 9.96 3.44 15.6 4.17 4.16 0.711 8.04 1.86 12.1 3.13 6.81 2.13 13.4 3.34 20.5 4.04 3.05 0.44 5.35 1.27 8.17 2.46 1.55 0.314 3.12 0.583 4.69 0.812 7.51 1.28 14.7 3.47 22.1 5.55 8.6 2.44 17.1 4.81 26 6.15 2.27 0.492 2.27 0.492 3.89 1.51 3.49 1.44 6.93 1.23 10.6 1.18 1.19-0.00424 1.19-0.00424 2.4-0.00858 2.53-0.0112 5.05-0.0363 7.58-0.0617 1.72-0.01 3.43-0.0192 5.15-0.0273 4.2-0.022 8.4-0.0565 12.6-0.0977 0.223-5.85-1.96-8.17-5.65-12.6-3.41-3.52-7.18-5.92-11.4-8.43-1.26-0.883-2.51-1.78-3.75-2.69-5.62-4-10.8-6.31-17.3-8.31-1.26-0.393-1.26-0.393-2.56-0.794-5.63-1.73-11.3-3.27-17-4.63-2.85-0.698-5.58-1.63-8.36-2.58-2.77-0.758-5.54-1.49-8.32-2.22-2.68-0.781-2.68-0.781-4.91-1.72-16.7-6.39-35.1-8.01-52.8-8.94-1.18-0.0738-2.36-0.148-3.57-0.224-7.97-0.337-11.6 0.167-17.2 5.95zm-129-6.85-1 1c-1.66 0.133-3.32 0.203-4.99 0.246-1.02 0.0329-2.03 0.0657-3.08 0.0996-2.15 0.0609-4.3 0.118-6.45 0.172-1.02 0.0342-2.04 0.0683-3.09 0.104-1.4 0.0376-1.4 0.0376-2.84 0.0759-2.64 0.314-4.23 1.06-6.55 2.3-3.34 0.367-6.65 0.504-10 0.656-3.17 0.133-3.17 0.133-6 2.34-1.74 0.405-3.49 0.777-5.25 1.12-5.46 1.39-7.94 3.54-11.2 8.04-1.54 1.84-1.54 1.84-3.59 2.82-3.69 1.94-4.63 6.26-5.95 10-0.772 3.36-0.772 3.36-1 6 4.58 1.14 9.02 1.18 13.7 1.2 1.27 0.00855 1.27 0.00855 2.56 0.0173 1.79 0.00943 3.58 0.016 5.37 0.0198 2.69 0.00961 5.38 0.0406 8.06 0.0723 9.35 0.0564 17.8-0.512 27-2.61 4.92-1.04 9.76-1.26 14.8-1.39 1.4-0.0512 1.4-0.0512 2.83-0.104 2.24-0.0806 4.49-0.15 6.73-0.209v-2c0.681-0.0501 1.36-0.1 2.06-0.152 3.08-0.232 6.17-0.477 9.25-0.723 1.07-0.0786 2.14-0.157 3.25-0.238 1.03-0.0838 2.06-0.168 3.12-0.254 0.948-0.0733 1.9-0.147 2.87-0.222 2.7-0.28 2.7-0.28 5.45-2.41 2.49-0.408 4.93-0.74 7.44-1 4.22-0.439 7.81-0.903 11.6-3 1.38-0.381 2.78-0.713 4.19-1 0.777-0.166 1.55-0.333 2.36-0.504 1.67-0.336 3.34-0.656 5.01-0.961 0.808-0.156 1.62-0.312 2.45-0.473 1.11-0.199 1.11-0.199 2.25-0.402 0.578-0.218 1.16-0.436 1.75-0.66l1-3c0.99-0.33 1.98-0.66 3-1 0.419-2.33 0.419-2.33 0-5-3.91-4.39-7.47-4.46-13-5l-2-2c-2.47-0.325-2.47-0.325-5.38-0.303-1.12-0.0166-2.25-0.0333-3.41-0.0504-1.83-0.0126-1.83-0.0126-3.7-0.0255-1.25-0.017-2.5-0.034-3.79-0.0515-3.33-0.0442-6.66-0.0805-9.99-0.112-4.68-0.0456-9.36-0.102-14-0.163-2.49-0.0319-4.99-0.0588-7.48-0.0802-1.7-0.0202-1.7-0.0202-3.44-0.0409-0.995-0.00951-1.99-0.019-3.02-0.0288-2.75-0.145-2.75-0.145-5.55-0.718-0.727-0.141-1.45-0.282-2.2-0.427zm-111 25-1 1c-1.56 0.203-3.13 0.347-4.7 0.465-0.962 0.078-1.92 0.156-2.92 0.236-2.03 0.156-4.06 0.31-6.09 0.461-5.08 0.416-9.5 0.999-14.3 2.84-1.51 0.322-3.04 0.615-4.56 0.875-6.3 1.21-12.3 3.15-18.4 5.12-1.21 0.389-1.21 0.389-2.44 0.785-2.19 0.718-4.38 1.46-6.56 2.21-0.896 0.308-1.79 0.616-2.71 0.934-4.25 1.5-8.36 3.02-12.3 5.13-3.8 2.01-7.69 3.14-11.8 4.23-2.29 0.601-2.29 0.601-4.1 2.71l-3.69 1.12c-5.36 1.68-10.1 4.3-15 7.01-3.37 1.86-6.7 3.54-10.3 4.87v2l-2.19 0.625c-3.89 1.9-5.4 3.76-7.81 7.38-0.333 2.67-0.333 2.67 1 5 3 3.26 5.27 4.27 9.58 4.46 1.74-0.00793 3.49-0.0372 5.23-0.0859 1.3-0.00193 1.3-0.00193 2.62-0.00391 8.88 0.0944 8.88 0.0944 16.6-3.37 1.47-0.353 2.95-0.657 4.44-0.938 0.911-0.177 1.82-0.353 2.76-0.535 1.73-0.326 3.46-0.647 5.2-0.961 12.6-2.17 12.6-2.17 24.2-7.16 3.55-2.05 6.79-1.86 10.8-2 3.03-0.469 4.3-1.47 6.62-3.41 3.11-1.17 6.23-2.06 9.44-2.94 3.59-0.993 3.59-0.993 7-2.56 3.56-1.5 3.56-1.5 7.04-2.23 5.88-1.43 11.1-4.3 16.4-7.08 1.04-0.521 2.09-1.04 3.16-1.58 0.995-0.516 1.99-1.03 3.02-1.56 0.902-0.464 1.8-0.928 2.73-1.41 2.64-1.95 3.28-3.54 4.21-6.64h3l2-5h2v-7c-2.64-1.32-4.93-1.3-7.88-1.5-5.7-0.392-5.7-0.392-8.45-1.09-0.554-0.134-1.11-0.268-1.68-0.406zm410 26.5c-0.362 0.488-0.725 0.975-1.1 1.48 3.54 8.85 10.9 14.5 19 19 0.656 0.393 1.31 0.786 1.99 1.19 3.28 2.11 3.28 2.11 7.01 2.81v2c0.528 0.231 1.06 0.463 1.6 0.701 6.01 2.65 12 5.42 17.9 8.24 0.886 0.417 1.77 0.834 2.68 1.26 5 2.37 9.87 4.89 14.7 7.6 8.32 4.66 16.8 9.31 26.1 11.6 2.18 0.616 4 1.55 6.02 2.57l3.5 1c3.5 1 3.5 1 5.5 2.06 2.11 1.12 2.11 1.12 5.12 1.31 4.14 0.668 7.51 1.95 11.3 3.59 5.63 2.31 10.3 3.31 16.4 3.16 0.688-0.00902 1.38-0.018 2.09-0.0273 1.68-0.0233 3.36-0.0592 5.04-0.0977 0.553-7.5-3-12.9-7-19-1.7-1.84-3.38-3.31-5.39-4.8-1.61-1.2-1.61-1.2-4.05-3.82-2.76-2.56-5.33-3.84-8.71-5.4-1.85-0.977-1.85-0.977-3.97-3.16-1.83-2.11-1.83-2.11-5-2.31l-2.88-0.5c-0.672-1.33-1.34-2.66-2-4-1.64-1.29-1.64-1.29-3.6-2.25-0.72-0.38-1.44-0.759-2.18-1.15-0.753-0.382-1.51-0.764-2.28-1.16-0.726-0.386-1.45-0.772-2.2-1.17-4.47-2.32-8.93-4.11-13.7-5.63-2.41-0.764-4.73-1.68-7.07-2.64-7.23-2.94-14.5-5.58-21.9-8v-1c-1.09-0.193-2.17-0.387-3.29-0.586-1.45-0.263-2.89-0.526-4.34-0.789-0.713-0.126-1.43-0.253-2.16-0.383-0.703-0.129-1.41-0.258-2.13-0.391-0.639-0.115-1.28-0.23-1.94-0.349-2.15-0.502-2.15-0.502-4.98-1.54-5.81-1.77-11.8-1.29-17.9-1.28-1.34-0.0157-2.69-0.032-4.03-0.0488-1.27-6.45e-4 -2.54-0.00129-3.85-0.00195-1.16-0.00298-2.32-0.00596-3.52-0.00903-2.93 0.119-2.93 0.119-4.81 1.9zm-596 46.5c-3.22 1.62-6.45 3.22-9.7 4.8-11 5.38-21.1 11.5-31.1 18.7-2.01 1.36-4.02 2.41-6.19 3.48l-1.5 1.5c-1.69 1.69-3.34 2.53-5.5 3.5v2c-0.949 0.248-1.9 0.495-2.88 0.75-3.6 1.44-3.58 1.96-5.12 5.25-2.62 1.25-2.62 1.25-5 2v2l-2.5 0.625c-7.23 2.84-12.2 7.8-17.1 13.7-1.45 1.64-1.45 1.64-3.45 2.64v3c-0.579 0.257-1.16 0.513-1.75 0.777-6.83 3.72-12.6 10.9-15.2 18.2l1 3c5.48-0.582 10.2-1.96 15.3-3.94 0.715-0.265 1.43-0.53 2.17-0.803 4.11-1.56 4.11-1.56 7.52-4.26 1.67-0.494 3.36-0.923 5.06-1.31 5.55-1.42 10.1-3.67 14.9-6.69v-2c0.842-0.253 1.68-0.505 2.55-0.766 3.75-1.34 7.16-3.07 10.6-4.98 0.659-0.357 1.32-0.714 2-1.08 1.33-0.72 2.65-1.44 3.98-2.17 1.6-0.87 3.2-1.73 4.8-2.58 5.16-2.76 10.2-5.66 15.2-8.67 1.11-0.665 2.21-1.33 3.36-2.02 0.811-0.572 1.62-1.14 2.46-1.73v-2c1.98-0.66 3.96-1.32 6-2v-2c0.701-0.248 1.4-0.495 2.12-0.75 3.25-1.41 5.95-3.26 8.88-5.25l2.31-1.12c1.88-0.763 1.88-0.763 2.69-2.88l6-3c3.72-2.37 6.53-4.3 9-8 0.99-0.33 1.98-0.66 3-1l2.38-2.38c2.62-2.62 2.62-2.62 5.44-3.81 2.43-1.6 2.43-1.6 2.54-4.18 0.0257-2.58-0.026-5.07-0.348-7.63-2.57-2.57-9.61-1.28-13.1-1.31-1.12-0.029-2.24-0.058-3.4-0.0879-6.97-0.0532-11.6 0.697-17.5 4.4zm763 35.3c-1.29 3.39-1.05 5.21-0.0156 8.67 1.31 2.36 1.31 2.36 3 4h2c0.251 0.589 0.503 1.18 0.762 1.79 1.39 2.49 2.86 3.84 5.05 5.65 6.1 5.09 11.4 10.9 16.7 16.7 3.08 3.35 6.22 6.62 9.46 9.82l4.5 4.5c0.782 0.779 1.56 1.56 2.37 2.36 1.59 1.6 3.15 3.24 4.69 4.89 2.58 2.39 5.23 4.02 8.24 5.82 7.87 5.12 14.3 12.5 20.8 19.1 3.34 3.38 6.69 6.65 10.3 9.72 2.92 2.51 5.5 5.15 8.05 8.04 6.57 7.45 13.7 14.4 20.7 21.4 1.41 1.41 2.82 2.81 4.23 4.22 4.71 4.7 4.71 4.7 9.44 9.39 1.03 1.03 2.05 2.07 3.05 3.12 1.14 1.19 2.33 2.33 3.53 3.46h2v2c1.15 1.11 2.29 2.22 3.45 3.32 1.88 2.03 3.37 4.2 4.93 6.49 4.24 6.19 8.97 11.6 14.4 16.8 2.9 2.83 4.68 5.59 6.25 9.38h2c0.259 0.579 0.518 1.16 0.785 1.75 1.31 2.41 2.8 4.17 4.65 6.18 3.1 3.46 5.48 6.9 7.56 11.1h2c0.268 0.722 0.536 1.44 0.812 2.19 1.86 4.41 4.34 8.04 7.25 11.8 2.22 2.92 3.71 5.52 4.94 9l1.56 2.25c1.71 3.26 1.96 5.93 2.23 9.57 0.522 5.4 2 7.59 6.21 11.2 6.46 4.3 6.46 4.3 14 5 2.62-1.39 2.62-1.39 5-3 0.99-0.33 1.98-0.66 3-1 0.0815-2.54 0.141-5.08 0.188-7.62 0.0251-0.713 0.0503-1.43 0.0762-2.16 0.0673-4.89-0.808-7.88-3.26-12.2l-0.812-3.88c-0.945-4.13-2.91-6.66-5.54-9.92-3.06-4.09-5.27-8.69-7.65-13.2-1.31-2.34-2.66-4.67-4-7h-2c-0.0851-0.744-0.17-1.49-0.258-2.25-0.893-3.3-2.09-4.42-4.62-6.68-3.34-3.15-5.17-5.88-7.12-10.1-1.64-1.69-3.31-3.35-5-5-5.3-6.61-5.3-6.61-7-10h-2l-2-5h-2c-0.213-0.545-0.425-1.09-0.645-1.65-1.83-3.18-4.4-5.43-7.04-7.91-4.78-4.61-8.28-9.22-11.7-15-2.6-3.91-6.02-6.56-9.65-9.47-1.69-1.65-3.36-3.31-5-5l-2.38-2.31c-2.09-2.13-4.01-4.29-5.94-6.56-2.99-3.47-6.23-6.39-9.72-9.34-2.65-2.4-4.88-5.09-7.19-7.81-1.81-2-3.72-3.72-5.78-5.47-3.5-2.96-6.45-6.18-9.43-9.66-3.35-3.9-7.08-7.28-10.9-10.6-3.65-3.21-6.8-6.6-9.94-10.3-2.18-2.42-4.58-4.46-7.08-6.53-4.01-3.36-7.41-7.25-10.9-11.2-5.95-6.63-11.7-12.3-19.8-16.2-1.69-1.64-3.35-3.31-5-5-5.95-4.67-12.5-8.3-19.1-11.9-1.89-1.09-1.89-1.09-2.89-2.09-2.48-0.207-4.89-0.324-7.38-0.375-0.686-0.0374-1.37-0.0748-2.08-0.113-3.65-0.0639-5.11-0.0213-7.53 2.82zm-892 66.6c-1.95 1.07-1.95 1.07-5.33 2.51-6.71 2.89-12.9 5.89-17.6 11.6v2l-2.25 0.375c-2.62 0.596-4.53 1.12-6.75 2.62-0.805 2.05-0.805 2.05-1 4l-1.88 0.25c-2.3 0.544-2.3 0.544-3.19 2.75-0.309 0.66-0.619 1.32-0.938 2-0.99 0.33-1.98 0.66-3 1-0.733 2.02-0.733 2.02-1 4l-4 1-1 4c-0.619 0.0825-1.24 0.165-1.88 0.25-2.26 0.529-2.26 0.529-3.06 2.5l-1.06 2.25-2.44 2.38c-2.68 2.48-2.68 2.48-4.06 5.62-1.71 3.42-3.7 5.4-6.5 8l-2.5 2.5c-1.67 1.67-3.38 3.29-5.12 4.88-2.97 3.28-5.38 7.03-5.38 11.6l-1.69 0.688c-5.28 3-7.71 7-10.3 12.3l-2.25 2.12c-0.578 0.619-1.16 1.24-1.75 1.88 0.136 2.22 0.136 2.22 1 4l4 1 2 15c5.4-1.08 6.64-2.09 10.5-5.75l2.78-2.61c3.66-3.55 7.25-7.15 10.8-10.8 1.09-1.12 2.17-2.25 3.26-3.37 0.53-0.564 1.06-1.13 1.61-1.71 3.99-4.09 7.86-6.4 13.1-8.73v-2l1.94-0.812c2.39-1.07 2.39-1.07 3.06-4.19 1.33-0.667 2.67-1.33 4-2l1-3c1.33-0.667 2.67-1.33 4-2 3.54-3.2 3.54-3.2 6.06-7.19 1.22-2.35 2.61-2.68 4.94-3.81l1-3 1.69-0.812c3.35-1.72 5.94-4.27 8.31-7.19v-2c0.99-0.33 1.98-0.66 3-1 0.697-1.65 1.36-3.32 2-5l3-3c1.19-2.6 1.19-2.6 2-5h3c1.92-1.97 3.44-3.77 5-6 0.599-0.853 0.599-0.853 1.21-1.72 3.59-5.99 3.85-12.5 2.79-19.3-1.39-2.76-2.61-3.96-5-6-2.24 0-4.15 1.83-6.05 2.93zm-130 145c-1.33 2.16-1.33 2.16-2.18 4.77-1.06 2.38-1.06 2.38-3 3.19-2.99 1.72-3.23 4.05-4.28 7.23-1.05 2.61-2.75 4.06-4.79 5.96-0.688 1.66-1.36 3.32-2 5l-3 3v3l-1-2h-2l-2 10c-0.99 0.33-1.98 0.66-3 1-0.774 1.77-0.774 1.77-1.25 3.94-1.48 4.91-3.95 8.41-6.98 12.5-2.29 3.3-3.99 6.75-5.71 10.4-1.21 2.49-2.63 4.81-4.06 7.19-0.308 0.772-0.616 1.54-0.934 2.34-1.02 2.56-2.19 4.96-3.44 7.41-5.29 10.5-9.39 21.3-13 32.5-0.613 1.78-0.613 1.78-1.61 3.78-0.04 2-0.0435 4 0 6 3.49 1.75 7.19 1.57 11 1 5.35-3.43 8.98-7.95 11-14l4-4v-2l1.81-0.625c3.03-1.9 3.73-4.15 5.19-7.38 0.557-0.908 1.11-1.82 1.69-2.75 1.48-2.1 1.48-2.1 1.31-4.25 0.99-0.33 1.98-0.66 3-1 1.19-1.8 2.37-3.61 3.47-5.46 1.83-3.03 3.76-5.97 5.72-8.91 0.674-1.02 1.35-2.04 2.04-3.09 1.77-2.54 1.77-2.54 3.77-4.54 2.23-3.79 2.23-3.79 3-8h2l3-9h2c4.17-5.15 7.17-11 10-17 0.811-1.61 1.62-3.21 2.44-4.81 2.27-4.53 4.38-9.12 6.45-13.7 1.11-2.45 1.11-2.45 2.25-4.48 1.02-2.33 1.07-4 0.988-6.53-0.018-0.764-0.0361-1.53-0.0547-2.32-0.0232-0.7-0.0464-1.4-0.0703-2.12v-3c-4.95-0.65-9.88-1.13-14.9-1.31-0.905-0.0374-1.81-0.0748-2.74-0.113-2.52 0.208-2.52 0.208-4.14 2.28zm18.8 16.1 1 2zm1246 40c-2.12 2.12-2.93 3.49-3.34 6.47 0.0157 0.901 0.0314 1.8 0.0476 2.73 0.00967 0.98 0.0193 1.96 0.0293 2.97 0.0251 1.02 0.0503 2.03 0.0762 3.08 0.0135 1.03 0.0271 2.06 0.041 3.12 0.0353 2.54 0.0846 5.08 0.146 7.62l2 1c0.781 2.33 0.781 2.33 1.5 5.25 0.927 3.73 2.01 7.21 3.5 10.8 2.15 5.87 3.53 11.9 5 18h2c0.147 0.961 0.147 0.961 0.297 1.94 0.732 4.23 1.39 7.95 3.7 11.6 2.08 3.58 2.74 6.37 3.5 10.4 0.653 2.72 1.98 4.73 3.5 7.07 0.711 1.98 1.39 3.98 2 6h2c0.0864 0.606 0.173 1.21 0.262 1.84 1.14 6.79 3.42 12.2 6.74 18.2 0.59 1.13 0.59 1.13 1.19 2.28 4.4 8.27 9.17 16.1 16.8 21.7 2.5-0.567 2.5-0.567 5-2 1.22-2.71 1.22-2.71 1.75-5.88 0.222-1.05 0.443-2.1 0.672-3.18 0.286-1.46 0.286-1.46 0.578-2.95 0.232-0.704 0.464-1.41 0.703-2.13 0.499-1.92 0.499-1.92-0.663-3.67-1.22-2.59-1.32-4.45-1.38-7.3-0.0296-0.966-0.0593-1.93-0.0898-2.93-0.0444-2.03-0.0886-4.06-0.133-6.09-0.0445-1.45-0.0445-1.45-0.0898-2.92-0.0187-0.881-0.0374-1.76-0.0566-2.67-0.148-2.57-0.148-2.57-2.29-5.3-0.682-2.69-1.3-5.35-1.88-8.06-1.32-5.97-2.89-11.5-5.39-17.2-0.734-1.79-0.734-1.79-0.734-3.79h-2c-0.182-0.88-0.364-1.76-0.551-2.67-0.251-1.16-0.503-2.32-0.762-3.52-0.244-1.15-0.487-2.3-0.738-3.48-0.932-3.27-2.11-5.5-3.95-8.33-0.893-1.7-1.77-3.41-2.62-5.12-0.638-1.27-0.638-1.27-1.29-2.57-1.09-2.3-1.09-2.3-2.09-5.3h-2c-0.0954-0.883-0.191-1.77-0.289-2.68-0.772-3.61-1.91-5.56-4.09-8.51-0.606-0.839-1.21-1.68-1.84-2.54-1.51-1.92-2.93-3.68-4.79-5.27h-2c-0.342-1.09-0.342-1.09-0.691-2.21-1.57-3.36-3.45-5.06-6.25-7.48-0.875-0.767-1.75-1.53-2.65-2.32-3.72-3.22-3.72-3.22-8.41-3.99zm-1391 53 1 2zm57 40c-3.42 3.53-5.41 7.56-7.51 11.9-1.11 2.28-2.26 4.53-3.45 6.77-4.03 7.67-7.09 14.9-9.24 23.3-0.801 2.97-0.801 2.97-2.43 6.6-1.69 4.15-2.25 8.18-2.85 12.6-0.527 2.77-0.527 2.77-1.52 4.76-1.31 2.63-1.6 5.1-2 8.01-0.782 5.58-0.782 5.58-2.03 7.96-1.78 3.74-1.44 7.96-1.62 12-0.344 3-0.344 3-2.34 6-0.286 3.32-0.414 6.6-0.479 9.93-0.0264 0.689-0.0529 1.38-0.0801 2.09-0.0202 0.93-0.0202 0.93-0.0408 1.88-0.401 2.1-0.401 2.1-1.91 4.89-1.76 3.79-1.84 6.41-1.78 10.6 0.00637 1.02 0.00637 1.02 0.0129 2.06 0.0167 2.15 0.0543 4.3 0.0926 6.45 0.0151 1.47 0.0287 2.93 0.041 4.4 0.0329 3.58 0.0846 7.15 0.146 10.7 6.67 0.101 9.92-0.725 15-5 7.08-7.65 12.7-17.4 13.1-28l-0.125-2h2c0.17-0.606 0.34-1.21 0.516-1.84 1.28-4.41 2.65-8.64 4.48-12.9 2.24-5.41 3.26-11 4.29-16.7 0.711-3.61 0.711-3.61 1.77-7.19 1.16-4.22 1.38-8.21 1.6-12.6 0.344-2.87 0.344-2.87 1.35-5.21 1.08-2.89 1.26-5.03 1.29-8.11 0.0128-1.06 0.0255-2.13 0.0387-3.23 0.00223-1.14 0.00445-2.28 0.00674-3.45 0.00666-1.18 0.0133-2.36 0.0202-3.57 0.0101-2.49 0.0148-4.98 0.0145-7.47 0.00438-3.81 0.0407-7.62 0.0786-11.4 0.00587-2.42 0.00984-4.84 0.0117-7.27 0.0144-1.14 0.0287-2.28 0.0435-3.45-0.00387-6.26-0.00387-6.26-2.41-11.9-1.9-1.96-1.9-1.96-4.1-1.74zm-71 1 1 2zm-5 16 1 2zm-10 33 1 4zm-5 27 1 2zm1484 6.36c-2.75 5.74-2.34 11.7-2.21 17.9 0.00129 1.17 0.00258 2.34 0.00391 3.55 0.0291 6.88 0.0291 6.88 2.37 13.2 0.271 2.03 0.271 2.03 0.309 4.15 0.0251 0.777 0.0503 1.55 0.0762 2.35 0.0351 1.62 0.0663 3.23 0.0938 4.85 0.0264 0.778 0.0529 1.56 0.0801 2.36 0.0135 0.702 0.0269 1.4 0.0408 2.13 0.292 2.31 0.292 2.31 1.9 4.54 1.8 3.13 1.93 5.2 2.02 8.79 0.0354 1.16 0.0709 2.31 0.107 3.51 0.0226 1.2 0.0451 2.4 0.0684 3.63 0.0342 1.22 0.0683 2.44 0.104 3.69 0.0823 3 0.152 6 0.209 9 0.99 0.33 1.98 0.66 3 1 0.0198 1.14 0.0396 2.27 0.0601 3.44 0.076 4.21 0.165 8.42 0.257 12.6 0.0383 1.82 0.0731 3.65 0.104 5.47 0.0456 2.62 0.104 5.24 0.164 7.86 0.0116 0.816 0.0231 1.63 0.035 2.47 0.101 3.87 0.187 5.85 2.38 9.13 0.598 2.16 0.598 2.16 1.06 4.5 1.23 6.11 2.66 8.66 7.74 12.3 2.34 1.47 2.34 1.47 6.01 1.3 3.6-1.27 4.25-1.94 6.19-5.12 3.49-10.6 3.54-21.5 3.69-32.5 0.0309-1.71 0.0625-3.42 0.0947-5.13 0.0765-4.3 0.134-8.6 0.185-12.9 0.0313-2.38 0.0713-4.76 0.115-7.14 0.0763-4.17 0.125-8.35 0.167-12.5 0.0215-1.25 0.043-2.49 0.0652-3.77 0.00427-1.14 0.00854-2.28 0.0129-3.46 0.00935-0.988 0.0187-1.98 0.0283-2.99-0.417-3.03-1.45-4.26-3.36-6.59-0.406-3.02-0.406-3.02-0.5-6.38-0.277-5.09-1.1-8.11-3.5-12.6-0.309-1.87-0.575-3.75-0.812-5.62-0.995-6.8-3.56-12.6-7.19-18.4l-2-1-0.75-3.12c-1.2-4.54-3.58-7.94-7.25-10.9-6.24-1.22-7.97 1.4-11.2 6.36zm-1490 23.6 1 4zm-4 18v23h1v-23h-1zm67 61c-3.08 3.38-5.07 6.88-7 11-0.524 0.944-0.524 0.944-1.06 1.91-1.04 2.31-1.24 4.02-1.38 6.53-0.297 3.92-1.03 7.45-2.07 11.2-2.05 8.7-1.92 17.3-1.89 26.1-0.00203 1.79-0.00494 3.57-0.0087 5.36-0.00439 3.71 0.00191 7.43 0.016 11.1 0.0172 4.76 0.00717 9.51-0.0107 14.3-0.0108 3.68-0.00739 7.35 3.83e-4 11 2e-3 1.75-4.37e-4 3.51-0.00744 5.26-0.00763 2.45 0.00401 4.89 0.0207 7.34-0.00607 0.719-0.0121 1.44-0.0184 2.18 0.056 4.43 0.915 6.99 3.41 10.6 0.66 3.16 0.66 3.16 1.06 6.5 0.514 4.19 1.28 7.62 2.94 11.5 0.376 1.99 0.72 3.99 1 6 4.05 1.03 6.13 1.51 9.81-0.625 3.16-3.67 3.23-8.48 3.73-13.1 0.457-3.25 0.457-3.25 1.48-6.05 1.56-5.1 1.41-10.3 1.55-15.6 0.0296-0.824 0.0593-1.65 0.0898-2.5 0.0187-0.747 0.0374-1.49 0.0566-2.26 0.287-1.88 0.287-1.88 2.29-3.88 0.307-2.52 0.307-2.52 0.259-5.49 0.0063-1.15 0.0126-2.3 0.0191-3.48-0.00405-1.25-0.0081-2.49-0.0123-3.78 0.00191-1.28 0.00383-2.55 0.0058-3.86 0.00136-2.7-0.00134-5.4-0.0107-8.11-0.0114-3.46-0.00485-6.92 0.00714-10.4 0.00898-3.3 0.00268-6.6-0.00226-9.9 0.00405-1.24 0.0081-2.48 0.0123-3.76-0.0063-1.15-0.0126-2.31-0.0191-3.5-0.00159-1.02-0.00318-2.03-0.00482-3.08-0.26-2.73-0.92-4.31-2.25-6.67-0.331-2.24-0.331-2.24-0.457-4.68-0.0581-0.904-0.116-1.81-0.176-2.74-0.0592-0.956-0.118-1.91-0.179-2.9-0.715-9.63-2.6-17.7-6.19-26.7l-1-3h-2v-2h-2zm1462 22 1 4zm-9 40c-1.75 2.33-2.83 4.29-3.5 7.12-0.5 1.88-0.5 1.88-1.94 3.23-1.8 1.89-2.32 3.29-3.06 5.77-0.246 0.799-0.492 1.6-0.746 2.42-0.373 1.21-0.373 1.21-0.754 2.45-0.52 1.46-1.04 2.92-1.56 4.38-1.46 4.32-2.23 8.65-2.91 13.1-0.527 2.48-0.527 2.48-1.53 4.36-1.09 2.31-1.36 4.06-1.56 6.6-0.0748 0.835-0.15 1.67-0.227 2.53-0.141 1.75-0.282 3.51-0.422 5.26-0.0748 0.833-0.15 1.67-0.227 2.52-0.0606 0.76-0.121 1.52-0.184 2.3-0.379 1.91-0.379 1.91-2.38 3.91-0.373 2.91-0.373 2.91-0.414 6.32-0.0387 1.26-0.0773 2.51-0.117 3.81-0.0309 1.32-0.0619 2.64-0.0938 4-0.0382 1.34-0.0772 2.68-0.117 4.02-0.0945 3.29-0.18 6.57-0.258 9.86h-2c-1.4 2.79-1.13 5.1-1.15 8.22-0.00638 1.31-0.0128 2.62-0.0193 3.96-0.00153 1.44-0.00264 2.87-0.00337 4.31-0.00321 1.47-0.00658 2.93-0.0101 4.4-0.00599 3.08-0.00784 6.16-0.00725 9.24 1.02e-4 3.94-0.0135 7.89-0.0308 11.8-0.0111 3.03-0.0131 6.06-0.0126 9.1-0.00118 1.45-0.0056 2.91-0.0133 4.36-0.00981 2.03-0.00566 4.07-8.95e-4 6.1-0.00143 1.16-0.00285 2.32-0.00432 3.51 0.243 2.93 0.547 4.6 2.25 6.97 3.27 1.27 3.27 1.27 7 1 6.6-3.62 7.82-9.13 10-16 0.703-1.84 1.41-3.67 2.12-5.5 1.71-4.65 2.68-9.2 3.38-14.1 0.492-2.41 0.492-2.41 1.52-4.35 1.67-3.53 1.38-7.33 1.53-11.2 0.441-2.88 0.441-2.88 1.94-4.7 1.91-2.77 1.9-4.52 1.94-7.86 0.0264-1.09 0.0529-2.18 0.0801-3.31 0.0203-1.7 0.0203-1.7 0.041-3.44 0.0346-2.25 0.0772-4.5 0.129-6.75 0.0123-0.996 0.0247-1.99 0.0374-3.02 0.284-2.93 1.05-5.13 2.27-7.8h1c0.0937-7.4 0.164-14.8 0.207-22.2 0.0207-3.44 0.0486-6.88 0.0945-10.3 0.628-22.1 0.628-22.1-4.3-43.5l-2-1v-2h-4zm9 13 1 4zm-1459 99.3c-1.67 2.14-1.74 3.2-1.75 5.89-0.00946 0.832-0.0189 1.66-0.0287 2.52 0.00607 0.897 0.0121 1.79 0.0184 2.72-0.00287 0.929-0.00574 1.86-0.0087 2.81-0.00204 1.97 0.0035 3.94 0.016 5.91 0.0159 2.99 2.15e-4 5.98-0.019 8.97 0.00198 1.92 0.00583 3.83 0.0117 5.75-0.00607 0.885-0.0121 1.77-0.0184 2.68 0.0586 5.27 0.831 9.59 2.73 14.5 1.06 3.07 1.14 6.07 1.25 9.29 0.154 4.23 0.44 6.99 2.44 10.7 0.525 2.05 0.999 4.12 1.44 6.19 1.02 4.62 2.23 9.02 3.81 13.5 1.25 3.88 2.11 7.86 3.01 11.8 0.573 2.65 0.573 2.65 2.75 4.5 0.565 1.96 1.06 3.95 1.5 5.94 0.821 3.67 1.39 5.9 3.5 9.06 0.43 1.51 0.822 3.03 1.19 4.56 1.46 5.13 3.9 8.88 7.09 13.1 1.75 2.36 3.23 4.8 4.72 7.32 1.63 2.46 1.63 2.46 4 4 3.69-0.146 3.69-0.146 7-1 3.39-6.99 3.43-13.5 3.34-21.1-0.0238-2.05-0.0205-4.09-0.0139-6.14-0.0368-6.75-0.288-11.6-3.32-17.7-0.346-2.16-0.652-4.33-0.938-6.5-1.4-10.4-1.4-10.4-4.06-20.5-1.13-3.75-2.12-7.48-2.94-11.3-1.83-8.89-1.83-8.89-5.53-17.1-1.77-3.03-2.64-5.93-3.59-9.31-1.17-4.62-1.17-4.62-3.94-8.31-0.719-2.32-1.39-4.65-2-7h-2l-3-10h-2l-0.938-3.31c-0.646-2.24-1.32-4.47-2.06-6.69h-2c-0.309-0.969-0.619-1.94-0.938-2.94-0.758-2.9-0.758-2.9-2.06-4.06-3.58-0.387-3.58-0.387-6.64 1.26zm1444 38.7 1 2zm-1500 22 1 2zm1480 9c-1.54 1.37-1.54 1.37-3 3v2h-3l-1 3-2 0.938-2 1.06-1 4-1.94 0.938c-2.29 0.928-2.29 0.928-3.31 3.5-0.89 2.6-0.89 2.6-0.75 5.56h-2c-2.29 4.81-2.29 4.81-3 10h-2c-0.381 1.01-0.381 1.01-0.77 2.05-0.344 0.892-0.688 1.78-1.04 2.7-0.336 0.882-0.673 1.76-1.02 2.67-1.17 2.58-1.17 2.58-2.77 4.68-2.03 2.75-1.97 5.56-2.4 8.9l-2 2c-0.614 2.19-1.15 4.4-1.62 6.62-0.26 1.19-0.521 2.38-0.789 3.6-0.29 1.37-0.29 1.37-0.586 2.77h-2c-2.06 5.11-3.23 9.52-4 15l-2 2c-0.569 2.03-0.569 2.03-0.938 4.31-0.776 3.8-1.87 6.45-4.06 9.69-3.01 5.01-3.29 8.3-3 14h-2c-1.61 2.68-2.07 4.52-2.5 7.69l-0.5 3.31-2 1c-0.578 1.94-1.06 3.9-1.5 5.88-0.819 3.69-1.38 5.95-3.5 9.12 0.0912 3.46 0.97 4.96 3.06 7.75 3.95 3.03 5.97 3.25 10.9 3.25 5.67-2.11 8.44-7.37 11.4-12.4 2.35-3.89 4.92-7.63 7.46-11.4 4.24-6.42 8.16-12.9 11.8-19.7 0.382-0.708 0.763-1.42 1.16-2.14 2.48-4.68 4.43-9.37 6.22-14.4l1.62-3.62c1.3-3.18 1.96-5.98 2.38-9.38h2c0.254-0.941 0.508-1.88 0.77-2.85 0.344-1.25 0.688-2.49 1.04-3.77 0.336-1.23 0.673-2.46 1.02-3.73 1.17-3.65 1.17-3.65 2.64-6.52 1.97-4.05 3-8.14 4.09-12.5 0.208-0.812 0.416-1.62 0.631-2.46 0.414-1.62 0.822-3.24 1.22-4.87 0.521-2.04 1.12-4.07 1.73-6.08 1.41-5.64 1.07-11.4 0.98-17.2-0.00902-1.16-0.018-2.31-0.0273-3.5-0.0234-2.83-0.0562-5.66-0.0977-8.5h-2l-0.875-3.44-1.12-3.56-2-1zm-1380 24 1 2zm1 8 1 3zm-86 19 1 2zm93.3 57.1c-3.07 4.4-1.88 10.8-1.31 15.9 1.31 4.52 3.06 8.72 5 13 0.354 0.897 0.709 1.79 1.07 2.72 1.06 2.62 2.46 4.87 3.93 7.28 1.02 1.99 2.02 3.99 3 6 1.23 2.46 2.45 4.91 3.69 7.36 0.85 1.71 1.68 3.43 2.5 5.16 2.57 5.37 5.56 10 9.06 14.8 1.87 2.83 3.27 5.69 4.69 8.77 2.4 5.04 5.16 8.27 9.25 12 2.33 2.4 3.42 4.88 4.74 7.92 1.64 3 4.06 5.05 6.54 7.36 1.52 1.59 1.52 1.59 2.52 4.15 1.35 3.3 3.55 4.78 6.34 6.91 1.66 1.53 1.66 1.53 2.58 3.46 3.23 6.21 11.8 11.2 18.1 14.1 1.39 0.236 2.79 0.423 4.19 0.562 5.29 0.607 5.29 0.607 7.81 3.44 0.356 2.97 0.504 5.66 0.5 8.62 0.178 6.94 0.791 12.3 4.5 18.4l1.62 3.06c0.681 0.959 0.681 0.959 1.38 1.94h2v2h2c0.186 0.825 0.371 1.65 0.562 2.5 2.19 5.32 6.01 9.14 10.1 13.1 1.34 1.39 1.34 1.39 2.34 3.39h2c0.0619 0.722 0.124 1.44 0.188 2.19 1.08 3.73 2.98 5.17 5.81 7.81 1.58 1.86 3.13 3.74 4.67 5.64 0.44 0.447 0.879 0.895 1.33 1.36h2v2c1.1 1.17 2.22 2.33 3.38 3.44 1.19 1.15 2.35 2.33 3.48 3.52 4.12 4.31 7.85 7.29 13.1 10l2.31 1.75c1.61 1.45 1.61 1.45 3.69 1.25v2h2v2c1.13 1.2 2.28 2.39 3.48 3.53 1.52 1.47 1.52 1.47 2.92 3.04 5.16 5.64 11.5 9.45 17.9 13.4 1.48 0.911 2.94 1.85 4.39 2.8 6.11 3.91 12.3 6.21 19.3 8.23-0.461-6.24-1.94-10.7-4.88-16.2-0.352-0.685-0.704-1.37-1.07-2.08-3.58-7.05-3.58-7.05-8.5-13.2-2.66-2.66-4.54-5.39-6.56-8.56-1.52-2.3-1.52-2.3-3-4h-2c-0.248-0.578-0.495-1.16-0.75-1.75-1.16-2.34-1.16-2.34-3.19-4.12-2.06-2.12-2.06-2.12-3.5-5.06-1.76-3.46-3.76-5.39-6.56-8.06-1.81-2.02-3.58-4.07-5.35-6.13-2.23-2.53-2.23-2.53-4.65-4.87h-2v-2c-1.33-1.3-1.33-1.3-3.06-2.62-3.36-2.78-6.1-5.78-8.91-9.1-3.32-3.72-6.97-7.13-10.6-10.6-2.52-2.78-3.79-5.38-5.45-8.71-1.61-1.73-3.28-3.39-5-5-2.36-2.41-4.68-4.86-7-7.31-0.603-0.626-1.21-1.25-1.83-1.9-3.57-3.78-6.48-7.56-9.09-12.1-1.65-2.63-3.84-4.6-6.09-6.73-3.46-3.78-6.5-7.51-9-12l-2-3h-2c-0.26-0.549-0.521-1.1-0.789-1.66-2.4-4.64-5.38-8.95-8.21-13.3-0.639-0.99-1.28-1.98-1.94-3-2.04-2.97-4.1-5.93-6.19-8.88-0.683-0.967-1.37-1.93-2.07-2.93-0.893-1.09-0.893-1.09-1.8-2.2h-2c-0.272-0.737-0.544-1.47-0.824-2.23-1.11-2.62-2.36-4.69-3.99-7.02-3.03-4.43-5.66-9.02-8.19-13.8h-2l-0.5-2.81c-1.36-4.82-4.43-8.29-7.42-12.2-2.06-2.94-3.57-5.83-5.08-9.09-2.45-5.2-5.45-9.03-9.46-13.1-1.54-1.74-1.54-1.74-1.54-3.74h-2c-0.218-0.696-0.436-1.39-0.66-2.11-1.68-3.62-4.07-6.27-6.78-9.14-0.49-0.541-0.981-1.08-1.49-1.64-3.48-3.75-5.42-4.99-10.6-5.36-3.35-0.0488-3.35-0.0488-5.19 1.37zm1280 67.5c-4.75 4.28-6.33 8.11-7.65 14.3-1.14 3.97-2.88 7.39-4.84 11-0.336 0.63-0.673 1.26-1.02 1.91-2.04 3.72-4.39 6.92-7.04 10.2-1.26 3.18-1.26 3.18-2 6h-2c-2.24 3.07-4.02 6.04-5.75 9.44-2.5 4.48-6.35 7.34-10.2 10.6-3.14 2.78-5.15 5.1-6.88 8.88-1.41 3.05-2.78 4.88-5.31 7.06-6.04 5.64-9.19 13.8-12.8 21.1-0.532 1.04-1.06 2.08-1.61 3.15-2.81 5.5-5.34 10.7-6.39 16.8 0.99 0.351 1.98 0.701 3 1.06 0.557 0.197 1.11 0.394 1.69 0.598 4.48 0.658 8.47 0.593 12.3-1.98 2.04-1.84 3.95-3.76 5.84-5.75 1.06-1.07 1.06-1.07 2.14-2.17 2.25-2.28 4.47-4.58 6.69-6.89 1.5-1.53 3-3.05 4.51-4.58 11.2-9.55 11.2-9.55 17.9-21.3h2c1.26-1.69 1.26-1.69 2.44-3.81 1.28-2.21 2.36-4 4.22-5.76 1.68-1.46 1.68-1.46 1.34-4.43 0.99-0.33 1.98-0.66 3-1 0.702-1.32 1.37-2.65 2-4 0.44-0.434 0.879-0.869 1.33-1.32 2.06-2.08 3.67-4.35 5.36-6.75 0.623-0.878 1.25-1.76 1.89-2.66 1.6-2.11 1.6-2.11 1.43-4.28 0.99-0.33 1.98-0.66 3-1 0.674-1.66 1.34-3.33 2-5 0.907-0.88 0.907-0.88 1.83-1.78 4.45-4.56 7.16-10.6 10.2-16.2 0.384-0.71 0.767-1.42 1.16-2.15 1.15-2.15 2.28-4.31 3.4-6.47 0.359-0.675 0.717-1.35 1.09-2.04 1.31-2.59 2.36-4.69 2.33-7.62-1.34-2.34-2.79-3.13-5.16-4.39-1.14-0.625-1.14-0.625-2.29-1.26-7.77-3.24-16-2.03-23 2.55zm-114 151-1 2c-1.95 1.08-3.96 1.98-5.99 2.9-2.11 1.15-3.37 2.36-5.01 4.1-2.11 1.81-4.23 3.6-6.36 5.38-0.814 0.802-0.814 0.802-1.64 1.62v2l-2.69 0.188c-4.11 1.01-5.55 2.68-8.31 5.81l-1.81 1.69c-1.41 1.26-1.41 1.26-1.19 3.31-0.619 0.0825-1.24 0.165-1.88 0.25-2.3 0.544-2.3 0.544-3.19 2.75-0.309 0.66-0.619 1.32-0.938 2-0.99 0.33-1.98 0.66-3 1-0.682 1.33-1.35 2.66-2 4-1.7 1.64-1.7 1.64-3.69 3.25-2.87 2.42-5.39 4.88-7.81 7.75-2.91 3.44-6.07 6.3-9.52 9.2-2.71 2.46-5.02 5.18-7.34 8-1.64 1.8-1.64 1.8-3.84 3.41-0.889 0.688-0.889 0.688-1.8 1.39v2h-3l-1.25 3.75c-1.04 2.85-1.59 4.11-3.88 6.19-2.91 3.2-2.7 6.86-2.88 11.1 4.94 1.7 8.5 0.148 13-2 4.49-2.6 8.84-5.43 13.2-8.23 3.02-1.92 6.07-3.79 9.14-5.63 1.77-1.22 3.14-2.61 4.66-4.14l3-2v-2l2.44-0.875c2.7-0.858 2.7-0.858 3.56-3.12l3.12-1.62c3.89-2.13 6.25-4.91 9.05-8.3 1.83-2.09 3.76-3.85 5.88-5.64 3.24-2.74 5.96-5.64 8.61-8.96 1.32-1.48 1.32-1.48 4.32-3.48v-3l2.12-0.562c3.92-1.96 6.41-4.84 8.88-8.44v-2l1.94-0.812c2.39-1.07 2.39-1.07 3.06-4.19 1.33-0.667 2.67-1.33 4-2l1-3c0.99-0.33 1.98-0.66 3-1l2-6c0.99-0.33 1.98-0.66 3-1 1.7-2.37 1.7-2.37 3.19-5.25 0.53-0.954 1.06-1.91 1.61-2.89 1.22-2.9 1.46-4.75 1.21-7.86-8.63-0.412-17.7 4.67-25 9zm-940 62.1c-1.77 3.24-2.18 5.21-2.06 8.94 1.84 3.12 4.42 5.48 7 8 1.06 1.07 2.13 2.15 3.19 3.22 2.75 2.78 5.52 5.54 8.32 8.29 1.37 1.36 2.71 2.76 4.04 4.16 2.54 2.42 5.08 4.15 8.08 5.96 3.18 1.92 5.8 3.72 8.38 6.38l2.56 1.25c5.51 2.81 10.4 6.53 15.4 10.2 2.84 2.07 5.67 3.98 8.73 5.7 3.31 1.88 3.31 1.88 5.19 3.32 2.38 1.74 4.78 2.96 7.44 4.24 4.87 2.39 9.66 4.87 14.4 7.44 1.28 0.685 2.57 1.37 3.85 2.05 1.9 1.02 3.79 2.04 5.67 3.08 7.57 4.06 16.1 7.11 24.7 6.74v-2c3.46-0.495 3.46-0.495 7-1 0.462-7.57-2.77-14.3-7.71-20-3.19-2.83-6.66-4.89-10.4-6.91-3.06-1.83-5.76-4.11-8.55-6.32-4.79-3.71-9.83-7.02-15.1-9.93-3.19-1.88-3.19-1.88-5.19-3.94-2.68-2.6-5.56-3.54-9-4.94-1.28-0.71-2.55-1.44-3.81-2.19-2.87-1.98-2.87-1.98-5.19-1.81l-1-3c-2.58-1.5-2.58-1.5-6-3-1.48-0.746-2.96-1.5-4.44-2.25-3.56-1.78-7.14-3.49-10.8-5.14-7.76-3.56-15.3-7.45-22.8-11.5-1.32-0.706-2.65-1.41-3.97-2.11-0.703-0.377-1.41-0.755-2.13-1.14-0.694-0.363-1.39-0.725-2.1-1.1-0.62-0.327-1.24-0.655-1.88-0.992-3.89-1.58-8.07-1.76-11.8 0.296zm899 4.94 1 2 1-2h-2zm-94.3 32.6c-4.29 2.3-8.98 3.27-13.7 4.44v2c-0.641 0.17-1.28 0.34-1.94 0.516-5.6 1.57-10.1 3.44-15.1 6.48-1.99 1.02-3.99 2.02-6 3-1.58 0.791-3.17 1.58-4.75 2.38-2.6 1.3-5.2 2.6-7.8 3.88-7.27 3.6-14.4 7.28-21.1 11.9-2.69 1.84-5.23 3.35-8.25 4.56-3.01 1.26-3.98 2.03-6.12 4.31-3.93 3.75-7.69 6.98-12.6 9.44-7.14 3.75-12.1 10.3-15.4 17.6-0.195 2.79-0.195 2.79 1 5 3.67 2.65 7.79 2.3 12.1 2.25 1.09 0.0116 1.09 0.0116 2.21 0.0234 4.3 0.128 4.3 0.128 7.67-2.27 2.4-0.485 4.77-0.886 7.19-1.25 19.1-3.26 36.2-13.8 53.1-22.8 2.36-1.26 4.72-2.47 7.11-3.65 2.48-1.25 4.42-2.66 6.63-4.33 1.66-0.946 3.33-1.89 5-2.82 3.78-2.22 7.38-4.72 11-7.18l3-2v-2l1.69-0.688c4-2.27 6.85-4.93 8.31-9.31l2-0.938c2.21-0.883 2.21-0.883 2.75-3.19l0.25-1.88h2c2.65-4.53 3.75-7.75 3-13-1.83-3.58-1.83-3.58-5-6-7.32-1.2-12.3 1.53-18.3 5.56zm24.3 2.44 1 3zm-674 52c-1.3 1.85-1.3 1.85-1 4 4.99 7.22 12.3 11.2 20 15 1.41 0.749 2.83 1.5 4.23 2.26 1.12 0.6 1.12 0.6 2.26 1.21 1.47 0.789 2.94 1.58 4.41 2.37 6.18 3.28 12.4 6.03 19.1 8.16 5.17 1.69 10.1 3.68 15 5.93 6.15 2.65 12.4 4.24 18.9 5.67 3.09 0.681 6.05 1.39 9.06 2.42 3.75 1.22 7.49 1.85 11.4 2.48 4.21 0.689 8.28 1.4 12.4 2.59 5.51 1.43 11.1 1.13 16.7 1.04 1.66-0.0135 1.66-0.0135 3.36-0.0273 2.71-0.0234 5.43-0.0562 8.14-0.0977l1-3 5-1c-0.295-1.67-0.639-3.34-1-5-0.173-0.963-0.345-1.93-0.523-2.92-2.15-4.49-5.27-5.42-9.73-7.27-1.51-0.66-3.01-1.32-4.52-1.98-0.725-0.31-1.45-0.62-2.2-0.939-2.73-1.2-5.38-2.55-8.04-3.89-6.26-2.83-12.5-4.71-19.2-6.29-3.74-0.946-7.23-2.28-10.8-3.71-6.92-2.72-13.7-4.7-21-6.29-3.83-0.911-7.36-2.25-11-3.71-6.23-2.3-12.5-3.88-19-5.31-2.18-0.502-4.35-1.1-6.49-1.75-11-2.94-26.4-6.5-36.5 0.0625zm487 15-2 2c-2.02 0.379-2.02 0.379-4.46 0.562-1.32 0.112-1.32 0.112-2.67 0.227-0.924 0.0696-1.85 0.139-2.8 0.211-1.82 0.138-3.64 0.283-5.46 0.438-0.809 0.0606-1.62 0.121-2.45 0.184-2.43 0.282-2.43 0.282-5.14 2.38-2.56 0.413-5.05 0.74-7.62 1-8.36 0.95-16 2.49-24 5.28-3.65 1.09-7.36 1.64-11.1 2.2-2.47 0.357-2.47 0.357-4.29 2.53-1.69 0.506-3.4 0.93-5.12 1.31-12.6 3.01-24.3 6.93-35.9 12.7-1.23 0.576-1.23 0.576-2.48 1.16-3.4 1.62-5.89 3.2-8.52 5.84-1.67 0.667-3.33 1.33-5 2-1.58 1.42-1.58 1.42-3 3l-2.12 1.25c-2.79 2.6-2.67 5.05-2.88 8.75l1 2h9v2c2.75 0.027 5.5 0.0468 8.25 0.0625 0.777 0.00838 1.55 0.0168 2.36 0.0254 0.754 0.00322 1.51 0.00645 2.29 0.00977 0.691 0.00524 1.38 0.0105 2.09 0.0159 2.12-0.119 3.96-0.58 6.01-1.11 2.37-0.154 4.75-0.274 7.12-0.375 6.24-0.326 12.3-1.04 18.5-2.06 0.745-0.122 1.49-0.245 2.26-0.371 4.2-0.731 8.09-1.77 12.1-3.19 1.77-0.493 3.54-0.972 5.31-1.44 3.47-0.928 6.86-1.94 10.2-3.12 3.15-1.08 6.23-1.83 9.5-2.44 3.91-0.726 7.41-1.81 11.1-3.29 1.85-0.711 1.85-0.711 5.1-1.59 4.42-1.33 8.57-3.09 12.8-4.89 4.41-1.85 8.88-3.5 13.4-5.11 5.33-2.34 10.5-4.84 14.6-9.12l2.19-1.81c2.04-2.11 2.04-2.11 2.38-5.12-0.779-4.24-2.06-5.56-5.56-8.06-2.37-0.445-4.6-0.624-7.01-0.664-0.656-0.111-1.31-0.222-1.99-0.336l-2-3h-4zm-273 32c-2.95 0.207-5.86 0.32-8.81 0.375-8.28 0.289-15.4 1.62-23.2 4.62-0.763 0.26-1.53 0.521-2.31 0.789-2.13 0.726-2.13 0.726-4.69 2.21-1.04 2.07-1.04 2.07-1 4 4.32 3.3 8.29 4.88 13.5 6.29 2.46 0.711 2.46 0.711 4.85 1.76 3.17 1.15 6 1.33 9.36 1.51 6.15 0.338 6.15 0.338 7.25 1.44 2.33 0.21 4.66 0.368 7 0.5 6.89 0.389 6.89 0.389 8 1.5 1.81 0.099 3.61 0.128 5.42 0.129 1.16 0.00315 2.32 0.0063 3.51 0.00955 1.26-0.00202 2.52-0.00405 3.82-0.00613 1.93 0.00144 1.93 0.00144 3.89 0.0029 2.72 0.00148 5.44-6.76e-4 8.16-0.00534 3.49-0.0057 6.99-0.00242 10.5 0.00357 3.32 0.00447 6.64 0.00135 9.97-0.00113 1.26 0.00202 2.52 0.00405 3.82 0.00613 1.16-0.00315 2.32-0.0063 3.51-0.00955 1.54-0.00119 1.54-0.00119 3.11-0.00241 2.28 0.133 2.28 0.133 3.32-1.13 1.61-0.145 3.22-0.227 4.84-0.281 0.98-0.0374 1.96-0.0748 2.97-0.113 1.55-0.0522 1.55-0.0522 3.13-0.105 2.03-0.0687 4.06-0.141 6.09-0.219 1.36-0.0454 1.36-0.0454 2.74-0.0918 2.27-0.0541 2.27-0.0541 4.23-1.19 2.33-0.0525 4.67-0.0921 7-0.125 7.45-0.295 12.7-2.52 18-7.88l1-3c-2.26-3.38-2.83-3.54-6.56-4.56-0.898-0.248-1.8-0.495-2.72-0.75-3.15-0.797-6.29-1.56-9.47-2.22-1.46-0.305-2.91-0.637-4.36-1-6.75-1.59-13.5-1.85-20.4-2.04-0.797-0.0283-1.59-0.0566-2.41-0.0857-0.717-0.0187-1.43-0.0374-2.17-0.0566-1.93-0.287-1.93-0.287-4.93-2.29-1.94-0.365-1.94-0.365-4.09-0.414-0.834-0.0388-1.67-0.0777-2.53-0.118-0.911-0.0308-1.82-0.0616-2.76-0.0933-0.954-0.0372-1.91-0.0744-2.89-0.113-8.26-0.286-16.5-0.365-24.8-0.387-1.78-0.00701-1.78-0.00701-3.6-0.0142-13.6-1.01-13.6-1.01-25.3 3.14zm-63 0 1 3zm60 24v1h12v-1h-12zm72 0v1h21v-1h-21zm69 0v1h7v-1h-7zm31 0v1h12v-1h-12z" fill="#FBFDFD"/>
    <path transform="translate(62,779)" d="m0 0h1v21h-1v-21z" fill="#000100"/>
    <path transform="translate(1535,709)" d="m0 0h1v14h-1v-14z" fill="#FCFEFE"/>
    <path transform="translate(62,841)" d="m0 0h1v12h-1v-12z" fill="#000100"/>
    <path transform="translate(873,1535)" d="m0 0h5v1h-5v-1z" fill="#FCFEFE"/>
    <path transform="translate(1535,864)" d="m0 0 1 4z" fill="#FCFEFE"/>
    <path transform="translate(186,404)" d="m0 0 4 1z" fill="#000100"/>
    <path transform="translate(733,61)" d="m0 0 4 1z" fill="#3F403F"/>
    <path transform="translate(885,1535)" d="m0 0 2 1z" fill="#000100"/>
    <path transform="translate(698,1516)" d="m0 0 2 1z" fill="#000100"/>
    <path transform="translate(197,405)" d="m0 0 2 1z" fill="#000100"/>
</svg>`,


                    content: `<div style=" z-index: 4;  display: inline-block; height: 96px;  width: 96px;background-color: #ff0000; font-size: 16px;   color: #fff; border-radius: 100%; padding: 4px; text-align: center;">
    <div style="height: 88px;width: 88px;  border: 2px dashed #fff;  border-radius: 100%; padding: 2px; position: relative;">
        <div style="position: absolute;top: 17%; left: 22%;">
            <span style="   font-weight: 700;  padding-top: 20px;  font-size: 32px; padding: 2px;">96</span>%<br>
            off
        </div>
    </div>
</div>`

                });




                function myFunction() {

                    const htmlObj = {
                        html: editor.getHtml(),
                        css: editor.getCss()

                    }

                    console.warn('current html', htmlObj)
                    setHtml(htmlObj)

                    // Your code here


                }

                editor.on('load', myFunction);
                editor.on('update', (some, argument) => {
                    let html = editor.getHtml()
                    //    alert(JSON.stringify(html))
                    //  alert('jjj')


                    //  editor.getSelected()

                    let cc = editor.DomComponents.getComponents()

                })



                editor.Storage.add('remote', {
                    async load() {

                        data = await server.get(`${getPage}`);
                        setLoading(false)

                        const divs = document.getElementsByClassName('form-group');
                        // alert(JSON.stringify(divs))
                        for (let x = 0; x < divs.length; x++) {
                            const div = divs[x];
                            const content = div.textContent.trim();
                            // alert('cc')
                            if (content == 'Handtekening' || content == 'Message') {
                                div.style.display = 'none';
                            }
                        }


                        // setDraftData(data?.data?.data?.draft_body)

                        // alert(data?.data?.data?.draft_body)
                        setStatus(data?.data?.data.status)
                        console.log('status', status);
                        setPageDetail(data?.data?.data)
                        setseoPgeTitle(data?.data?.data?.seo_setting?.seo_title);
                        setseoPgeKeyword(data?.data?.data?.seo_setting?.seo_keyword);
                        setseoPgeDescription(data?.data?.data?.seo_setting?.seo_description);
                        console.log('seo keywords', seoPgeKeyword);
                        console.log('seo title ', seoPgeTitle);
                        return data
                    },




                    async store(data) {
                        // Set loading to true when starting the operation
                        setDraftLoading(true);

                        try {
                            const obj = {
                                page_id: editorpage,
                                draft_body: JSON.stringify(data),
                            };



                            const htmlObj = {
                                html: editor.getHtml(),
                                css: editor.getCss()

                            }

                            // console.warn('current html',htmlObj)
                            setHtml(htmlObj)


                            // Perform your asynchronous operation (e.g., making an API request)
                            const response = await server.post(`${updatePage}`, obj);

                            // Set loading back to false when the operation is complete
                            setDraftLoading(false);

                            return response;
                        } catch (error) {
                            // Handle errors if needed
                            setDraftLoading(false);
                            alert(error);
                        }
                    }
                });
                const panelManager = editor.Panels;
                let editPanel2 = null

                var newPanel = panelManager.addPanel({
                    id: 'myNewPanel',
                    className: 'MyNewpanle',
                    visible: true,
                    buttons: [
                        {
                            id: 'backbtn',
                            command: {
                                run: () => {
                                    navigate(-1)
                                }
                            },
                            className: 'fa fa-arrow-left',
                        },
                        {
                            id: 'cmdDeviceDesktop',
                            command: e => e.setDevice('Desktop'),
                            className: 'fa fa-desktop',
                            active: 1,
                        },
                        {
                            id: 'cmdDeviceTablet',
                            command: e => e.setDevice('Tablet'),
                            className: 'fa fa-tablet',
                        },
                        {
                            id: 'cmdDeviceMobile',
                            command: e => e.setDevice('Mobile portrait'),
                            className: 'fa fa-mobile',
                        },
                        {

                            id: 'Publish',
                            label: `<button  type="button"  class="ccc btn btn-secondary Mydropdowntoogle" > 
                                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="11" width="11" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M477.64 38.26a4.75 4.75 0 00-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 00-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0010.55 11.2l87.31-9.63a194.1 194.1 0 001.19 19.7 19.53 19.53 0 005.7 12L170.7 375a19.59 19.59 0 0012 5.7 193.53 193.53 0 0019.59 1.19l-9.58 87.2a9.65 9.65 0 0011.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5 8.4-19.27 10.12-41.77 8.18-64.27a317.66 317.66 0 0042.21-35.64C441 232.05 491.74 99.74 477.64 38.26zM294.07 217.93a48 48 0 1167.86 0 47.95 47.95 0 01-67.86 0z"></path>
                                        <path d="M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46-23.77 4.05-44.76-16.49-40.49-40.52 1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 00-3.65-7.45 60 60 0 00-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.69 59.69 0 00176 403.09c.37-4.18-4.72-6.67-7.6-3.66z"></path>
                                    </svg>
                               <span class="px-2 fw-semibold"> ${draftLoading ? 'loading' : 'publish'}  <span>
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" 
                                viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                                <path fill="none" d="M0 0h24v24H0z"></path><path d="M7 10l5 5 5-5z"></path></svg>
                                </span> </span>
                                 
                            `,
                            active: 1,
                            command: {
                                run: async () => {



                                    setPublishOpen(true)


                                    // alert(editor.getHtml())
                                    const htmlObj = {
                                        html: editor.getHtml(),
                                        css: editor.getCss()

                                    }
                                    setHtml(htmlObj)

                                }
                            },
                        },
                        {
                            id: 'Draft',
                            label: '',
                            command: {
                                run: () => {

                                }
                            },
                        },

                    ],
                });
                return editor

            }


            // updateGrapeJs =='start'    ?  init() :''
            let editor = init()

            setEditor(editor)


            const pn = editor.Panels;
            let editPanel = null;
            let seoBtnTags = null; // Initialize outside the run function
            let googleBtnTags = null; // Initialize outside the run function
            let microsoftBtnTags = null; // Initialize outside the run function
            let googleIdBtnTags = null; // Initialize outside the run function
            let generalBtnTags = null; // Initialize outside the run function
            let isApiCallInProgress = false;



            editor.addComponents('<style>  </style>');

            pn.addButton('views',
                [
                    {
                        id: 'seo',
                        className: 'fa fa-cogs',
                        command: {
                            label: 'Custom Block',
                            category: 'Custom Category',
                            attributes: {
                                class: 'gjs-fonts gjs-f-b1',
                            },
                            run: function (editor) {
                                // editPanel = null
                                if (editPanel == null) {
                                    // alert('initial')
                                    const editMenuDiv = document.createElement('div')
                                    const btnn = editMenuDiv.getElementsByClassName('seo-tags-heading');
                                    // btnn[0].addEventListener('click',function (e){
                                    //
                                    // })
                                    editMenuDiv.innerHTML = `
                        <div class="gjs-block-category ">
                          <div class="gjs-title seo-tags-heading" >
                            <i class="gjs-caret-icon fa fa-caret-down"></i>
                            Seo Setting
                          </div>

                         
                          <div class="gjs-blocks-c seo-block">
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Page Title 
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <input class="custom-seo-input custom-seo-input-title" placeholder="Enter SEO title" name="pageTitle"  />
                                </div>
                                <p class="custom-seo-label m-0">Max 70 characters</p>

                              </div>


                           <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Keywords (comma separated) 
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <input class="custom-seo-input custom-seo-input-keyword" placeholder="Marketing, Subscription, Email etc." name="Keywords" />
                                </div>
                              </div>  
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Description 
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <textarea class="custom-seo-textarea custom-seo-input-description" placeholder="Enter SEO description" name="description"  maxlength="5000"></textarea>
                                </div>
                                 <p class="custom-seo-label m-0">Max 200 words</p>
                              </div>
                               <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Page slug *
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <input class="custom-seo-input custom-seo-input-slug" placeholder="Enter the page slug" />
                                </div>
                                 <button type="button" class="btn btn-primary savbtnnn d-flex fs-12 mb-3 shadow-none"  disabled>Save <div role="status" class="spinner-border save-spinner"><span class="visually-hidden">Loading...</span></div></button>
                               
                              </div>  
                          </div>
                        </div>

                        <div  class="gjs-block-category ">
                        <div class="gjs-title googleId-tags-heading" >
                                <i class="gjs-caret-icon fa fa-caret-down"></i>
                               Google Scripts
                          </div>
                          <div class="gjs-blocks-c googleId-block">
                              
                          <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                          <div class="gjs-sm-label gjs-four-color" data-sm-label="" ">
                              <span class="gjs-sm-icon" title="">
                                  Google Conversion ID ${data?.data?.data?.script_setting?.google_conversion_id ?  `<img src=${Checked} style="width:20px; height:20px;margin-left:5px" alt="Description" />`: ''}
                              </span>
                          </div>
                          <div class="gjs-fields" data-sm-fields="">
                              <input class="custom-seo-input google_conversion_id" placeholder="Enter Google Conversion ID" />
                          </div>
                      </div>
                      
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                
                                 <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                        <span class="gjs-sm-icon " title="">
                                        Conversion Label 
                                              </span>
                                         </div>                                  
                                      <div class="gjs-fields " data-sm-fields="">
                                        <input class="custom-seo-input google_label_id" placeholder="Enter Conversion Label                                        " />
                                    </div>



                                    <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                              <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                  <span class="gjs-sm-icon " title="">
                                    Google Meta Tag
                                  </span>
                              </div>
                              <div class="gjs-fields" data-sm-fields="">
                                <input class="custom-seo-input google-verification" placeholder="Enter Google Meta Tag" />
                            </div>
                          </div>   


                                    <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">

                                      <span class="gjs-sm-icon " title="">

                                        Google Analytics ID
                                        ${data?.data?.data?.script_setting?.google_analytics_id ?  `<img  src=${Checked} style="width:20px; height:20px;margin-left:5px" alt="Description" />`: ''}

                                        </span>

                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <input class="custom-seo-input google-analyticsId" placeholder="UA-0000000-02" />
                                </div>
                              </div>   


                              


                                     <button type="button" class="btn btn-primary google-save-btn d-flex fs-12 mb-3"  >
                                         Save
                                         <div role="status" class="spinner-border save-spinner save-spinner-googleId"><span class="visually-hidden">Loading...</span></div>
                                          
                                          </button>
                              </div>  
                              
                                           
                            </div>
                        </div>

                        <div class="gjs-block-category d-none">
                          <div class="gjs-title google-tags-heading" >
                            <i class="gjs-caret-icon fa fa-caret-down"></i>
                            Tracking Codes
                          </div>
                          <div class="gjs-blocks-c google-block">
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full d-none">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Google Maps API Key 
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <input class="custom-seo-input" placeholder="enter API Key "/>
                                </div>
                              </div>
                             
                                      
                                 <button type="button" class="btn btn-primary tracking-code-save-btn d-flex fs-12 mb-3"  >
                                 Save
                                 <div role="status" class="spinner-border save-spinner save-spinner-tracking-code"><span class="visually-hidden">Loading...</span></div>
                                  
                                  </button>
                              </div>  
                            </div>
                        </div>                      
                        <div class="gjs-block-category ">
                          <div class="gjs-title microsoft-tags-heading" >
                                <i class="gjs-caret-icon fa fa-caret-down"></i>
                               Microsoft Scripts
                          </div>
                          <div class="gjs-blocks-c microsoft-block">
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                              <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                        <span class="gjs-sm-icon " title="">
                                          MS Site Verification Tag 
                                              </span>
                                         </div>                                  
                                <div class="gjs-fields " data-sm-fields="">
                                        <input class="custom-seo-input ms_verification_tag" placeholder="Enter MS Site Verification Tag " />
                               </div>
                              </div>
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                
                                 <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                        <span class="gjs-sm-icon " title="">
                                           MS UET Tag ID
                                              </span>
                                         </div>                                  
                                      <div class="gjs-fields " data-sm-fields="">
                                        <input class="custom-seo-input ms_uet_tag_id" placeholder="Enter MS Uet tag ID" />
                                    </div>
                                     <button type="button" class="btn btn-primary microsoft-save-btn d-flex fs-12 mb-3"  >
                                         Save
                                         <div role="status" class="spinner-border save-spinner save-spinner-microsoft"><span class="visually-hidden">Loading...</span></div>
                                          
                                          </button>
                              </div>  
                              
                                           
                            </div>
                        </div>
                        <div class="gjs-block-category ">
                          <div class="gjs-title general-tags-heading" >
                            <i class="gjs-caret-icon fa fa-caret-down"></i>
                            General Scripts
                          </div>
                          <div class="gjs-blocks-c general-block">
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Header
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <textarea class="custom-seo-textarea custom-head-input-description page_header_script" placeholder="Paste your code here" name="headdescription"  maxlength="5000"></textarea>
                                </div>
                                 <p class="custom-seo-label m-0">Enter javascript or css code into html document header.</p>
                              </div>
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Body
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <textarea class="custom-seo-textarea custom-body-input-description page_body_script" placeholder="Paste your code here" name="bodydescription"  maxlength="5000"></textarea>
                                </div>
                                 <p class="custom-seo-label m-0">Enter html, javascript or css right after the opening <body> tag.</p>
                              </div>
                              <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
                                  <div class="gjs-sm-label gjs-four-color" data-sm-label="">
                                      <span class="gjs-sm-icon " title="">
                                        Footer
                                      </span>
                                  </div>
                                  <div class="gjs-fields" data-sm-fields="">
                                    <textarea class="custom-seo-textarea custom-footer-input-description page_footer_script" placeholder="Paste your code here" name="footerdescription"  maxlength="5000"></textarea>
                                </div>
                                 <p class="custom-seo-label m-0">Enter html, javascript or css right before the closing <body> tag. </p>
                                 <button type="button" class="btn btn-primary general-save-btn d-flex fs-12 mb-3"  >
                                 Save
                                 <div role="status" class="spinner-border save-spinner save-spinner-general"><span class="visually-hidden">Loading...</span></div>
                                  
                                  </button>
                                 
                              </div>
                          </div>
                        </div>
                     
                     
                    `;

                                    const panels = pn.getPanel('views-container')
                                    panels.set('appendContent', editMenuDiv).trigger('change:appendContent')
                                    editPanel = editMenuDiv

                                    // alert('cc')
                                }
                                //console.log('cc')


                                editPanel.style.display = 'block';

                                //  console.log('block')
                                let seotitle = data?.data?.data?.seo_setting?.seo_title;
                                let seokeyword = data?.data?.data?.seo_setting?.seo_keyword;
                                let seodescription = data?.data?.data?.seo_setting?.seo_description;
                                let seoslugg = data?.data?.data?.url;
                                let googleAnalyticsId1 = data?.data?.data?.script_setting?.google_analytics_id;

                                let googleVerificationTag = data?.data?.data?.script_setting?.google_verification_tag ? decodeURIComponent(window.atob(data?.data?.data?.script_setting?.google_verification_tag)) : '';

                                // let facebook_id = data?.data?.data?.script_setting?.facebook_id;
                                // let twitter_id = data?.data?.data?.script_setting?.twitter_id;
                                let ms_verification_tag = data?.data?.data?.script_setting?.ms_verification_tag ? decodeURIComponent(window.atob(data?.data?.data?.script_setting?.ms_verification_tag)) : '';
                                let ms_uet_tag_id = data?.data?.data?.script_setting?.ms_uet_tag_id;
                                let page_header_script = data?.data?.data?.script_setting?.page_header_script ? decodeURIComponent(window.atob(data?.data?.data?.script_setting?.page_header_script)) : '';
                                let page_body_script = data?.data?.data?.script_setting?.page_body_script ? decodeURIComponent(window.atob(data?.data?.data?.script_setting?.page_body_script)) : '';
                                let page_footer_script = data?.data?.data?.script_setting?.page_footer_script ? decodeURIComponent(window.atob(data?.data?.data?.script_setting?.page_footer_script)) : '';
                                let google_conversion_id = data?.data?.data?.script_setting?.google_conversion_id
                                let google_label_id = data?.data?.data?.script_setting?.google_conversion_label


                                //  Modified  seo
                                const seoBlock = document.querySelector(".seo-block");
                                seoBlock.classList.add('d-none');

                                const CarrotIcon = document.querySelector(".seo-tags-heading i ");

                                CarrotIcon.classList.add('fa-caret-right')


                                //google tags

                                const googleBlock = document.querySelector(".google-block");
                                googleBlock.classList.add('d-none');
                                const googleIcon = document.querySelector(".google-tags-heading i ");
                                googleIcon.classList.add('fa-caret-right')


                                // microsoft bock

                                const microsoftBlock = document.querySelector(".microsoft-block");
                                microsoftBlock.classList.add('d-none');
                                const microsoftIcon = document.querySelector(".microsoft-tags-heading i ");

                                microsoftIcon.classList.add('fa-caret-right')


                                // google id block

                                const googleIdBlock = document.querySelector(".googleId-block");
                                googleIdBlock.classList.add('d-none');
                                const googleIdIcon = document.querySelector(".googleId-tags-heading i ");

                                googleIdIcon.classList.add('fa-caret-right')


                                //   general block


                                const generalBlock = document.querySelector(".general-block");
                                generalBlock.classList.add('d-none');
                                const generalIcon = document.querySelector(".general-tags-heading i ");

                                generalIcon.classList.add('fa-caret-right')



                                console.log(CarrotIcon);
                                if (seotitle === undefined) {
                                    seotitle = '';
                                }
                                if (seokeyword === undefined) {
                                    seokeyword = '';
                                }
                                if (seodescription === undefined) {
                                    seodescription = '';
                                }
                                if (seoslugg === undefined) {
                                    seoslugg = '';
                                }
                                if (googleAnalyticsId1 === undefined) {
                                    googleAnalyticsId1 = '';
                                }

                                if (googleVerificationTag === undefined) {
                                    googleVerificationTag = '';
                                }


                                // if (facebook_id === undefined) {
                                //     facebook_id = '';
                                // }
                                // if (twitter_id === undefined) {
                                //     twitter_id = '';
                                // }
                                if (ms_verification_tag === undefined) {
                                    ms_verification_tag = '';
                                }
                                if (ms_uet_tag_id === undefined) {
                                    ms_uet_tag_id = '';
                                }
                                if (page_header_script === undefined) {
                                    page_header_script = '';
                                }
                                if (page_body_script === undefined) {
                                    page_body_script = '';
                                }
                                if (page_footer_script === undefined) {
                                    page_footer_script = '';
                                }
                                if (google_conversion_id === undefined) {
                                    google_conversion_id = '';
                                }
                                if (google_label_id === undefined) {
                                    google_label_id = '';
                                }


                                (function () {
                                    // alert(window.atob(ms_verification_tag))
                                    document.getElementsByClassName('custom-seo-input-title')[0].value = seotitle;
                                    document.getElementsByClassName('custom-seo-input-keyword')[0].value = seokeyword;
                                    document.getElementsByClassName('custom-seo-input-description')[0].value = seodescription;
                                    document.getElementsByClassName('custom-seo-input-slug')[0].value = seoslugg;
                                    document.getElementsByClassName('google-analyticsId')[0].value = googleAnalyticsId1;
                                    document.getElementsByClassName('google-verification')[0].value = googleVerificationTag;

                                    // document.getElementsByClassName('facebook_id')[0].value = facebook_id;
                                    // document.getElementsByClassName('twitter_id')[0].value = twitter_id;
                                    document.getElementsByClassName('ms_verification_tag ')[0].value = ms_verification_tag;
                                    document.getElementsByClassName('ms_uet_tag_id ')[0].value = ms_uet_tag_id;
                                    document.getElementsByClassName('page_header_script')[0].value = page_header_script;
                                    document.getElementsByClassName('page_body_script ')[0].value = page_body_script;
                                    document.getElementsByClassName('page_footer_script ')[0].value = page_footer_script;
                                    document.getElementsByClassName('google_conversion_id ')[0].value = google_conversion_id;
                                    document.getElementsByClassName('google_label_id ')[0].value = google_label_id;


                                })();


                                seoBtnTags = document.querySelector(".seo-tags-heading");
                                seoBtnTags.addEventListener('click', toggleSeoBlock);


                                googleBtnTags = document.querySelector(".google-tags-heading");
                                googleBtnTags.addEventListener('click', toogleGoogleBlock);

                                microsoftBtnTags = document.querySelector(".microsoft-tags-heading");
                                microsoftBtnTags.addEventListener('click', toogleMicroSoftBlock)



                                googleIdBtnTags = document.querySelector(".googleId-tags-heading");
                                googleIdBtnTags.addEventListener('click', toogleGoogleIdBlock)



                                generalBtnTags = document.querySelector(".general-tags-heading");
                                generalBtnTags.addEventListener('click', toogleGeneralBlock)


                                //Seo ScriptSetting start


                                var Save = document.querySelector('.savbtnnn');

                                var seoTitle = document.querySelector('.custom-seo-input-title');
                                var seoKeyword = document.querySelector('.custom-seo-input-keyword');
                                var seoDescription = document.querySelector('.custom-seo-input-description');
                                var seoSlug = document.querySelector('.custom-seo-input-slug');
                                var seoTitleValue = seoTitle.value;
                                var seoKeywordValue = seoKeyword.value;
                                var seoDescriptionValue = seoDescription.value;
                                var seoSlugValue = seoSlug.value;

                                if (seoDescriptionValue.length && seoTitleValue.length > 0) {
                                    Save.removeAttribute('disabled');
                                }

                                seoTitle.addEventListener('input', evt => {
                                    seoTitleValue = seoTitle.value
                                    if (seoSlugValue.length > 0) {
                                        Save.removeAttribute('disabled');
                                    }
                                    // if(seoDescriptionValue.length >0  && seoTitleValue.length > 0 &&  seoSlugValue.length > 0){
                                    //     Save.removeAttribute('disabled');
                                    // }else {
                                    //     Save.setAttribute("disabled", "disabled");
                                    // }
                                });
                                seoKeyword.addEventListener('input', evt => {
                                    seoKeywordValue = seoKeyword.value;
                                    if (seoSlugValue.length > 0) {
                                        Save.removeAttribute('disabled');
                                    }
                                })


                                seoDescription.addEventListener('input', evt => {
                                    seoDescriptionValue = seoDescription.value;
                                    if (seoSlugValue.length > 0) {
                                        Save.removeAttribute('disabled');
                                    }

                                    // if(seoDescriptionValue.length && seoTitleValue.length  && seoSlugValue.length > 0){
                                    //
                                    //     Save.removeAttribute('disabled');
                                    // }else {
                                    //     Save.setAttribute("disabled", "disabled");
                                    // }
                                })
                                seoSlug.addEventListener('change', evt => {
                                    let resullt = evt.target.value.replace(/\s+/g, '-').trim().toLowerCase()
                                    evt.target.value = resullt;
                                    // seoSlugValue=seoSlugValue.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, '-').trim().toLowerCase();
                                    // console.log(seoSlugValue);
                                    // seoSlugValue=seoSlug.value;
                                    seoSlugValue = resullt;

                                    if (seoSlugValue.length > 0) {

                                        Save.removeAttribute('disabled');
                                    } else {
                                        Save.setAttribute("disabled", "disabled");
                                    }
                                })


                                Save.addEventListener('click', async function (e) {
                                    if (isApiCallInProgress) {
                                        return; // Prevent multiple clicks while the API call is in progress.
                                    }

                                    isApiCallInProgress = true; // Set the flag to indicate an API call is in progress.

                                    let spinner = document.querySelector('.save-spinner');
                                    spinner.style.display = 'block';

                                    e.preventDefault();

                                    let formData = {
                                        page_id: editorpage,
                                        seo_title: seoTitleValue,
                                        seo_keyword: seoKeywordValue,
                                        seo_description: seoDescriptionValue,
                                        slug: seoSlugValue,
                                    };

                                    try {
                                        const {data} = await server.post(`page/update_seo_setting`,
                                            formData
                                        );

                                        console.log('API calling', data);
                                        setUpdateGrapeJs(!updateGrapeJs);

                                        if (data?.status) {
                                            toast(data?.message, 'success');
                                        }

                                        spinner.style.display = 'none';
                                    } catch (e) {
                                        spinner.style.display = 'none';
                                        console.log('cosakdljsald', e);

                                        if (e.response.data?.error === true) {
                                            if (e.response?.data?.errors.seo_title) {
                                                toast(e.response?.data?.errors.seo_title[0], 'error');
                                            } else if (e.response?.data?.errors.seo_description) {
                                                toast(e.response?.data?.errors.seo_description[0], 'error');
                                            } else if (e.response?.data?.errors.seo_keyword) {
                                                toast(e.response?.data?.errors.seo_keyword[0], 'error');
                                            } else if (e.response?.data?.errors.slug) {
                                                toast(e.response?.data?.errors.slug[0], 'error');
                                            }
                                            else
                                            {
                                                toast(e.response?.data?.errors_array[0], 'error');

                                            }
                                        }
                                    } finally {
                                        isApiCallInProgress = false; // Reset the flag to allow future API calls.
                                    }
                                });




                                //    SEO Script Setting end
                                //    Tracking Codes Setting start

                                var SavetrackingCode4 = document.querySelector('.tracking-code-save-btn');

                                // var SavetrackingCode = document.querySelector('.general-save-btn');

                                var googleAnalyticsId = document.querySelector('.google-analyticsId');
                                var googleAnalyticsIdValue = googleAnalyticsId.value;

                                var googleVerificationTagId = document.querySelector('.google-verification');
                                var googleVerificationTagValue = googleVerificationTagId.value;

                                // var facebookId = document.querySelector('.facebook_id');
                                // var facebookIdValue = facebookId.value;
                                // var twitterId = document.querySelector('.twitter_id');
                                // var twitterIdValue = twitterId.value;
                                var msVerificationTagId = document.querySelector('.ms_verification_tag');
                                var msVerificationTagIdValue = msVerificationTagId.value;
                                var msUetTagId = document.querySelector('.ms_uet_tag_id');
                                var msUetTagIdValue = msUetTagId.value;

                                var pageHeaderId = document.querySelector('.page_header_script');
                                var pageHeaderValue = pageHeaderId.value;

                                var pageBodyId = document.querySelector('.page_body_script');
                                var pageBodyValue = pageBodyId.value;

                                var pageFooterId = document.querySelector('.page_footer_script');
                                var pageFooterValue = pageFooterId.value;

                                var googleCoversationId = document.querySelector('.google_conversion_id');
                                var googleConversationValue = googleCoversationId.value;

                                var googleLabelId = document.querySelector('.google_label_id');
                                var googleLabelValue = googleLabelId.value;


                                googleAnalyticsId.addEventListener('input', function (e) {
                                    googleAnalyticsIdValue = googleAnalyticsId.value;
                                });
                                googleVerificationTagId.addEventListener('input', function (e) {
                                    googleVerificationTagValue = googleVerificationTagId.value;
                                });
                                // facebookId.addEventListener('input', function (e) {
                                //     facebookIdValue = this.value;
                                // });
                                // twitterId.addEventListener('input', function (e) {
                                //     twitterIdValue = this.value;
                                // });
                                msVerificationTagId.addEventListener('input', function (e) {
                                    msVerificationTagIdValue = this.value;
                                });
                                msUetTagId.addEventListener('input', function (e) {
                                    msUetTagIdValue = this.value;
                                });
                                pageHeaderId.addEventListener('input', function (e) {
                                    pageHeaderValue = this.value;
                                });
                                pageBodyId.addEventListener('input', function (e) {
                                    pageBodyValue = this.value;
                                });
                                pageFooterId.addEventListener('input', function (e) {
                                    pageFooterValue = this.value;
                                });
                                googleCoversationId.addEventListener('input', function (e) {
                                    googleConversationValue = this.value;
                                });

                                googleLabelId.addEventListener('input', function (e) {
                                    googleLabelValue = this.value;
                                });


                                SavetrackingCode4.addEventListener('click', async function (e) {

                                    let spinner = document.querySelector('.save-spinner-tracking-code');


                                    spinner.style.display = 'block';


                                    e.preventDefault();

                                    let formData = {
                                        page_id: editorpage,
                                        google_analytics_id: googleAnalyticsIdValue,
                                        // facebook_id: facebookIdValue,
                                        // twitter_id: twitterIdValue,
                                        google_verification_tag: window.btoa(encodeURIComponent(googleVerificationTagValue)),

                                        ms_verification_tag: window.btoa(encodeURIComponent(msVerificationTagIdValue)),
                                        ms_uet_tag_id: msUetTagIdValue,
                                        page_header_script: window.btoa(encodeURIComponent(pageHeaderValue)),
                                        page_body_script: window.btoa(encodeURIComponent(pageBodyValue)),
                                        page_footer_script: window.btoa(encodeURIComponent(pageFooterValue)),
                                        google_conversion_id: googleConversationValue,
                                        google_conversion_label: googleLabelValue


                                    }
                                    try {
                                        const {data} = await server.post(`page/update_script_setting`,
                                            formData
                                        );
                                        if (data?.status) {
                                            toast(data?.message, 'success')
                                        }
                                        //   console.log(data)
                                        // setProduct(data);
                                        // setLoading(false);
                                        // spinner.style.display='none';
                                        spinner.style.display = 'none';
                                    } catch (e) {
                                        spinner.style.display = 'none';
                                        // spinner.style.display='none';
                                        // if(e.response.data?.status===false){
                                        //     toast("Please fill all feilds",'error')
                                        // }
                                        //console.log(e.response);
                                        if (e?.response?.data?.error)
                                            toast(e?.response?.data?.errors_array, 'error');
                                    }
                                })


                                //    Tracking Codes Setting end


                                //microsoft_scripts

                                var SavetrackingCode3 = document.querySelector('.microsoft-save-btn');


                                var googleAnalyticsId = document.querySelector('.google-analyticsId');
                                var googleAnalyticsIdValue = googleAnalyticsId.value;

                                var googleVerificationTagId = document.querySelector('.google-verification');
                                var googleVerificationTagValue = googleVerificationTagId.value;


                                //  var facebookId = document.querySelector('.facebook_id');
                                //  var facebookIdValue = facebookId.value;
                                //  var twitterId = document.querySelector('.twitter_id');
                                //  var twitterIdValue = twitterId.value;
                                var msVerificationTagId = document.querySelector('.ms_verification_tag');
                                var msVerificationTagIdValue = msVerificationTagId.value;
                                var msUetTagId = document.querySelector('.ms_uet_tag_id');
                                var msUetTagIdValue = msUetTagId.value;

                                var pageHeaderId = document.querySelector('.page_header_script');
                                var pageHeaderValue = pageHeaderId.value;

                                var pageBodyId = document.querySelector('.page_body_script');
                                var pageBodyValue = pageBodyId.value;

                                var pageFooterId = document.querySelector('.page_footer_script');
                                var pageFooterValue = pageFooterId.value;

                                var googleCoversationId = document.querySelector('.google_conversion_id');
                                var googleConversationValue = googleCoversationId.value;

                                var googleLabelId = document.querySelector('.google_label_id');
                                var googleLabelValue = googleLabelId.value;


                                googleAnalyticsId.addEventListener('input', function (e) {
                                    googleAnalyticsIdValue = googleAnalyticsId.value;
                                });
                                googleVerificationTagId.addEventListener('input', function (e) {
                                    googleVerificationTagValue = googleVerificationTagId.value;
                                });

                                //  facebookId.addEventListener('input', function (e) {
                                //      facebookIdValue = this.value;
                                //  });
                                //  twitterId.addEventListener('input', function (e) {
                                //      twitterIdValue = this.value;
                                //  });
                                msVerificationTagId.addEventListener('input', function (e) {
                                    msVerificationTagIdValue = this.value;
                                });
                                msUetTagId.addEventListener('input', function (e) {
                                    msUetTagIdValue = this.value;
                                });
                                pageHeaderId.addEventListener('input', function (e) {
                                    pageHeaderValue = this.value;
                                });
                                pageBodyId.addEventListener('input', function (e) {
                                    pageBodyValue = this.value;
                                });
                                pageFooterId.addEventListener('input', function (e) {
                                    pageFooterValue = this.value;
                                });
                                googleCoversationId.addEventListener('input', function (e) {
                                    googleConversationValue = this.value;
                                });
                                googleLabelId.addEventListener('input', function (e) {
                                    googleLabelValue = this.value;
                                });


                                SavetrackingCode3.addEventListener('click', async function (e) {

                                    let spinner = document.querySelector('.save-spinner-microsoft');


                                    spinner.style.display = 'block';


                                    e.preventDefault();

                                    let formData = {
                                        page_id: editorpage,
                                        google_analytics_id: googleAnalyticsIdValue,
                                        //  facebook_id: facebookIdValue,
                                        //  twitter_id: twitterIdValue,
                                        google_verification_tag: window.btoa(encodeURIComponent(googleVerificationTagValue)),

                                        ms_verification_tag: window.btoa(encodeURIComponent(msVerificationTagIdValue)),
                                        ms_uet_tag_id: msUetTagIdValue,
                                        page_header_script: window.btoa(encodeURIComponent(pageHeaderValue)),
                                        page_body_script: window.btoa(encodeURIComponent(pageBodyValue)),
                                        page_footer_script: window.btoa(encodeURIComponent(pageFooterValue)),
                                        google_conversion_id: googleConversationValue,
                                        google_conversion_label: googleLabelValue


                                    }
                                    try {
                                        const {data} = await server.post(`page/update_script_setting`,
                                            formData
                                        );
                                        if (data?.status) {
                                            toast(data?.message, 'success')
                                        }
                                        //   console.log(data)
                                        // setProduct(data);
                                        // setLoading(false);
                                        // spinner.style.display='none';
                                        spinner.style.display = 'none';
                                    } catch (e) {
                                        spinner.style.display = 'none';
                                        // spinner.style.display='none';
                                        // if(e.response.data?.status===false){
                                        //     toast("Please fill all feilds",'error')
                                        // }
                                        //console.log(e.response);
                                        if (e?.response?.data?.error)
                                            toast(e?.response?.data?.errors_array, 'error');
                                    }
                                })


                                //    Microsoft Script end


                                //general_scripts

                                var SavetrackingCode2 = document.querySelector('.general-save-btn');

                                var googleAnalyticsId = document.querySelector('.google-analyticsId');
                                var googleAnalyticsIdValue = googleAnalyticsId.value;

                                var googleVerificationTagId = document.querySelector('.google-verification');
                                var googleVerificationTagValue = googleVerificationTagId.value;

                                //  var facebookId = document.querySelector('.facebook_id');
                                //  var facebookIdValue = facebookId.value;
                                //  var twitterId = document.querySelector('.twitter_id');
                                //  var twitterIdValue = twitterId.value;
                                var msVerificationTagId = document.querySelector('.ms_verification_tag');
                                var msVerificationTagIdValue = msVerificationTagId.value;
                                var msUetTagId = document.querySelector('.ms_uet_tag_id');
                                var msUetTagIdValue = msUetTagId.value;

                                var pageHeaderId = document.querySelector('.page_header_script');
                                var pageHeaderValue = pageHeaderId.value;

                                var pageBodyId = document.querySelector('.page_body_script');
                                var pageBodyValue = pageBodyId.value;

                                var pageFooterId = document.querySelector('.page_footer_script');
                                var pageFooterValue = pageFooterId.value;
                                var googleCoversationId = document.querySelector('.google_conversion_id');
                                var googleConversationValue = googleCoversationId.value;

                                var googleLabelId = document.querySelector('.google_label_id');
                                var googleLabelValue = googleLabelId.value;


                                googleAnalyticsId.addEventListener('input', function (e) {
                                    googleAnalyticsIdValue = googleAnalyticsId.value;
                                });
                                googleVerificationTagId.addEventListener('input', function (e) {
                                    googleVerificationTagValue = googleVerificationTagId.value;
                                });
                                //  facebookId.addEventListener('input', function (e) {
                                //      facebookIdValue = this.value;
                                //  });
                                //  twitterId.addEventListener('input', function (e) {
                                //      twitterIdValue = this.value;
                                //  });
                                msVerificationTagId.addEventListener('input', function (e) {
                                    msVerificationTagIdValue = this.value;
                                });
                                msUetTagId.addEventListener('input', function (e) {
                                    msUetTagIdValue = this.value;
                                });
                                pageHeaderId.addEventListener('input', function (e) {
                                    pageHeaderValue = this.value;
                                });
                                pageBodyId.addEventListener('input', function (e) {
                                    pageBodyValue = this.value;
                                });
                                pageFooterId.addEventListener('input', function (e) {
                                    pageFooterValue = this.value;
                                });
                                googleCoversationId.addEventListener('input', function (e) {
                                    googleConversationValue = this.value;
                                });

                                googleLabelId.addEventListener('input', function (e) {
                                    googleLabelValue = this.value;
                                });


                                SavetrackingCode2.addEventListener('click', async function (e) {

                                    let spinner = document.querySelector('.save-spinner-general');


                                    spinner.style.display = 'block';


                                    e.preventDefault();

                                    let formData = {
                                        page_id: editorpage,
                                        google_analytics_id: googleAnalyticsIdValue,
                                        //  facebook_id: facebookIdValue,
                                        //  twitter_id: twitterIdValue,
                                        google_verification_tag: window.btoa(encodeURIComponent(googleVerificationTagValue)),

                                        ms_verification_tag: window.btoa(encodeURIComponent(msVerificationTagIdValue)),
                                        ms_uet_tag_id: msUetTagIdValue,
                                        page_header_script: window.btoa(encodeURIComponent(pageHeaderValue)),
                                        page_body_script: window.btoa(encodeURIComponent(pageBodyValue)),
                                        page_footer_script: window.btoa(encodeURIComponent(pageFooterValue)),
                                        google_conversion_id: googleConversationValue,
                                        google_conversion_label: googleLabelValue


                                    }
                                    try {
                                        const {data} = await server.post(`page/update_script_setting`,
                                            formData
                                        );
                                        if (data?.status) {
                                            toast(data?.message, 'success')
                                        }
                                        //   console.log(data)
                                        // setProduct(data);
                                        // setLoading(false);
                                        // spinner.style.display='none';
                                        spinner.style.display = 'none';
                                    } catch (e) {
                                        spinner.style.display = 'none';
                                        // spinner.style.display='none';
                                        // if(e.response.data?.status===false){
                                        //     toast("Please fill all feilds",'error')
                                        // }
                                        //console.log(e.response);
                                        if (e?.response?.data?.error)
                                            toast(e?.response?.data?.errors_array, 'error');
                                    }
                                })


                                //    General Script end


                                //google script start

                                var SavetrackingCode5 = document.querySelector('.google-save-btn');

                                var googleAnalyticsId = document.querySelector('.google-analyticsId');
                                var googleAnalyticsIdValue = googleAnalyticsId.value;
                                var googleVerificationTagId = document.querySelector('.google-verification');
                                var googleVerificationTagValue = googleVerificationTagId.value;

                                //  var facebookId = document.querySelector('.facebook_id');
                                //  var facebookIdValue = facebookId.value;
                                //  var twitterId = document.querySelector('.twitter_id');
                                //  var twitterIdValue = twitterId.value;
                                var msVerificationTagId = document.querySelector('.ms_verification_tag');
                                var msVerificationTagIdValue = msVerificationTagId.value;
                                var msUetTagId = document.querySelector('.ms_uet_tag_id');
                                var msUetTagIdValue = msUetTagId.value;

                                var pageHeaderId = document.querySelector('.page_header_script');
                                var pageHeaderValue = pageHeaderId.value;

                                var pageBodyId = document.querySelector('.page_body_script');
                                var pageBodyValue = pageBodyId.value;

                                var pageFooterId = document.querySelector('.page_footer_script');
                                var pageFooterValue = pageFooterId.value;

                                var googleCoversationId = document.querySelector('.google_conversion_id');
                                var googleConversationValue = googleCoversationId.value;

                                var googleLabelId = document.querySelector('.google_label_id');
                                var googleLabelValue = googleLabelId.value;


                                googleAnalyticsId.addEventListener('input', function (e) {
                                    googleAnalyticsIdValue = googleAnalyticsId.value;
                                });
                                googleVerificationTagId.addEventListener('input', function (e) {
                                    googleVerificationTagValue = googleVerificationTagId.value;
                                });
                                //  facebookId.addEventListener('input', function (e) {
                                //      facebookIdValue = this.value;
                                //  });
                                //  twitterId.addEventListener('input', function (e) {
                                //      twitterIdValue = this.value;
                                //  });
                                msVerificationTagId.addEventListener('input', function (e) {
                                    msVerificationTagIdValue = this.value;
                                });
                                msUetTagId.addEventListener('input', function (e) {
                                    msUetTagIdValue = this.value;
                                });
                                pageHeaderId.addEventListener('input', function (e) {
                                    pageHeaderValue = this.value;
                                });
                                pageBodyId.addEventListener('input', function (e) {
                                    pageBodyValue = this.value;
                                });
                                pageFooterId.addEventListener('input', function (e) {
                                    pageFooterValue = this.value;
                                });
                                googleCoversationId.addEventListener('input', function (e) {
                                    googleConversationValue = this.value;
                                });
                                googleLabelId.addEventListener('input', function (e) {
                                    googleLabelValue = this.value;
                                });


                                SavetrackingCode5.addEventListener('click', async function (e) {

                                    let spinner = document.querySelector('.save-spinner-googleId');


                                    spinner.style.display = 'block';


                                    e.preventDefault();

                                    let formData = {
                                        page_id: editorpage,
                                        google_analytics_id: googleAnalyticsIdValue,
                                        //  facebook_id: facebookIdValue,
                                        //  twitter_id: twitterIdValue,
                                        google_verification_tag: window.btoa(encodeURIComponent(googleVerificationTagValue)),

                                        ms_verification_tag: window.btoa(encodeURIComponent(msVerificationTagIdValue)),
                                        ms_uet_tag_id: msUetTagIdValue,
                                        page_header_script: window.btoa(encodeURIComponent(pageHeaderValue)),
                                        page_body_script: window.btoa(encodeURIComponent(pageBodyValue)),
                                        page_footer_script: window.btoa(encodeURIComponent(pageFooterValue)),
                                        google_conversion_id: googleConversationValue,
                                        google_conversion_label: googleLabelValue


                                    }
                                    try {
                                        const {data} = await server.post(`page/update_script_setting`,
                                            formData
                                        );
                                        if (data?.status) {
                                            toast(data?.message, 'success')
                                        }
                                        //   console.log(data)
                                        // setProduct(data);
                                        // setLoading(false);
                                        // spinner.style.display='none';
                                        spinner.style.display = 'none';
                                    } catch (e) {
                                        spinner.style.display = 'none';
                                        // spinner.style.display='none';
                                        // if(e.response.data?.status===false){
                                        //     toast("Please fill all feilds",'error')
                                        // }
                                        //console.log(e.response);
                                        if (e?.response?.data?.error)
                                            toast(e?.response?.data?.errors_array, 'error');
                                    }
                                })


                                //    Google script end


                            },
                            stop: function (editor) {


                                if (editPanel != null) {
                                    editPanel.style.display = 'none'
                                }
                                if (seoBtnTags) {
                                    seoBtnTags.removeEventListener('click', toggleSeoBlock);
                                }

                                if (googleBtnTags) {
                                    googleBtnTags.removeEventListener('click', toogleGoogleBlock);
                                }

                                if (googleIdBtnTags) {
                                    googleIdBtnTags.removeEventListener('click', toogleGoogleIdBlock);
                                }
                                if (microsoftBtnTags) {
                                    microsoftBtnTags.removeEventListener('click', toogleMicroSoftBlock);
                                }
                                if (generalBtnTags) {
                                    generalBtnTags.removeEventListener('click', toogleGeneralBlock);
                                }
                            }
                        }
                        ,
                        attributes: {title: 'Add Seo Settings'},

                        togglable: 0,


                    },]);


            function toggleSeoBlock(e) {
                const seoBlock = editPanel.querySelector(".seo-block");
                const CarrotIcon = seoBtnTags.querySelector("i");

                if (CarrotIcon.classList.contains('fa-caret-right')) {
                    CarrotIcon.classList.remove('fa-caret-right');
                    CarrotIcon.classList.add('fa-caret-down');
                    seoBlock.classList.remove('d-none');
                } else {
                    CarrotIcon.classList.remove('fa-caret-down');
                    CarrotIcon.classList.add('fa-caret-right');
                    seoBlock.classList.add('d-none');
                }
            }


            function toogleGoogleBlock(e) {
                const googleBlock = editPanel.querySelector(".google-block");
                const CarrotIcon = googleBtnTags.querySelector("i");

                if (CarrotIcon.classList.contains('fa-caret-right')) {
                    CarrotIcon.classList.remove('fa-caret-right');
                    CarrotIcon.classList.add('fa-caret-down');
                    googleBlock.classList.remove('d-none');
                } else {
                    CarrotIcon.classList.remove('fa-caret-down');
                    CarrotIcon.classList.add('fa-caret-right');
                    googleBlock.classList.add('d-none');
                }
            }


            function toogleMicroSoftBlock(e) {
                const microsoftBlock = editPanel.querySelector(".microsoft-block");
                const CarrotIcon = microsoftBtnTags.querySelector("i");

                if (CarrotIcon.classList.contains('fa-caret-right')) {
                    CarrotIcon.classList.remove('fa-caret-right');
                    CarrotIcon.classList.add('fa-caret-down');
                    microsoftBlock.classList.remove('d-none');
                } else {
                    CarrotIcon.classList.remove('fa-caret-down');
                    CarrotIcon.classList.add('fa-caret-right');
                    microsoftBlock.classList.add('d-none');
                }
            }


            function toogleGoogleIdBlock(e) {
                const googleIdBlock = editPanel.querySelector(".googleId-block");
                const CarrotIcon = googleIdBtnTags.querySelector("i");

                if (CarrotIcon.classList.contains('fa-caret-right')) {
                    CarrotIcon.classList.remove('fa-caret-right');
                    CarrotIcon.classList.add('fa-caret-down');
                    googleIdBlock.classList.remove('d-none');
                } else {
                    CarrotIcon.classList.remove('fa-caret-down');
                    CarrotIcon.classList.add('fa-caret-right');
                    googleIdBlock.classList.add('d-none');
                }
            }

            function toogleGeneralBlock(e) {
                const generalBlock = editPanel.querySelector(".general-block");
                const CarrotIcon = generalBtnTags.querySelector("i");

                if (CarrotIcon.classList.contains('fa-caret-right')) {
                    CarrotIcon.classList.remove('fa-caret-right');
                    CarrotIcon.classList.add('fa-caret-down');
                    generalBlock.classList.remove('d-none');
                } else {
                    CarrotIcon.classList.remove('fa-caret-down');
                    CarrotIcon.classList.add('fa-caret-right');
                    generalBlock.classList.add('d-none');
                }
            }



            //---------------------------------------------------------------------------------------
            const pn03 = editor.Panels;
            let editPanel03 = null
            //  pn03.addButton('views',
            //      [
            //          {
            //              id: 'third-party-mail',
            //              className: 'fa  fa-plug',
            //              command: {
            //                  label: 'Custom Block',
            //                  category: 'Custom Category',
            //                  attributes: {
            //                      class: 'gjs-fonts gjs-f-b1',
            //                  },
            //                  run: function (editor) {
            //                      if (editPanel03 == null) {
            //                          const editMenuDiv03 = document.createElement('div')
            //                          const btn03 = editMenuDiv03.getElementsByClassName('seo-tpp-tags-heading');

            //                          editMenuDiv03.innerHTML = `
            //              <div class="gjs-block-category ">
            //                <div class="gjs-title tpp-tags-heading" >
            //                  <i class="gjs-caret-icon fa fa-caret-down"></i>
            //                 Autoresponder Integration
            //                </div>
            //                <div class="gjs-blocks-c tpp-block">
            //                      <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
            //                        <div class="gjs-sm-label gjs-four-color" data-sm-label="">
            //                            <span class="gjs-sm-icon " title="">
            //                              Select Provider
            //                            </span>
            //                        </div>
            //                        <div class="gjs-fields" data-sm-fields="">
            //                         <select class="custom-select-gjs">
            //                             <option>1</option>
            //                             <option>2</option>
            //                             <option>3</option>
            //                          </select>
            //                      </div>
            //                       <p class="custom-seo-label m-0">The service provider you selected hasn’t been connected to InstaBuilder. Click the “Connect” button below to integrate.</p>
            //                    </div>
            //                      <div class="gjs-sm-property gjs-sm-stack gjs-sm-property__transition gjs-sm-property--full">
            //                       <button type="button" class="btn btn-primary savbtnnn d-flex fs-12 mb-3 shadow-none"  disabled>Save <div role="status" class="spinner-border save-spinner"><span class="visually-hidden">Loading...</span></div></button>
            //                    </div>
            //                </div>
            //              </div>
            //          `;
            //                          const panels = pn03.getPanel('views-container')
            //                          panels.set('appendContent', editMenuDiv03).trigger('change:appendContent')
            //                          editPanel03 = editMenuDiv03
            //                      }

            //                      editPanel03.style.display = 'block';


            //                  },


            //              },
            //              attributes: {title: 'Add third party integration Settings'},
            //              togglable: 0,


            //          },]);
            //---------------------------------------------------------------------------------------


            const desiredModels = editor.StyleManager.getSectors().models.filter((value, idx, self) => {
                return idx === self.findIndex((t) => (
                    t.id === value.id && t.name === value.name
                ))
            });

            editor.StyleManager.getSectors().models = desiredModels;

            // const desiredModels = editor.StyleManager.getSectors().models.filter((value, idx, self) => {
            //     return idx === self.findIndex((t) => (
            //         t.id === value.id && t.name === value.name
            //     ))
            // });
            //
            // editor.StyleManager.getSectors().models = desiredModels;
            //


        }


        setDraft("")
    }, [editorpage, updateUi, updateGrapeJs, isLoading])


    console.log(draft)

    const showToast = () => {
        toast.success(
            <div>

                <span>Publishing Successful. <a style={{color: 'blue', textDecoration: 'underline'}}
                                                href={`${publishedUrl}?is_published=true`} target="_blank">View Page</a></span>


            </div>,
            {
                position: toast.POSITION.TOP_RIGHT,
                closeButton: true, // Show close button
                autoClose: false, // Set auto-close timeout to 5 seconds (5000 milliseconds)
            }
        );


        setTimeout(() => {
            // setToastShown(false);
            localStorage.setItem('isPublished', 'false');
        }, 5000); // 5 seconds
    };

    useEffect(() => {
        if (isPublished) {
            showToast(); // Show toast if isPublished is true and the toast hasn't been shown yet
        }
    }, [isPublished]);



    useEffect(() => {
        // Find the "undo" button element by its class
        const undoButton = document.querySelector('.gjs-pn-btn.fa.fa-undo');
        const redoButton = document.querySelector('.gjs-pn-btn.fa.fa-repeat');
        const downloadButton = document.querySelector('.gjs-pn-btn.fa.fa-download');
        const trashButton = document.querySelector('.gjs-pn-btn.fa.fa-trash');
        const desktopButton = document.querySelector('.gjs-pn-btn.fa.fa-desktop');
        const viewComponentButton = document.querySelector('.gjs-pn-btn.fa.fa-square-o');
        const viewCodeButton = document.querySelector('.gjs-pn-btn.fa.fa-code');
        const openWidgetButton = document.querySelector('.gjs-pn-btn.fa.fa-paint-brush');
        const backButton = document.querySelector('.gjs-pn-btn.fa.fa-arrow-left');

        // Check if the button element exists
        if (undoButton) {
            // Add the title attribute to the button element
            undoButton.setAttribute('title', 'Undo');
        }
        if (redoButton) {
            // Add the title attribute to the button element
            redoButton.setAttribute('title', 'Redo');
        }
        if (downloadButton) {
            // Add the title attribute to the button element
            downloadButton.setAttribute('title', 'Import');
        }
        if (trashButton) {
            // Add the title attribute to the button element
            trashButton.setAttribute('title', 'Delete');
        }
        if (desktopButton) {
            // Add the title attribute to the button element
            desktopButton.setAttribute('title', 'Desktop View');
        }
        if (viewComponentButton) {
            // Add the title attribute to the button element
            viewComponentButton.setAttribute('title', 'View widgets');
        }
        if (viewCodeButton) {
            // Add the title attribute to the button element
            viewCodeButton.setAttribute('title', 'View HTML Code');
        }
        if (openWidgetButton) {
            // Add the title attribute to the button element
            openWidgetButton.setAttribute('title', 'Open Widgets');
        }
        if (backButton) {
            // Add the title attribute to the button element
            backButton.setAttribute('title', 'Back Arrow');
        }
    }, []);

    useEffect(() => {
        const updateConversionId = () => {
            // Get the input element
            var inputElement = document.querySelector('.custom-seo-input.google_conversion_id');

            // Get the span element
            var spanElement = document.querySelector('.gjs-sm-icon');

            // Check if the elements are found
            if (inputElement && spanElement) {
                // Get the updated value of the input element
                var conversionId = inputElement.value;
                console.warn('inputtttttttttt',conversionId)

                // Check if there is a value in the input
                if (conversionId.trim() !== '') {
                    // Change the text content of the span element to the conversion ID
                    spanElement.textContent = conversionId;
                } else {
                    console.warn('wroks')
                    // If the input is empty, set it back to the default text
                    spanElement.textContent = 'Google Conversion ';
                }
            }
        };

        // Initial update
        updateConversionId();

        // Add an event listener to the input for changes
        document.addEventListener('input', updateConversionId);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('input', updateConversionId);
        };
    }, []); // Empty dependency array means this effect runs once, similar to componentDidMount


    const Publish = async () => {

        let vr = html?.html?.length > 56
        if (!vr) {
            toast('Please add text to Publish Landing Page, Page cannot be Empty', 'error')
            //   alert('please fill')
        } else {
            setLoading(true)
            // const html = {
            //     html: editor.getHtml(),
            //     css: editor.getCss()
            // }
            const obj = {
                page_id: editorpage, html_body: JSON.stringify(html),
                domain_id: domainId,
                status: 1
            }
            try {
                const {data} = await server.post(`${updatePage}`, obj
                );
                setPublishOpen(!publishOpen)
                setLoading(false)
                if (data?.status) {
                    setDomainId()
                    console.log('data publishh', data.data);

                    setUpdateUi(!updateUi)
                    let Url = data.data?.published_url
                    //   setFrontUrl(Url)
                    localStorage.setItem('publishedUrl', Url);

                    // window.location.href = `${fronUrl}?is_published=true`;

                    // window.open(`${fronUrl}?is_published=true`, "_blank")
                    window.location.reload()


                    // localStorage.setItem('isPublished', 'true');
                    localStorage.setItem('isPublished', 'true');

                    // setLoading(false)
                    // isLoading(true)
                    // router.push(`/pages/editor/${data?.data?.page_id}`)
                }
                console.log(data)
                // setProduct(data);
                // setLoading(false);
            } catch (e) {

                setLoading(false)
                if (e.response?.data?.status === false) {
                    if (e.response?.data.errors_array?.[0]) {
                        toast(e.response?.data.errors_array?.[0], 'error')
                    } else {
                        toast(e.response?.data?.message, 'error')

                    }
                    //  setError(e.response?.data.errors?.title[0])

                } else {


                    setPublishOpen(!publishOpen)

                    toast('Publishing failed. Please try again.', 'error')
                }


            }
        }
    }




    useEffect(() => {
        // Find the "undo" button element by its class
        const undoButton = document.querySelector('.gjs-pn-btn.fa.fa-undo');
        const redoButton = document.querySelector('.gjs-pn-btn.fa.fa-repeat');
        const downloadButton = document.querySelector('.gjs-pn-btn.fa.fa-download');
        const trashButton = document.querySelector('.gjs-pn-btn.fa.fa-trash');
        const desktopButton = document.querySelector('.gjs-pn-btn.fa.fa-desktop');
        const viewComponentButton = document.querySelector('.gjs-pn-btn.fa.fa-square-o');
        const viewCodeButton = document.querySelector('.gjs-pn-btn.fa.fa-code');
        const openWidgetButton = document.querySelector('.gjs-pn-btn.fa.fa-paint-brush');
        const backButton = document.querySelector('.gjs-pn-btn.fa.fa-arrow-left');

        // Check if the button element exists
        if (undoButton) {
            // Add the title attribute to the button element
            undoButton.setAttribute('title', 'Undo');
        }
        if (redoButton) {
            // Add the title attribute to the button element
            redoButton.setAttribute('title', 'Redo');
        }
        if (downloadButton) {
            // Add the title attribute to the button element
            downloadButton.setAttribute('title', 'Import HTML code');
        }
        if (trashButton) {
            // Add the title attribute to the button element
            trashButton.setAttribute('title', 'Delete');
        }
        if (desktopButton) {
            // Add the title attribute to the button element
            desktopButton.setAttribute('title', 'Desktop View');
        }
        if (viewComponentButton) {
            // Add the title attribute to the button element
            viewComponentButton.setAttribute('title', 'View widgets');
        }
        if (viewCodeButton) {
            // Add the title attribute to the button element
            viewCodeButton.setAttribute('title', 'View HTML Code');
        }
        if (openWidgetButton) {
            // Add the title attribute to the button element
            openWidgetButton.setAttribute('title', 'Open Widgets');
        }
        if (backButton) {
            // Add the title attribute to the button element
            backButton.setAttribute('title', 'Back Arrow');
        }
    }, []);


    return (
        <>
            {/* <ToastContainer /> */}
            {/* <LoadingOverlay
          style={{ width: 200, height: 200, backgroundColor: 'papayawhip' }}
  active={loading}

  text='Loading your content...'
  > */}


            {(publishOpen && !isDisabled) && (

                <div className={'publishDropDown'}>

                    <div className="d-flex p-5">

                        <div className={`publish_dropdown`}>
                            <Dropdown isOpen={publishOpen} toggle={toggle} direction={direction}>
                                {/* <DropdownToggle caret>  */}
                                {/* <IoRocketSharp size={22}/>  <span className="px-2 fw-semibold">Publish</span>   */}
                                {/* </DropdownToggle> */}


                                <DropdownMenu {...args} dark>
                                    <DropdownItem header>SELECT YOUR DESTINATION</DropdownItem>
                                    <div className={'domain-list-drop '}>

                                        {!pageDetail?.is_domain && (
                                            <FormGroup check className={'radio-check-custom opacity-dim'}>
                                                <Input
                                                    type="radio"
                                                    checked
                                                />
                                                <Label>

                                                    {pageDetail?.public_url}

                                                </Label>
                                            </FormGroup>
                                        )}
                                        {/* <DropdownItem> */}

                                        {pageDetail?.domains?.length > 0 && pageDetail?.domains?.map((x) => {

                                            return (
                                                <>

                                                    <FormGroup check className={'radio-check-custom'}>

                                                        {pageDetail?.is_domain && (
                                                            <Input
                                                                disabled={pageDetail?.is_domain}
                                                                checked={pageDetail?.is_domain}
                                                                name="radio1"
                                                                type="radio"
                                                                value={x?.id}
                                                                onChange={(e) => setDomainId(e.target.value)}
                                                            />
                                                        )}


                                                        {!pageDetail?.is_domain && (

                                                            <Input
                                                                disabled={pageDetail?.is_domain}
                                                                name="radio1"
                                                                type="radio"
                                                                value={x?.id}
                                                                onChange={(e) => setDomainId(e.target.value)}
                                                            />

                                                        )}
                                                        {' '}
                                                        <Label check>
                                                            {x?.domain_url}
                                                        </Label>
                                                    </FormGroup>

                                                </>
                                            )
                                        })}
                                    </div>

                                    {pageDetail?.domains?.length == 0 && (
                                        <FormGroup check className={'radio-check-custom'}>

                                            {/* <Input type="checkbox"/> */}
                                            <Label>
                                                Custom Domain
                                            </Label>
                                            <small> <a onClick={() => {
                                                navigate(`/pages/domain`)

                                                // let fronUrl = `${public_url}/${data.data.url}`;
                                                // window.open("/pages/domain", "_blank")
                                            }}> Click here</a> to add custom domain </small>

                                        </FormGroup>


                                    )}


                                    <div className={'footer-action'}>
                                        <div

                                            className="d-flex justify-content-between">
                                            <a
                                                // disabled={isDisabled}

                                                onClick={Publish}
                                                className={`primary-btn-modal`}>  {draftLoading ? 'Loading' : `Publish on selected domain`} </a>

                                            <a className={`btn-grey-outline`}
                                               onClick={() => {
                                                   setPublishOpen(!publishOpen)
                                               }}
                                            >Cancel</a>

                                        </div>
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>


                    {/* <div id="myDropdown" class="dropdown-content"  >
                                       <a href="#home">Home</a>
                                       <a href="#about">About</a>
                                       <a href="#contact">Contact</a>
                                     </div>`; */}
                </div>
            )}


            {loading && (

                <div className={'loaderPageEditor'}>
                    <Loader/>
                </div>
            )}


            {}

            {/* </LoadingOverlay> */}
            <div id="gjs"></div>
        </>
    );
}

export default Editor;